// This file is auto-generated by @hey-api/openapi-ts

import { type Client, type ClientMeta, formDataBodySerializer, type Options as Options2, type RequestResult, type TDataShape } from './client';
import { client } from './client.gen';
import type { AuthzRoleListRolesData, AuthzRoleListRolesErrors, AuthzRoleListRolesResponses, ConfigGetData, ConfigGetErrors, ConfigGetResponses, KnowledgeBaseGetArticleData, KnowledgeBaseGetArticleErrors, KnowledgeBaseGetArticleResponses, KnowledgeBaseListArticlesData, KnowledgeBaseListArticlesErrors, KnowledgeBaseListArticlesResponses, KnowledgeBaseTopicsListListTopicsData, KnowledgeBaseTopicsListListTopicsErrors, KnowledgeBaseTopicsListListTopicsResponses, OrgAccountDeleteData, OrgAccountDeleteErrors, OrgAccountDeleteResponses, OrgAccountImageGetImageData, OrgAccountImageGetImageErrors, OrgAccountImageGetImageResponses, OrgAccountImageUpdateImageData, OrgAccountImageUpdateImageErrors, OrgAccountImageUpdateImageResponses, OrgAccountUpdateData, OrgAccountUpdateErrors, OrgAccountUpdateResponses, OrgAccountUserListUsersData, OrgAccountUserListUsersErrors, OrgAccountUserListUsersResponses, OrgAlertBulkDeleteOrgAlertsData, OrgAlertBulkDeleteOrgAlertsErrors, OrgAlertBulkDeleteOrgAlertsResponses, OrgAlertDeleteOrgAlertData, OrgAlertDeleteOrgAlertErrors, OrgAlertDeleteOrgAlertResponses, OrgAlertGetOrgAlertData, OrgAlertGetOrgAlertErrors, OrgAlertGetOrgAlertResponses, OrgAlertListOrgAlertsData, OrgAlertListOrgAlertsErrors, OrgAlertListOrgAlertsResponses, OrgAlertStatsGetOrgAlertStatsData, OrgAlertStatsGetOrgAlertStatsErrors, OrgAlertStatsGetOrgAlertStatsResponses, OrgAlertUpdateOrgAlertData, OrgAlertUpdateOrgAlertErrors, OrgAlertUpdateOrgAlertResponses, OrgBillingAccountBalanceGetBalanceData, OrgBillingAccountBalanceGetBalanceErrors, OrgBillingAccountBalanceGetBalanceResponses, OrgBillingAccountBillingAccountListData, OrgBillingAccountBillingAccountListErrors, OrgBillingAccountBillingAccountListResponses, OrgBillingAccountGetData, OrgBillingAccountGetErrors, OrgBillingAccountGetResponses, OrgBillingAccountServiceAccountServiceAccountListData, OrgBillingAccountServiceAccountServiceAccountListErrors, OrgBillingAccountServiceAccountServiceAccountListResponses, OrgCommodityCreateOrgCommodityData, OrgCommodityCreateOrgCommodityErrors, OrgCommodityCreateOrgCommodityResponses, OrgCommodityDeleteOrgCommodityData, OrgCommodityDeleteOrgCommodityErrors, OrgCommodityDeleteOrgCommodityResponses, OrgCommodityListOrgCommoditiesData, OrgCommodityListOrgCommoditiesErrors, OrgCommodityListOrgCommoditiesResponses, OrgCommodityReferenceListReferenceCommoditiesData, OrgCommodityReferenceListReferenceCommoditiesErrors, OrgCommodityReferenceListReferenceCommoditiesResponses, OrgCommodityUpdateOrgCommodityData, OrgCommodityUpdateOrgCommodityErrors, OrgCommodityUpdateOrgCommodityResponses, OrgComplianceDeterminationsDecisionDecideTrackingDeterminationData, OrgComplianceDeterminationsDecisionDecideTrackingDeterminationErrors, OrgComplianceDeterminationsDecisionDecideTrackingDeterminationResponses, OrgCompliancePropertyAgencyStatusGetPropertyAgencyStatusData, OrgCompliancePropertyAgencyStatusGetPropertyAgencyStatusErrors, OrgCompliancePropertyAgencyStatusGetPropertyAgencyStatusResponses, OrgComplianceRequirementsSatisfiedMarkRequirementSatisfiedForPropertiesData, OrgComplianceRequirementsSatisfiedMarkRequirementSatisfiedForPropertiesErrors, OrgComplianceRequirementsSatisfiedMarkRequirementSatisfiedForPropertiesResponses, OrgComplianceTasksCompleteCompleteTaskData, OrgComplianceTasksCompleteCompleteTaskErrors, OrgComplianceTasksCompleteCompleteTaskResponses, OrgComplianceTasksCreateNewTaskData, OrgComplianceTasksCreateNewTaskErrors, OrgComplianceTasksCreateNewTaskResponses, OrgComplianceTasksDeleteTaskData, OrgComplianceTasksDeleteTaskErrors, OrgComplianceTasksDeleteTaskResponses, OrgComplianceTasksGetTaskDetailsData, OrgComplianceTasksGetTaskDetailsErrors, OrgComplianceTasksGetTaskDetailsResponses, OrgComplianceTasksListOrgTasksData, OrgComplianceTasksListOrgTasksErrors, OrgComplianceTasksListOrgTasksResponses, OrgComplianceTasksMyTasksListMyTasksData, OrgComplianceTasksMyTasksListMyTasksErrors, OrgComplianceTasksMyTasksListMyTasksResponses, OrgComplianceTasksOverdueListOverdueTasksData, OrgComplianceTasksOverdueListOverdueTasksErrors, OrgComplianceTasksOverdueListOverdueTasksResponses, OrgComplianceTasksUpdateTaskDetailsData, OrgComplianceTasksUpdateTaskDetailsErrors, OrgComplianceTasksUpdateTaskDetailsResponses, OrgComplianceTrackingAcknowledgeAcknowledgeTrackingData, OrgComplianceTrackingAcknowledgeAcknowledgeTrackingErrors, OrgComplianceTrackingAcknowledgeAcknowledgeTrackingResponses, OrgComplianceTrackingAcpExposureGetTrackingAcpExposureData, OrgComplianceTrackingAcpExposureGetTrackingAcpExposureErrors, OrgComplianceTrackingAcpExposureGetTrackingAcpExposureResponses, OrgComplianceTrackingCreateNewTrackingData, OrgComplianceTrackingCreateNewTrackingErrors, OrgComplianceTrackingCreateNewTrackingResponses, OrgComplianceTrackingDeterminationsCreateTrackingDeterminationData, OrgComplianceTrackingDeterminationsCreateTrackingDeterminationErrors, OrgComplianceTrackingDeterminationsCreateTrackingDeterminationResponses, OrgComplianceTrackingDeterminationsListTrackingDeterminationsData, OrgComplianceTrackingDeterminationsListTrackingDeterminationsErrors, OrgComplianceTrackingDeterminationsListTrackingDeterminationsResponses, OrgComplianceTrackingEventsListTrackingEventsData, OrgComplianceTrackingEventsListTrackingEventsErrors, OrgComplianceTrackingEventsListTrackingEventsResponses, OrgComplianceTrackingEventsRecordTrackingEventData, OrgComplianceTrackingEventsRecordTrackingEventErrors, OrgComplianceTrackingEventsRecordTrackingEventResponses, OrgComplianceTrackingGenerateTasksGenerateTasksData, OrgComplianceTrackingGenerateTasksGenerateTasksErrors, OrgComplianceTrackingGenerateTasksGenerateTasksResponses, OrgComplianceTrackingGetTrackingDetailsData, OrgComplianceTrackingGetTrackingDetailsErrors, OrgComplianceTrackingGetTrackingDetailsResponses, OrgComplianceTrackingListOrgTrackingData, OrgComplianceTrackingListOrgTrackingErrors, OrgComplianceTrackingListOrgTrackingResponses, OrgComplianceTrackingPropertyListTrackingForPropertyData, OrgComplianceTrackingPropertyListTrackingForPropertyErrors, OrgComplianceTrackingPropertyListTrackingForPropertyResponses, OrgComplianceTrackingRequirementsSatisfiedMarkTrackingRequirementSatisfiedData, OrgComplianceTrackingRequirementsSatisfiedMarkTrackingRequirementSatisfiedErrors, OrgComplianceTrackingRequirementsSatisfiedMarkTrackingRequirementSatisfiedResponses, OrgComplianceTrackingResultsEmissionsComputeTrackingEmissionsData, OrgComplianceTrackingResultsEmissionsComputeTrackingEmissionsErrors, OrgComplianceTrackingResultsEmissionsComputeTrackingEmissionsResponses, OrgComplianceTrackingResultsListTrackingResultsData, OrgComplianceTrackingResultsListTrackingResultsErrors, OrgComplianceTrackingResultsListTrackingResultsResponses, OrgComplianceTrackingResultsStandardEvaluateTrackingStandardData, OrgComplianceTrackingResultsStandardEvaluateTrackingStandardErrors, OrgComplianceTrackingResultsStandardEvaluateTrackingStandardResponses, OrgComplianceTrackingReviewResolveTrackingReviewData, OrgComplianceTrackingReviewResolveTrackingReviewErrors, OrgComplianceTrackingReviewResolveTrackingReviewResponses, OrgComplianceTrackingTasksListTrackingTasksData, OrgComplianceTrackingTasksListTrackingTasksErrors, OrgComplianceTrackingTasksListTrackingTasksResponses, OrgComplianceTrackingTrackChangeTrackingTrackData, OrgComplianceTrackingTrackChangeTrackingTrackErrors, OrgComplianceTrackingTrackChangeTrackingTrackResponses, OrgComplianceTrackingTrackHistoryListTrackingTrackHistoryData, OrgComplianceTrackingTrackHistoryListTrackingTrackHistoryErrors, OrgComplianceTrackingTrackHistoryListTrackingTrackHistoryResponses, OrgComplianceTrackingUpdateTrackingDetailsData, OrgComplianceTrackingUpdateTrackingDetailsErrors, OrgComplianceTrackingUpdateTrackingDetailsResponses, OrgCoverageListAnomaliesListCoverageListAnomaliesData, OrgCoverageListAnomaliesListCoverageListAnomaliesErrors, OrgCoverageListAnomaliesListCoverageListAnomaliesResponses, OrgCoverageListListCoverageListsData, OrgCoverageListListCoverageListsErrors, OrgCoverageListListCoverageListsResponses, OrgCoverageListMatchesListCoverageListMatchesData, OrgCoverageListMatchesListCoverageListMatchesErrors, OrgCoverageListMatchesListCoverageListMatchesResponses, OrgCoverageListMatchMatchCoverageListData, OrgCoverageListMatchMatchCoverageListErrors, OrgCoverageListMatchMatchCoverageListResponses, OrgDashboardCreateDashboardData, OrgDashboardCreateDashboardErrors, OrgDashboardCreateDashboardResponses, OrgDashboardDataGetDashboardDataData, OrgDashboardDataGetDashboardDataErrors, OrgDashboardDataGetDashboardDataResponses, OrgDashboardDeleteDashboardData, OrgDashboardDeleteDashboardErrors, OrgDashboardDeleteDashboardResponses, OrgDashboardDuplicateDuplicateDashboardData, OrgDashboardDuplicateDuplicateDashboardErrors, OrgDashboardDuplicateDuplicateDashboardResponses, OrgDashboardGetDashboardData, OrgDashboardGetDashboardErrors, OrgDashboardGetDashboardResponses, OrgDashboardListDashboardsData, OrgDashboardListDashboardsErrors, OrgDashboardListDashboardsResponses, OrgDashboardUpdateDashboardData, OrgDashboardUpdateDashboardErrors, OrgDashboardUpdateDashboardResponses, OrgDepartmentCreateData, OrgDepartmentCreateErrors, OrgDepartmentCreateResponses, OrgDepartmentGetData, OrgDepartmentGetErrors, OrgDepartmentGetResponses, OrgDepartmentListData, OrgDepartmentListErrors, OrgDepartmentListResponses, OrgDepartmentUpdateData, OrgDepartmentUpdateErrors, OrgDepartmentUpdateResponses, OrgDigestGetDigestData, OrgDigestGetDigestErrors, OrgDigestGetDigestResponses, OrgFileContentsGetFileContentsData, OrgFileContentsGetFileContentsErrors, OrgFileContentsGetFileContentsResponses, OrgFileGetFilesData, OrgFileGetFilesErrors, OrgFileGetFileSetData, OrgFileGetFileSetErrors, OrgFileGetFileSetResponses, OrgFileGetFilesResponses, OrgFileUploadFilesData, OrgFileUploadFilesErrors, OrgFileUploadFilesResponses, OrgImageGetOrgImageData, OrgImageGetOrgImageErrors, OrgImageGetOrgImageResponses, OrgImageUpdateImageData, OrgImageUpdateImageErrors, OrgImageUpdateImageResponses, OrgIngestJobCreateData, OrgIngestJobCreateErrors, OrgIngestJobCreateResponses, OrgIngestJobGetData, OrgIngestJobGetErrors, OrgIngestJobGetResponses, OrgIngestJobListData, OrgIngestJobListErrors, OrgIngestJobListResponses, OrgIngestJobUpdateData, OrgIngestJobUpdateErrors, OrgIngestJobUpdateResponses, OrgInitiativesCreateNewInitiativeData, OrgInitiativesCreateNewInitiativeErrors, OrgInitiativesCreateNewInitiativeResponses, OrgInitiativesDeleteInitiativeEndpointData, OrgInitiativesDeleteInitiativeEndpointErrors, OrgInitiativesDeleteInitiativeEndpointResponses, OrgInitiativesGetInitiativeDetailsData, OrgInitiativesGetInitiativeDetailsErrors, OrgInitiativesGetInitiativeDetailsResponses, OrgInitiativesImpactsAddInitiativeImpactData, OrgInitiativesImpactsAddInitiativeImpactErrors, OrgInitiativesImpactsAddInitiativeImpactResponses, OrgInitiativesListInitiativesData, OrgInitiativesListInitiativesErrors, OrgInitiativesListInitiativesResponses, OrgInitiativesMilestonesCompleteCompleteInitiativeMilestoneData, OrgInitiativesMilestonesCompleteCompleteInitiativeMilestoneErrors, OrgInitiativesMilestonesCompleteCompleteInitiativeMilestoneResponses, OrgInitiativesMilestonesCreateInitiativeMilestoneData, OrgInitiativesMilestonesCreateInitiativeMilestoneErrors, OrgInitiativesMilestonesCreateInitiativeMilestoneResponses, OrgInitiativesMilestonesUpdateInitiativeMilestoneData, OrgInitiativesMilestonesUpdateInitiativeMilestoneErrors, OrgInitiativesMilestonesUpdateInitiativeMilestoneResponses, OrgInitiativesProgressGetInitiativeProgressData, OrgInitiativesProgressGetInitiativeProgressErrors, OrgInitiativesProgressGetInitiativeProgressResponses, OrgInitiativesTasksCompleteCompleteInitiativeTaskData, OrgInitiativesTasksCompleteCompleteInitiativeTaskErrors, OrgInitiativesTasksCompleteCompleteInitiativeTaskResponses, OrgInitiativesTasksCreateInitiativeTaskData, OrgInitiativesTasksCreateInitiativeTaskErrors, OrgInitiativesTasksCreateInitiativeTaskResponses, OrgInitiativesTasksDeleteInitiativeTaskData, OrgInitiativesTasksDeleteInitiativeTaskErrors, OrgInitiativesTasksDeleteInitiativeTaskResponses, OrgInitiativesTasksUpdateInitiativeTaskData, OrgInitiativesTasksUpdateInitiativeTaskErrors, OrgInitiativesTasksUpdateInitiativeTaskResponses, OrgInitiativesUpdateInitiativeDetailsData, OrgInitiativesUpdateInitiativeDetailsErrors, OrgInitiativesUpdateInitiativeDetailsResponses, OrgInsightsDuplicatesGetDuplicateIssuesData, OrgInsightsDuplicatesGetDuplicateIssuesErrors, OrgInsightsDuplicatesGetDuplicateIssuesResponses, OrgInsightsGetSummaryData, OrgInsightsGetSummaryErrors, OrgInsightsGetSummaryResponses, OrgInsightsIncorrectGetIncorrectIssuesData, OrgInsightsIncorrectGetIncorrectIssuesErrors, OrgInsightsIncorrectGetIncorrectIssuesResponses, OrgInsightsMissingGetMissingIssuesData, OrgInsightsMissingGetMissingIssuesErrors, OrgInsightsMissingGetMissingIssuesResponses, OrgIntegrationImageGetImageData, OrgIntegrationImageGetImageErrors, OrgIntegrationImageGetImageResponses, OrgIntegrationListOrgIntegrationsData, OrgIntegrationListOrgIntegrationsErrors, OrgIntegrationListOrgIntegrationsResponses, OrgInvitationCreateData, OrgInvitationCreateErrors, OrgInvitationCreateResponses, OrgInvitationListInvitationsData, OrgInvitationListInvitationsErrors, OrgInvitationListInvitationsResponses, OrgInvitationReadData, OrgInvitationReadErrors, OrgInvitationReadResponses, OrgInvitationUpdateData, OrgInvitationUpdateErrors, OrgInvitationUpdateResponses, OrgJurisdictionBoundsLookupBoundsData, OrgJurisdictionBoundsLookupBoundsErrors, OrgJurisdictionBoundsLookupBoundsResponses, OrgJurisdictionCreateOrgJurisdictionData, OrgJurisdictionCreateOrgJurisdictionErrors, OrgJurisdictionCreateOrgJurisdictionResponses, OrgJurisdictionDeactivateJurisdictionEndpointData, OrgJurisdictionDeactivateJurisdictionEndpointErrors, OrgJurisdictionDeactivateJurisdictionEndpointResponses, OrgJurisdictionGetJurisdictionDetailsData, OrgJurisdictionGetJurisdictionDetailsErrors, OrgJurisdictionGetJurisdictionDetailsResponses, OrgJurisdictionListJurisdictionsData, OrgJurisdictionListJurisdictionsErrors, OrgJurisdictionListJurisdictionsResponses, OrgJurisdictionUpdateJurisdictionDetailsData, OrgJurisdictionUpdateJurisdictionDetailsErrors, OrgJurisdictionUpdateJurisdictionDetailsResponses, OrgJurisdictionUploadBoundaryUploadBoundaryFileData, OrgJurisdictionUploadBoundaryUploadBoundaryFileErrors, OrgJurisdictionUploadBoundaryUploadBoundaryFileResponses, OrgListListOrgsData, OrgListListOrgsErrors, OrgListListOrgsResponses, OrgMeterCapabilityAddCapabilityData, OrgMeterCapabilityAddCapabilityErrors, OrgMeterCapabilityAddCapabilityResponses, OrgMeterCapabilityGetCapabilityData, OrgMeterCapabilityGetCapabilityErrors, OrgMeterCapabilityGetCapabilityResponses, OrgMeterCapabilityListCapabilitiesData, OrgMeterCapabilityListCapabilitiesErrors, OrgMeterCapabilityListCapabilitiesResponses, OrgMeterCapabilityRemoveCapabilityData, OrgMeterCapabilityRemoveCapabilityErrors, OrgMeterCapabilityRemoveCapabilityResponses, OrgMeterCapabilityUpdateCapabilityData, OrgMeterCapabilityUpdateCapabilityErrors, OrgMeterCapabilityUpdateCapabilityResponses, OrgMeterCreateMeterData, OrgMeterCreateMeterErrors, OrgMeterCreateMeterResponses, OrgMeterDeleteMeterData, OrgMeterDeleteMeterErrors, OrgMeterDeleteMeterResponses, OrgMeterGetMeterData, OrgMeterGetMeterErrors, OrgMeterGetMeterResponses, OrgMeterIntervalBatchPushIntervalBatchData, OrgMeterIntervalBatchPushIntervalBatchErrors, OrgMeterIntervalBatchPushIntervalBatchResponses, OrgMeterIntervalChannelsListChannelsData, OrgMeterIntervalChannelsListChannelsErrors, OrgMeterIntervalChannelsListChannelsResponses, OrgMeterIntervalGetIntervalSeriesData, OrgMeterIntervalGetIntervalSeriesErrors, OrgMeterIntervalGetIntervalSeriesResponses, OrgMeterIntervalSummaryGetIntervalSummaryData, OrgMeterIntervalSummaryGetIntervalSummaryErrors, OrgMeterIntervalSummaryGetIntervalSummaryResponses, OrgMeterListMetersData, OrgMeterListMetersErrors, OrgMeterListMetersResponses, OrgMeterMeasureTypeListMeterMeasureTypesData, OrgMeterMeasureTypeListMeterMeasureTypesErrors, OrgMeterMeasureTypeListMeterMeasureTypesResponses, OrgMeterReadingCreateReadingData, OrgMeterReadingCreateReadingErrors, OrgMeterReadingCreateReadingResponses, OrgMeterReadingDeleteReadingData, OrgMeterReadingDeleteReadingErrors, OrgMeterReadingDeleteReadingResponses, OrgMeterReadingGetReadingData, OrgMeterReadingGetReadingErrors, OrgMeterReadingGetReadingResponses, OrgMeterReadingListReadingsData, OrgMeterReadingListReadingsErrors, OrgMeterReadingListReadingsResponses, OrgMeterReadingUpdateReadingData, OrgMeterReadingUpdateReadingErrors, OrgMeterReadingUpdateReadingResponses, OrgMeterTypeListMeterTypesData, OrgMeterTypeListMeterTypesErrors, OrgMeterTypeListMeterTypesResponses, OrgMeterUpdateMeterData, OrgMeterUpdateMeterErrors, OrgMeterUpdateMeterResponses, OrgPaymentBalanceGetOrgBalanceData, OrgPaymentBalanceGetOrgBalanceErrors, OrgPaymentBalanceGetOrgBalanceResponses, OrgPaymentCreateData, OrgPaymentCreateErrors, OrgPaymentCreateResponses, OrgPaymentDeleteData, OrgPaymentDeleteErrors, OrgPaymentDeleteResponses, OrgPaymentListPaymentsData, OrgPaymentListPaymentsErrors, OrgPaymentListPaymentsResponses, OrgPaymentUpcomingListUpcomingData, OrgPaymentUpcomingListUpcomingErrors, OrgPaymentUpcomingListUpcomingResponses, OrgPaymentUpdateData, OrgPaymentUpdateErrors, OrgPaymentUpdateResponses, OrgPreferencesGetPreferencesData, OrgPreferencesGetPreferencesErrors, OrgPreferencesGetPreferencesResponses, OrgPreferencesSetPreferencesData, OrgPreferencesSetPreferencesErrors, OrgPreferencesSetPreferencesResponses, OrgProgramCatalogGetCatalogProgramData, OrgProgramCatalogGetCatalogProgramErrors, OrgProgramCatalogGetCatalogProgramResponses, OrgProgramCatalogListCatalogProgramsData, OrgProgramCatalogListCatalogProgramsErrors, OrgProgramCatalogListCatalogProgramsResponses, OrgProgramCommunicationsTemplatesCreateCommunicationTemplateData, OrgProgramCommunicationsTemplatesCreateCommunicationTemplateErrors, OrgProgramCommunicationsTemplatesCreateCommunicationTemplateResponses, OrgProgramCommunicationsTemplatesDeleteCommunicationTemplateData, OrgProgramCommunicationsTemplatesDeleteCommunicationTemplateErrors, OrgProgramCommunicationsTemplatesDeleteCommunicationTemplateResponses, OrgProgramCommunicationsTemplatesListCommunicationTemplatesData, OrgProgramCommunicationsTemplatesListCommunicationTemplatesErrors, OrgProgramCommunicationsTemplatesListCommunicationTemplatesResponses, OrgProgramCommunicationsTemplatesUpdateCommunicationTemplateData, OrgProgramCommunicationsTemplatesUpdateCommunicationTemplateErrors, OrgProgramCommunicationsTemplatesUpdateCommunicationTemplateResponses, OrgProgramCreateNewProgramData, OrgProgramCreateNewProgramErrors, OrgProgramCreateNewProgramResponses, OrgProgramCyclesActivateActivateCycleData, OrgProgramCyclesActivateActivateCycleErrors, OrgProgramCyclesActivateActivateCycleResponses, OrgProgramCyclesComplianceCreateCycleComplianceRecordData, OrgProgramCyclesComplianceCreateCycleComplianceRecordErrors, OrgProgramCyclesComplianceCreateCycleComplianceRecordResponses, OrgProgramCyclesComplianceEvaluateEvaluateCycleComplianceData, OrgProgramCyclesComplianceEvaluateEvaluateCycleComplianceErrors, OrgProgramCyclesComplianceEvaluateEvaluateCycleComplianceResponses, OrgProgramCyclesComplianceListCycleComplianceData, OrgProgramCyclesComplianceListCycleComplianceErrors, OrgProgramCyclesComplianceListCycleComplianceResponses, OrgProgramCyclesComplianceStatsGetCycleComplianceStatsData, OrgProgramCyclesComplianceStatsGetCycleComplianceStatsErrors, OrgProgramCyclesComplianceStatsGetCycleComplianceStatsResponses, OrgProgramCyclesComplianceUpdateCycleComplianceRecordData, OrgProgramCyclesComplianceUpdateCycleComplianceRecordErrors, OrgProgramCyclesComplianceUpdateCycleComplianceRecordResponses, OrgProgramCyclesCreateProgramCycleData, OrgProgramCyclesCreateProgramCycleErrors, OrgProgramCyclesCreateProgramCycleResponses, OrgProgramCyclesCriteriaCreateCycleCriteriaData, OrgProgramCyclesCriteriaCreateCycleCriteriaErrors, OrgProgramCyclesCriteriaCreateCycleCriteriaResponses, OrgProgramCyclesCriteriaDeleteCycleCriteriaData, OrgProgramCyclesCriteriaDeleteCycleCriteriaErrors, OrgProgramCyclesCriteriaDeleteCycleCriteriaResponses, OrgProgramCyclesCriteriaListCycleCriteriaData, OrgProgramCyclesCriteriaListCycleCriteriaErrors, OrgProgramCyclesCriteriaListCycleCriteriaResponses, OrgProgramCyclesCriteriaUpdateCycleCriteriaData, OrgProgramCyclesCriteriaUpdateCycleCriteriaErrors, OrgProgramCyclesCriteriaUpdateCycleCriteriaResponses, OrgProgramCyclesDeadlinesCreateCycleDeadlineData, OrgProgramCyclesDeadlinesCreateCycleDeadlineErrors, OrgProgramCyclesDeadlinesCreateCycleDeadlineResponses, OrgProgramCyclesDeadlinesDeleteCycleDeadlineData, OrgProgramCyclesDeadlinesDeleteCycleDeadlineErrors, OrgProgramCyclesDeadlinesDeleteCycleDeadlineResponses, OrgProgramCyclesDeadlinesListCycleDeadlinesData, OrgProgramCyclesDeadlinesListCycleDeadlinesErrors, OrgProgramCyclesDeadlinesListCycleDeadlinesResponses, OrgProgramCyclesDeadlinesUpdateCycleDeadlineData, OrgProgramCyclesDeadlinesUpdateCycleDeadlineErrors, OrgProgramCyclesDeadlinesUpdateCycleDeadlineResponses, OrgProgramCyclesEnrollmentsCreateCycleEnrollmentData, OrgProgramCyclesEnrollmentsCreateCycleEnrollmentErrors, OrgProgramCyclesEnrollmentsCreateCycleEnrollmentResponses, OrgProgramCyclesEnrollmentsListCycleEnrollmentsData, OrgProgramCyclesEnrollmentsListCycleEnrollmentsErrors, OrgProgramCyclesEnrollmentsListCycleEnrollmentsResponses, OrgProgramCyclesEnrollmentsUpdateCycleEnrollmentData, OrgProgramCyclesEnrollmentsUpdateCycleEnrollmentErrors, OrgProgramCyclesEnrollmentsUpdateCycleEnrollmentResponses, OrgProgramCyclesFormsCreateCycleFormData, OrgProgramCyclesFormsCreateCycleFormErrors, OrgProgramCyclesFormsCreateCycleFormResponses, OrgProgramCyclesFormsDefinitionGetFormDefinitionData, OrgProgramCyclesFormsDefinitionGetFormDefinitionErrors, OrgProgramCyclesFormsDefinitionGetFormDefinitionResponses, OrgProgramCyclesFormsDeleteCycleFormData, OrgProgramCyclesFormsDeleteCycleFormErrors, OrgProgramCyclesFormsDeleteCycleFormResponses, OrgProgramCyclesFormsListCycleFormsData, OrgProgramCyclesFormsListCycleFormsErrors, OrgProgramCyclesFormsListCycleFormsResponses, OrgProgramCyclesFormsMySubmissionGetMyFormSubmissionData, OrgProgramCyclesFormsMySubmissionGetMyFormSubmissionErrors, OrgProgramCyclesFormsMySubmissionGetMyFormSubmissionResponses, OrgProgramCyclesFormsSubmissionsListFormSubmissionsData, OrgProgramCyclesFormsSubmissionsListFormSubmissionsErrors, OrgProgramCyclesFormsSubmissionsListFormSubmissionsResponses, OrgProgramCyclesFormsSubmissionsReviewFormSubmissionData, OrgProgramCyclesFormsSubmissionsReviewFormSubmissionErrors, OrgProgramCyclesFormsSubmissionsReviewFormSubmissionResponses, OrgProgramCyclesFormsSubmissionsSubmitSubmitOwnerFormSubmissionData, OrgProgramCyclesFormsSubmissionsSubmitSubmitOwnerFormSubmissionErrors, OrgProgramCyclesFormsSubmissionsSubmitSubmitOwnerFormSubmissionResponses, OrgProgramCyclesFormsSubmissionsUpsertOwnerFormSubmissionData, OrgProgramCyclesFormsSubmissionsUpsertOwnerFormSubmissionErrors, OrgProgramCyclesFormsSubmissionsUpsertOwnerFormSubmissionResponses, OrgProgramCyclesFormsUpdateCycleFormData, OrgProgramCyclesFormsUpdateCycleFormErrors, OrgProgramCyclesFormsUpdateCycleFormResponses, OrgProgramCyclesGetCycleData, OrgProgramCyclesGetCycleErrors, OrgProgramCyclesGetCycleResponses, OrgProgramCyclesLatestGetLatestCycleData, OrgProgramCyclesLatestGetLatestCycleErrors, OrgProgramCyclesLatestGetLatestCycleResponses, OrgProgramCyclesListProgramCyclesData, OrgProgramCyclesListProgramCyclesErrors, OrgProgramCyclesListProgramCyclesResponses, OrgProgramCyclesPortalsCreateCyclePortalData, OrgProgramCyclesPortalsCreateCyclePortalErrors, OrgProgramCyclesPortalsCreateCyclePortalResponses, OrgProgramCyclesPortalsDeleteCyclePortalData, OrgProgramCyclesPortalsDeleteCyclePortalErrors, OrgProgramCyclesPortalsDeleteCyclePortalResponses, OrgProgramCyclesPortalsListCyclePortalsData, OrgProgramCyclesPortalsListCyclePortalsErrors, OrgProgramCyclesPortalsListCyclePortalsResponses, OrgProgramCyclesPortalsMySubmissionsListMyPortalSubmissionsData, OrgProgramCyclesPortalsMySubmissionsListMyPortalSubmissionsErrors, OrgProgramCyclesPortalsMySubmissionsListMyPortalSubmissionsResponses, OrgProgramCyclesPortalsSubmissionsGetMyPortalSubmissionData, OrgProgramCyclesPortalsSubmissionsGetMyPortalSubmissionErrors, OrgProgramCyclesPortalsSubmissionsGetMyPortalSubmissionResponses, OrgProgramCyclesPortalsSubmissionsListPortalSubmissionsData, OrgProgramCyclesPortalsSubmissionsListPortalSubmissionsErrors, OrgProgramCyclesPortalsSubmissionsListPortalSubmissionsResponses, OrgProgramCyclesPortalsSubmissionsReviewPortalSubmissionData, OrgProgramCyclesPortalsSubmissionsReviewPortalSubmissionErrors, OrgProgramCyclesPortalsSubmissionsReviewPortalSubmissionResponses, OrgProgramCyclesPortalsSubmissionsUploadOwnerPortalSubmissionData, OrgProgramCyclesPortalsSubmissionsUploadOwnerPortalSubmissionErrors, OrgProgramCyclesPortalsSubmissionsUploadOwnerPortalSubmissionResponses, OrgProgramCyclesPortalsUpdateCyclePortalData, OrgProgramCyclesPortalsUpdateCyclePortalErrors, OrgProgramCyclesPortalsUpdateCyclePortalResponses, OrgProgramCyclesReportsCitywideCitywideReportData, OrgProgramCyclesReportsCitywideCitywideReportErrors, OrgProgramCyclesReportsCitywideCitywideReportResponses, OrgProgramCyclesReportsDashboardProgramDashboardData, OrgProgramCyclesReportsDashboardProgramDashboardErrors, OrgProgramCyclesReportsDashboardProgramDashboardResponses, OrgProgramCyclesReportsDisclosureCsvDisclosureExportData, OrgProgramCyclesReportsDisclosureCsvDisclosureExportErrors, OrgProgramCyclesReportsDisclosureCsvDisclosureExportResponses, OrgProgramCyclesRequirementsCreateCycleRequirementData, OrgProgramCyclesRequirementsCreateCycleRequirementErrors, OrgProgramCyclesRequirementsCreateCycleRequirementResponses, OrgProgramCyclesRequirementsDeleteCycleRequirementData, OrgProgramCyclesRequirementsDeleteCycleRequirementErrors, OrgProgramCyclesRequirementsDeleteCycleRequirementResponses, OrgProgramCyclesRequirementsListCycleRequirementsData, OrgProgramCyclesRequirementsListCycleRequirementsErrors, OrgProgramCyclesRequirementsListCycleRequirementsResponses, OrgProgramCyclesRequirementsUpdateCycleRequirementData, OrgProgramCyclesRequirementsUpdateCycleRequirementErrors, OrgProgramCyclesRequirementsUpdateCycleRequirementResponses, OrgProgramCyclesUpdateProgramCycleData, OrgProgramCyclesUpdateProgramCycleErrors, OrgProgramCyclesUpdateProgramCycleResponses, OrgProgramDefinitionHistoryListProgramDefinitionHistoryData, OrgProgramDefinitionHistoryListProgramDefinitionHistoryErrors, OrgProgramDefinitionHistoryListProgramDefinitionHistoryResponses, OrgProgramDeleteProgramData, OrgProgramDeleteProgramErrors, OrgProgramDeleteProgramResponses, OrgProgramGetProgramDetailsData, OrgProgramGetProgramDetailsErrors, OrgProgramGetProgramDetailsResponses, OrgProgramImportRunsListProgramImportRunsData, OrgProgramImportRunsListProgramImportRunsErrors, OrgProgramImportRunsListProgramImportRunsResponses, OrgProgramListAllProgramsData, OrgProgramListAllProgramsErrors, OrgProgramListAllProgramsResponses, OrgProgramMatchConfirmConfirmProgramMatchData, OrgProgramMatchConfirmConfirmProgramMatchErrors, OrgProgramMatchConfirmConfirmProgramMatchResponses, OrgProgramMatchDeclineDeclineProgramMatchData, OrgProgramMatchDeclineDeclineProgramMatchErrors, OrgProgramMatchDeclineDeclineProgramMatchResponses, OrgProgramMatchGetProgramMatchData, OrgProgramMatchGetProgramMatchErrors, OrgProgramMatchGetProgramMatchResponses, OrgProgramMatchListProgramMatchesData, OrgProgramMatchListProgramMatchesErrors, OrgProgramMatchListProgramMatchesResponses, OrgProgramPropertiesAutoMatchCandidatesListAutoMatchCandidatesData, OrgProgramPropertiesAutoMatchCandidatesListAutoMatchCandidatesErrors, OrgProgramPropertiesAutoMatchCandidatesListAutoMatchCandidatesResponses, OrgProgramPropertiesCreateProgramPropertyData, OrgProgramPropertiesCreateProgramPropertyErrors, OrgProgramPropertiesCreateProgramPropertyResponses, OrgProgramPropertiesDeleteProgramPropertyData, OrgProgramPropertiesDeleteProgramPropertyErrors, OrgProgramPropertiesDeleteProgramPropertyResponses, OrgProgramPropertiesLinkLinkProgramPropertyData, OrgProgramPropertiesLinkLinkProgramPropertyErrors, OrgProgramPropertiesLinkLinkProgramPropertyResponses, OrgProgramPropertiesLinkUnlinkProgramPropertyData, OrgProgramPropertiesLinkUnlinkProgramPropertyErrors, OrgProgramPropertiesLinkUnlinkProgramPropertyResponses, OrgProgramPropertiesListProgramPropertiesData, OrgProgramPropertiesListProgramPropertiesErrors, OrgProgramPropertiesListProgramPropertiesResponses, OrgProgramPropertiesUpdateProgramPropertyData, OrgProgramPropertiesUpdateProgramPropertyErrors, OrgProgramPropertiesUpdateProgramPropertyResponses, OrgProgramPropertyShareRequestsApproveApproveShareRequestData, OrgProgramPropertyShareRequestsApproveApproveShareRequestErrors, OrgProgramPropertyShareRequestsApproveApproveShareRequestResponses, OrgProgramPropertyShareRequestsCreateShareRequestData, OrgProgramPropertyShareRequestsCreateShareRequestErrors, OrgProgramPropertyShareRequestsCreateShareRequestResponses, OrgProgramPropertyShareRequestsDenyDenyShareRequestData, OrgProgramPropertyShareRequestsDenyDenyShareRequestErrors, OrgProgramPropertyShareRequestsDenyDenyShareRequestResponses, OrgProgramPropertyShareRequestsIncomingListIncomingShareRequestsData, OrgProgramPropertyShareRequestsIncomingListIncomingShareRequestsErrors, OrgProgramPropertyShareRequestsIncomingListIncomingShareRequestsResponses, OrgProgramPropertyShareRequestsOutgoingListOutgoingShareRequestsData, OrgProgramPropertyShareRequestsOutgoingListOutgoingShareRequestsErrors, OrgProgramPropertyShareRequestsOutgoingListOutgoingShareRequestsResponses, OrgProgramPropertyShareRequestsRevokeRevokeShareRequestData, OrgProgramPropertyShareRequestsRevokeRevokeShareRequestErrors, OrgProgramPropertyShareRequestsRevokeRevokeShareRequestResponses, OrgProgramReferenceGetProgramReferenceData, OrgProgramReferenceGetProgramReferenceErrors, OrgProgramReferenceGetProgramReferenceResponses, OrgProgramSourcesListProgramSourcesData, OrgProgramSourcesListProgramSourcesErrors, OrgProgramSourcesListProgramSourcesResponses, OrgProgramStatusSetProgramStatusData, OrgProgramStatusSetProgramStatusErrors, OrgProgramStatusSetProgramStatusResponses, OrgProgramTemplateCriteriaCreateProgramTemplateCriteriaData, OrgProgramTemplateCriteriaCreateProgramTemplateCriteriaErrors, OrgProgramTemplateCriteriaCreateProgramTemplateCriteriaResponses, OrgProgramTemplateCriteriaDeleteProgramTemplateCriteriaData, OrgProgramTemplateCriteriaDeleteProgramTemplateCriteriaErrors, OrgProgramTemplateCriteriaDeleteProgramTemplateCriteriaResponses, OrgProgramTemplateCriteriaListProgramTemplateCriteriaData, OrgProgramTemplateCriteriaListProgramTemplateCriteriaErrors, OrgProgramTemplateCriteriaListProgramTemplateCriteriaResponses, OrgProgramTemplateCriteriaUpdateProgramTemplateCriteriaData, OrgProgramTemplateCriteriaUpdateProgramTemplateCriteriaErrors, OrgProgramTemplateCriteriaUpdateProgramTemplateCriteriaResponses, OrgProgramTemplateDeadlinesCreateProgramTemplateDeadlineData, OrgProgramTemplateDeadlinesCreateProgramTemplateDeadlineErrors, OrgProgramTemplateDeadlinesCreateProgramTemplateDeadlineResponses, OrgProgramTemplateDeadlinesDeleteProgramTemplateDeadlineData, OrgProgramTemplateDeadlinesDeleteProgramTemplateDeadlineErrors, OrgProgramTemplateDeadlinesDeleteProgramTemplateDeadlineResponses, OrgProgramTemplateDeadlinesListProgramTemplateDeadlinesData, OrgProgramTemplateDeadlinesListProgramTemplateDeadlinesErrors, OrgProgramTemplateDeadlinesListProgramTemplateDeadlinesResponses, OrgProgramTemplateDeadlinesUpdateProgramTemplateDeadlineData, OrgProgramTemplateDeadlinesUpdateProgramTemplateDeadlineErrors, OrgProgramTemplateDeadlinesUpdateProgramTemplateDeadlineResponses, OrgProgramTemplateRequirementsCreateProgramTemplateRequirementData, OrgProgramTemplateRequirementsCreateProgramTemplateRequirementErrors, OrgProgramTemplateRequirementsCreateProgramTemplateRequirementResponses, OrgProgramTemplateRequirementsDeleteProgramTemplateRequirementData, OrgProgramTemplateRequirementsDeleteProgramTemplateRequirementErrors, OrgProgramTemplateRequirementsDeleteProgramTemplateRequirementResponses, OrgProgramTemplateRequirementsListProgramTemplateRequirementsData, OrgProgramTemplateRequirementsListProgramTemplateRequirementsErrors, OrgProgramTemplateRequirementsListProgramTemplateRequirementsResponses, OrgProgramTemplateRequirementsUpdateProgramTemplateRequirementData, OrgProgramTemplateRequirementsUpdateProgramTemplateRequirementErrors, OrgProgramTemplateRequirementsUpdateProgramTemplateRequirementResponses, OrgProgramTracksListProgramTracksData, OrgProgramTracksListProgramTracksErrors, OrgProgramTracksListProgramTracksResponses, OrgProgramUpdateProgramDetailsData, OrgProgramUpdateProgramDetailsErrors, OrgProgramUpdateProgramDetailsResponses, OrgPropertyAttestationsCreatePropertyAttestationData, OrgPropertyAttestationsCreatePropertyAttestationErrors, OrgPropertyAttestationsCreatePropertyAttestationResponses, OrgPropertyAttestationsListPropertyAttestationsData, OrgPropertyAttestationsListPropertyAttestationsErrors, OrgPropertyAttestationsListPropertyAttestationsResponses, OrgPropertyAttestationsUpdatePropertyAttestationData, OrgPropertyAttestationsUpdatePropertyAttestationErrors, OrgPropertyAttestationsUpdatePropertyAttestationResponses, OrgPropertyCreateData, OrgPropertyCreateErrors, OrgPropertyCreateResponses, OrgPropertyListData, OrgPropertyListErrors, OrgPropertyListResponses, OrgPropertyMetricsImportImportPropertyMetricsData, OrgPropertyMetricsImportImportPropertyMetricsErrors, OrgPropertyMetricsImportImportPropertyMetricsResponses, OrgPropertyMetricsListPropertyMetricsData, OrgPropertyMetricsListPropertyMetricsErrors, OrgPropertyMetricsListPropertyMetricsResponses, OrgPropertyMetricsSetPropertyMetricData, OrgPropertyMetricsSetPropertyMetricErrors, OrgPropertyMetricsSetPropertyMetricResponses, OrgPropertyProgramFactsGetPropertyProgramFactsData, OrgPropertyProgramFactsGetPropertyProgramFactsErrors, OrgPropertyProgramFactsGetPropertyProgramFactsResponses, OrgPropertyProgramFactsSetPropertyProgramFactsData, OrgPropertyProgramFactsSetPropertyProgramFactsErrors, OrgPropertyProgramFactsSetPropertyProgramFactsResponses, OrgPropertyReadinessGetPropertyReadinessData, OrgPropertyReadinessGetPropertyReadinessErrors, OrgPropertyReadinessGetPropertyReadinessResponses, OrgPropertyServiceHistoryGetServiceHistoryData, OrgPropertyServiceHistoryGetServiceHistoryErrors, OrgPropertyServiceHistoryGetServiceHistoryResponses, OrgPropertyTenantSpacesCreatePropertyTenantSpaceData, OrgPropertyTenantSpacesCreatePropertyTenantSpaceErrors, OrgPropertyTenantSpacesCreatePropertyTenantSpaceResponses, OrgPropertyTenantSpacesExportCsvExportPropertyTenantSpacesData, OrgPropertyTenantSpacesExportCsvExportPropertyTenantSpacesErrors, OrgPropertyTenantSpacesExportCsvExportPropertyTenantSpacesResponses, OrgPropertyTenantSpacesImportImportPropertyTenantSpacesData, OrgPropertyTenantSpacesImportImportPropertyTenantSpacesErrors, OrgPropertyTenantSpacesImportImportPropertyTenantSpacesResponses, OrgPropertyTenantSpacesListPropertyTenantSpacesData, OrgPropertyTenantSpacesListPropertyTenantSpacesErrors, OrgPropertyTenantSpacesListPropertyTenantSpacesResponses, OrgPropertyTenantSpacesUpdatePropertyTenantSpaceData, OrgPropertyTenantSpacesUpdatePropertyTenantSpaceErrors, OrgPropertyTenantSpacesUpdatePropertyTenantSpaceResponses, OrgPropertyUpdateData, OrgPropertyUpdateErrors, OrgPropertyUpdateResponses, OrgPropertyUsesListPropertyUsesData, OrgPropertyUsesListPropertyUsesErrors, OrgPropertyUsesListPropertyUsesResponses, OrgPropertyUsesReplacePropertyUsesData, OrgPropertyUsesReplacePropertyUsesErrors, OrgPropertyUsesReplacePropertyUsesResponses, OrgQueryBatchExecuteQueryBatchData, OrgQueryBatchExecuteQueryBatchErrors, OrgQueryBatchExecuteQueryBatchResponses, OrgQueryCatalogDimensionsGetDimensionCatalogData, OrgQueryCatalogDimensionsGetDimensionCatalogErrors, OrgQueryCatalogDimensionsGetDimensionCatalogResponses, OrgQueryCatalogMetricsGetMetricCatalogData, OrgQueryCatalogMetricsGetMetricCatalogErrors, OrgQueryCatalogMetricsGetMetricCatalogResponses, OrgQueryDataGetDataData, OrgQueryDataGetDataErrors, OrgQueryDataGetDataResponses, OrgQueryExportCreateExportJobData, OrgQueryExportCreateExportJobErrors, OrgQueryExportCreateExportJobResponses, OrgQueryExportGetExportJobData, OrgQueryExportGetExportJobErrors, OrgQueryExportGetExportJobResponses, OrgSavedFilterCreateData, OrgSavedFilterCreateErrors, OrgSavedFilterCreateResponses, OrgSavedFilterDeleteData, OrgSavedFilterDeleteErrors, OrgSavedFilterDeleteResponses, OrgSavedFilterListSavedFiltersData, OrgSavedFilterListSavedFiltersErrors, OrgSavedFilterListSavedFiltersResponses, OrgSavedFilterUpdateData, OrgSavedFilterUpdateErrors, OrgSavedFilterUpdateResponses, OrgSearchSearchData, OrgSearchSearchErrors, OrgSearchSearchResponses, OrgServiceAccountBalanceGetBalanceData, OrgServiceAccountBalanceGetBalanceErrors, OrgServiceAccountBalanceGetBalanceResponses, OrgServiceAccountServiceAccountListData, OrgServiceAccountServiceAccountListErrors, OrgServiceAccountServiceAccountListResponses, OrgStatementDeleteData, OrgStatementDeleteErrors, OrgStatementDeleteResponses, OrgStatementGetData, OrgStatementGetErrors, OrgStatementGetResponses, OrgStatementListData, OrgStatementListErrors, OrgStatementListResponses, OrgStatementUpdateData, OrgStatementUpdateErrors, OrgStatementUpdateResponses, OrgSupportCreateSupportRequestData, OrgSupportCreateSupportRequestErrors, OrgSupportCreateSupportRequestResponses, OrgSupportGetSupportRequestData, OrgSupportGetSupportRequestErrors, OrgSupportGetSupportRequestResponses, OrgSupportListSupportRequestsData, OrgSupportListSupportRequestsErrors, OrgSupportListSupportRequestsResponses, OrgSupportMessageCreateMessageData, OrgSupportMessageCreateMessageErrors, OrgSupportMessageCreateMessageResponses, OrgSupportUpdateSupportRequestData, OrgSupportUpdateSupportRequestErrors, OrgSupportUpdateSupportRequestResponses, OrgTargetCreateData, OrgTargetCreateErrors, OrgTargetCreateResponses, OrgTargetDeleteData, OrgTargetDeleteErrors, OrgTargetDeleteResponses, OrgTargetListTargetsData, OrgTargetListTargetsErrors, OrgTargetListTargetsResponses, OrgTargetProgressListProgressData, OrgTargetProgressListProgressErrors, OrgTargetProgressListProgressResponses, OrgTargetSeriesGetSeriesData, OrgTargetSeriesGetSeriesErrors, OrgTargetSeriesGetSeriesResponses, OrgTargetUpdateData, OrgTargetUpdateErrors, OrgTargetUpdateResponses, OrgUpdateData, OrgUpdateErrors, OrgUpdateResponses, OrgUserCreateData, OrgUserCreateErrors, OrgUserCreateResponses, OrgUserDeleteUserData, OrgUserDeleteUserErrors, OrgUserDeleteUserResponses, OrgUserImageUpdateImageData, OrgUserImageUpdateImageErrors, OrgUserImageUpdateImageResponses, OrgUserListUsersData, OrgUserListUsersErrors, OrgUserListUsersResponses, OrgUserMeGetData, OrgUserMeGetErrors, OrgUserMeGetResponses, OrgUserUpdateUserData, OrgUserUpdateUserErrors, OrgUserUpdateUserResponses, OrgVendorBalanceGetBalanceData, OrgVendorBalanceGetBalanceErrors, OrgVendorBalanceGetBalanceResponses, OrgVendorBillingAccountBillingAccountListData, OrgVendorBillingAccountBillingAccountListErrors, OrgVendorBillingAccountBillingAccountListResponses, OrgVendorBillingAccountPropertiesGetBillingAccountPropertiesData, OrgVendorBillingAccountPropertiesGetBillingAccountPropertiesErrors, OrgVendorBillingAccountPropertiesGetBillingAccountPropertiesResponses, OrgVendorBillingAccountUpdateBillingAccountData, OrgVendorBillingAccountUpdateBillingAccountErrors, OrgVendorBillingAccountUpdateBillingAccountResponses, OrgVendorCreateUpdateData, OrgVendorCreateUpdateErrors, OrgVendorCreateUpdateResponses, OrgVendorGetData, OrgVendorGetErrors, OrgVendorGetResponses, OrgVendorListOrgVendorsData, OrgVendorListOrgVendorsErrors, OrgVendorListOrgVendorsResponses, OrgVendorPropertiesGetPropertiesData, OrgVendorPropertiesGetPropertiesErrors, OrgVendorPropertiesGetPropertiesResponses, OrgVendorServiceAccountGetServiceAccountData, OrgVendorServiceAccountGetServiceAccountErrors, OrgVendorServiceAccountGetServiceAccountResponses, OrgVendorServiceAccountPropertiesGetServiceAccountPropertiesData, OrgVendorServiceAccountPropertiesGetServiceAccountPropertiesErrors, OrgVendorServiceAccountPropertiesGetServiceAccountPropertiesResponses, OrgVendorServiceAccountServiceAccountListData, OrgVendorServiceAccountServiceAccountListErrors, OrgVendorServiceAccountServiceAccountListResponses, OrgVendorServiceAccountUpdateServiceAccountData, OrgVendorServiceAccountUpdateServiceAccountErrors, OrgVendorServiceAccountUpdateServiceAccountResponses, OrgViewCreateViewData, OrgViewCreateViewErrors, OrgViewCreateViewResponses, OrgViewDashboardTemplateInstantiateCreateDashboardFromTemplateData, OrgViewDashboardTemplateInstantiateCreateDashboardFromTemplateErrors, OrgViewDashboardTemplateInstantiateCreateDashboardFromTemplateResponses, OrgViewDashboardTemplateListDashboardTemplateLibraryData, OrgViewDashboardTemplateListDashboardTemplateLibraryErrors, OrgViewDashboardTemplateListDashboardTemplateLibraryResponses, OrgViewDataGetDataData, OrgViewDataGetDataErrors, OrgViewDataGetDataResponses, OrgViewDeleteViewData, OrgViewDeleteViewErrors, OrgViewDeleteViewResponses, OrgViewDuplicateDuplicateViewData, OrgViewDuplicateDuplicateViewErrors, OrgViewDuplicateDuplicateViewResponses, OrgViewFromTemplateCreateFromTemplateData, OrgViewFromTemplateCreateFromTemplateErrors, OrgViewFromTemplateCreateFromTemplateResponses, OrgViewGetViewData, OrgViewGetViewErrors, OrgViewGetViewResponses, OrgViewListViewsData, OrgViewListViewsErrors, OrgViewListViewsResponses, OrgViewTemplateListTemplatesData, OrgViewTemplateListTemplatesErrors, OrgViewTemplateListTemplatesResponses, OrgViewUpdateViewData, OrgViewUpdateViewErrors, OrgViewUpdateViewResponses, PublicDashboardDataGetPublishedDashboardDataData, PublicDashboardDataGetPublishedDashboardDataErrors, PublicDashboardDataGetPublishedDashboardDataResponses, PublicDashboardGetPublishedDashboardData, PublicDashboardGetPublishedDashboardErrors, PublicDashboardGetPublishedDashboardResponses, PublicDashboardTargetsGetPublishedDashboardTargetsData, PublicDashboardTargetsGetPublishedDashboardTargetsErrors, PublicDashboardTargetsGetPublishedDashboardTargetsResponses, PublicProgramFormGetPublicFormData, PublicProgramFormGetPublicFormErrors, PublicProgramFormGetPublicFormResponses, PublicProgramFormSubmissionCreateOrUpdateSubmissionData, PublicProgramFormSubmissionCreateOrUpdateSubmissionErrors, PublicProgramFormSubmissionCreateOrUpdateSubmissionResponses, PublicProgramFormSubmissionGetFormSubmissionByCredentialsData, PublicProgramFormSubmissionGetFormSubmissionByCredentialsErrors, PublicProgramFormSubmissionGetFormSubmissionByCredentialsResponses, PublicProgramFormValidateAccessValidateFormAccessData, PublicProgramFormValidateAccessValidateFormAccessErrors, PublicProgramFormValidateAccessValidateFormAccessResponses, PublicProgramPortalGetPublicPortalData, PublicProgramPortalGetPublicPortalErrors, PublicProgramPortalGetPublicPortalResponses, PublicProgramPortalValidateAccessValidatePortalAccessData, PublicProgramPortalValidateAccessValidatePortalAccessErrors, PublicProgramPortalValidateAccessValidatePortalAccessResponses, PublicTargetSeriesGetSeriesData, PublicTargetSeriesGetSeriesErrors, PublicTargetSeriesGetSeriesResponses, PublicViewDataGetDataData, PublicViewDataGetDataErrors, PublicViewDataGetDataResponses, PublicViewGetViewData, PublicViewGetViewErrors, PublicViewGetViewResponses, RestrictedAccountsListAccountsData, RestrictedAccountsListAccountsErrors, RestrictedAccountsListAccountsResponses, RestrictedAccountsOrgsListAccountOrgsData, RestrictedAccountsOrgsListAccountOrgsErrors, RestrictedAccountsOrgsListAccountOrgsResponses, RestrictedAccountsUpdateAccountData, RestrictedAccountsUpdateAccountErrors, RestrictedAccountsUpdateAccountResponses, RestrictedAccountsUsersListAccountUsersData, RestrictedAccountsUsersListAccountUsersErrors, RestrictedAccountsUsersListAccountUsersResponses, RestrictedAuthzPermissionsCreatePermissionData, RestrictedAuthzPermissionsCreatePermissionErrors, RestrictedAuthzPermissionsCreatePermissionResponses, RestrictedAuthzPermissionsDeletePermissionData, RestrictedAuthzPermissionsDeletePermissionErrors, RestrictedAuthzPermissionsDeletePermissionResponses, RestrictedAuthzPermissionsListPermissionsData, RestrictedAuthzPermissionsListPermissionsErrors, RestrictedAuthzPermissionsListPermissionsResponses, RestrictedAuthzPermissionsUpdatePermissionData, RestrictedAuthzPermissionsUpdatePermissionErrors, RestrictedAuthzPermissionsUpdatePermissionResponses, RestrictedAuthzRolesCreateRoleData, RestrictedAuthzRolesCreateRoleErrors, RestrictedAuthzRolesCreateRoleResponses, RestrictedAuthzRolesDeleteRoleData, RestrictedAuthzRolesDeleteRoleErrors, RestrictedAuthzRolesDeleteRoleResponses, RestrictedAuthzRolesListRolesData, RestrictedAuthzRolesListRolesErrors, RestrictedAuthzRolesListRolesResponses, RestrictedAuthzRolesUpdateRoleData, RestrictedAuthzRolesUpdateRoleErrors, RestrictedAuthzRolesUpdateRoleResponses, RestrictedOrgsGetOrgData, RestrictedOrgsGetOrgErrors, RestrictedOrgsGetOrgResponses, RestrictedOrgsUpdateOrgData, RestrictedOrgsUpdateOrgErrors, RestrictedOrgsUpdateOrgResponses, RestrictedPackageListPackagesData, RestrictedPackageListPackagesErrors, RestrictedPackageListPackagesResponses, RestrictedVendorsCreateVendorData, RestrictedVendorsCreateVendorErrors, RestrictedVendorsCreateVendorResponses, RestrictedVendorsUpdateVendorData, RestrictedVendorsUpdateVendorErrors, RestrictedVendorsUpdateVendorResponses, UserImageGetUserImageData, UserImageGetUserImageErrors, UserImageGetUserImageResponses, UserMeGetData, UserMeGetErrors, UserMeGetResponses, UserNotificationBulkDeleteUserNotificationsData, UserNotificationBulkDeleteUserNotificationsErrors, UserNotificationBulkDeleteUserNotificationsResponses, UserNotificationDeleteUserNotificationData, UserNotificationDeleteUserNotificationErrors, UserNotificationDeleteUserNotificationResponses, UserNotificationGetUserNotificationData, UserNotificationGetUserNotificationErrors, UserNotificationGetUserNotificationResponses, UserNotificationListUserNotificationsData, UserNotificationListUserNotificationsErrors, UserNotificationListUserNotificationsResponses, UserNotificationStatsGetUserNotificationStatsData, UserNotificationStatsGetUserNotificationStatsErrors, UserNotificationStatsGetUserNotificationStatsResponses, UserNotificationUpdateUserNotificationData, UserNotificationUpdateUserNotificationErrors, UserNotificationUpdateUserNotificationResponses, VendorImageGetImageData, VendorImageGetImageErrors, VendorImageGetImageResponses, VendorListData, VendorListErrors, VendorListResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * List Roles
 *
 * List available org user roles in the platform.
 */
export const authzRoleListRoles = <ThrowOnError extends boolean = false>(options?: Options<AuthzRoleListRolesData, ThrowOnError>): RequestResult<AuthzRoleListRolesResponses, AuthzRoleListRolesErrors, ThrowOnError> => (options?.client ?? client).get<AuthzRoleListRolesResponses, AuthzRoleListRolesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/authz/role',
    ...options
});

/**
 * Get
 */
export const configGet = <ThrowOnError extends boolean = false>(options?: Options<ConfigGetData, ThrowOnError>): RequestResult<ConfigGetResponses, ConfigGetErrors, ThrowOnError> => (options?.client ?? client).get<ConfigGetResponses, ConfigGetErrors, ThrowOnError>({
    responseType: 'json',
    url: '/config/',
    ...options
});

/**
 * List Articles
 *
 * List all knowledge base articles with optional filtering.
 */
export const knowledgeBaseListArticles = <ThrowOnError extends boolean = false>(options?: Options<KnowledgeBaseListArticlesData, ThrowOnError>): RequestResult<KnowledgeBaseListArticlesResponses, KnowledgeBaseListArticlesErrors, ThrowOnError> => (options?.client ?? client).get<KnowledgeBaseListArticlesResponses, KnowledgeBaseListArticlesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/knowledge-base/',
    ...options
});

/**
 * Get Article
 *
 * Get a single knowledge base article by ID.
 */
export const knowledgeBaseGetArticle = <ThrowOnError extends boolean = false>(options: Options<KnowledgeBaseGetArticleData, ThrowOnError>): RequestResult<KnowledgeBaseGetArticleResponses, KnowledgeBaseGetArticleErrors, ThrowOnError> => (options.client ?? client).get<KnowledgeBaseGetArticleResponses, KnowledgeBaseGetArticleErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/knowledge-base/{article_id}',
    ...options
});

/**
 * List Topics
 *
 * List all available topic categories.
 */
export const knowledgeBaseTopicsListListTopics = <ThrowOnError extends boolean = false>(options?: Options<KnowledgeBaseTopicsListListTopicsData, ThrowOnError>): RequestResult<KnowledgeBaseTopicsListListTopicsResponses, KnowledgeBaseTopicsListListTopicsErrors, ThrowOnError> => (options?.client ?? client).get<KnowledgeBaseTopicsListListTopicsResponses, KnowledgeBaseTopicsListListTopicsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/knowledge-base/topics/list',
    ...options
});

/**
 * List Roles
 *
 * List all roles
 */
export const restrictedAuthzRolesListRoles = <ThrowOnError extends boolean = false>(options?: Options<RestrictedAuthzRolesListRolesData, ThrowOnError>): RequestResult<RestrictedAuthzRolesListRolesResponses, RestrictedAuthzRolesListRolesErrors, ThrowOnError> => (options?.client ?? client).get<RestrictedAuthzRolesListRolesResponses, RestrictedAuthzRolesListRolesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/restricted/authz/roles',
    ...options
});

/**
 * Create Role
 *
 * Update role
 */
export const restrictedAuthzRolesCreateRole = <ThrowOnError extends boolean = false>(options: Options<RestrictedAuthzRolesCreateRoleData, ThrowOnError>): RequestResult<RestrictedAuthzRolesCreateRoleResponses, RestrictedAuthzRolesCreateRoleErrors, ThrowOnError> => (options.client ?? client).put<RestrictedAuthzRolesCreateRoleResponses, RestrictedAuthzRolesCreateRoleErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/restricted/authz/roles',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Permissions
 *
 * List all permissions
 */
export const restrictedAuthzPermissionsListPermissions = <ThrowOnError extends boolean = false>(options?: Options<RestrictedAuthzPermissionsListPermissionsData, ThrowOnError>): RequestResult<RestrictedAuthzPermissionsListPermissionsResponses, RestrictedAuthzPermissionsListPermissionsErrors, ThrowOnError> => (options?.client ?? client).get<RestrictedAuthzPermissionsListPermissionsResponses, RestrictedAuthzPermissionsListPermissionsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/restricted/authz/permissions',
    ...options
});

/**
 * Create Permission
 *
 * Update permission
 */
export const restrictedAuthzPermissionsCreatePermission = <ThrowOnError extends boolean = false>(options: Options<RestrictedAuthzPermissionsCreatePermissionData, ThrowOnError>): RequestResult<RestrictedAuthzPermissionsCreatePermissionResponses, RestrictedAuthzPermissionsCreatePermissionErrors, ThrowOnError> => (options.client ?? client).put<RestrictedAuthzPermissionsCreatePermissionResponses, RestrictedAuthzPermissionsCreatePermissionErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/restricted/authz/permissions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Role
 *
 * Update role
 */
export const restrictedAuthzRolesDeleteRole = <ThrowOnError extends boolean = false>(options: Options<RestrictedAuthzRolesDeleteRoleData, ThrowOnError>): RequestResult<RestrictedAuthzRolesDeleteRoleResponses, RestrictedAuthzRolesDeleteRoleErrors, ThrowOnError> => (options.client ?? client).delete<RestrictedAuthzRolesDeleteRoleResponses, RestrictedAuthzRolesDeleteRoleErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/restricted/authz/roles/{role_id}',
    ...options
});

/**
 * Update Role
 *
 * Update role
 */
export const restrictedAuthzRolesUpdateRole = <ThrowOnError extends boolean = false>(options: Options<RestrictedAuthzRolesUpdateRoleData, ThrowOnError>): RequestResult<RestrictedAuthzRolesUpdateRoleResponses, RestrictedAuthzRolesUpdateRoleErrors, ThrowOnError> => (options.client ?? client).post<RestrictedAuthzRolesUpdateRoleResponses, RestrictedAuthzRolesUpdateRoleErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/restricted/authz/roles/{role_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Permission
 *
 * Update permission
 */
export const restrictedAuthzPermissionsDeletePermission = <ThrowOnError extends boolean = false>(options: Options<RestrictedAuthzPermissionsDeletePermissionData, ThrowOnError>): RequestResult<RestrictedAuthzPermissionsDeletePermissionResponses, RestrictedAuthzPermissionsDeletePermissionErrors, ThrowOnError> => (options.client ?? client).delete<RestrictedAuthzPermissionsDeletePermissionResponses, RestrictedAuthzPermissionsDeletePermissionErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/restricted/authz/permissions/{permission_id}',
    ...options
});

/**
 * Update Permission
 *
 * Update permission
 */
export const restrictedAuthzPermissionsUpdatePermission = <ThrowOnError extends boolean = false>(options: Options<RestrictedAuthzPermissionsUpdatePermissionData, ThrowOnError>): RequestResult<RestrictedAuthzPermissionsUpdatePermissionResponses, RestrictedAuthzPermissionsUpdatePermissionErrors, ThrowOnError> => (options.client ?? client).post<RestrictedAuthzPermissionsUpdatePermissionResponses, RestrictedAuthzPermissionsUpdatePermissionErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/restricted/authz/permissions/{permission_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Accounts
 */
export const restrictedAccountsListAccounts = <ThrowOnError extends boolean = false>(options?: Options<RestrictedAccountsListAccountsData, ThrowOnError>): RequestResult<RestrictedAccountsListAccountsResponses, RestrictedAccountsListAccountsErrors, ThrowOnError> => (options?.client ?? client).get<RestrictedAccountsListAccountsResponses, RestrictedAccountsListAccountsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/restricted/accounts',
    ...options
});

/**
 * List Account Orgs
 */
export const restrictedAccountsOrgsListAccountOrgs = <ThrowOnError extends boolean = false>(options: Options<RestrictedAccountsOrgsListAccountOrgsData, ThrowOnError>): RequestResult<RestrictedAccountsOrgsListAccountOrgsResponses, RestrictedAccountsOrgsListAccountOrgsErrors, ThrowOnError> => (options.client ?? client).get<RestrictedAccountsOrgsListAccountOrgsResponses, RestrictedAccountsOrgsListAccountOrgsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/restricted/accounts/{account_id}/orgs',
    ...options
});

/**
 * List Account Users
 */
export const restrictedAccountsUsersListAccountUsers = <ThrowOnError extends boolean = false>(options: Options<RestrictedAccountsUsersListAccountUsersData, ThrowOnError>): RequestResult<RestrictedAccountsUsersListAccountUsersResponses, RestrictedAccountsUsersListAccountUsersErrors, ThrowOnError> => (options.client ?? client).get<RestrictedAccountsUsersListAccountUsersResponses, RestrictedAccountsUsersListAccountUsersErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/restricted/accounts/{account_id}/users',
    ...options
});

/**
 * Update Account
 */
export const restrictedAccountsUpdateAccount = <ThrowOnError extends boolean = false>(options: Options<RestrictedAccountsUpdateAccountData, ThrowOnError>): RequestResult<RestrictedAccountsUpdateAccountResponses, RestrictedAccountsUpdateAccountErrors, ThrowOnError> => (options.client ?? client).post<RestrictedAccountsUpdateAccountResponses, RestrictedAccountsUpdateAccountErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/restricted/accounts/{account_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Org
 */
export const restrictedOrgsGetOrg = <ThrowOnError extends boolean = false>(options: Options<RestrictedOrgsGetOrgData, ThrowOnError>): RequestResult<RestrictedOrgsGetOrgResponses, RestrictedOrgsGetOrgErrors, ThrowOnError> => (options.client ?? client).get<RestrictedOrgsGetOrgResponses, RestrictedOrgsGetOrgErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/restricted/orgs/{org_id}',
    ...options
});

/**
 * Update Org
 */
export const restrictedOrgsUpdateOrg = <ThrowOnError extends boolean = false>(options: Options<RestrictedOrgsUpdateOrgData, ThrowOnError>): RequestResult<RestrictedOrgsUpdateOrgResponses, RestrictedOrgsUpdateOrgErrors, ThrowOnError> => (options.client ?? client).post<RestrictedOrgsUpdateOrgResponses, RestrictedOrgsUpdateOrgErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/restricted/orgs/{org_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Vendor
 */
export const restrictedVendorsCreateVendor = <ThrowOnError extends boolean = false>(options: Options<RestrictedVendorsCreateVendorData, ThrowOnError>): RequestResult<RestrictedVendorsCreateVendorResponses, RestrictedVendorsCreateVendorErrors, ThrowOnError> => (options.client ?? client).put<RestrictedVendorsCreateVendorResponses, RestrictedVendorsCreateVendorErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/restricted/vendors',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Vendor
 */
export const restrictedVendorsUpdateVendor = <ThrowOnError extends boolean = false>(options: Options<RestrictedVendorsUpdateVendorData, ThrowOnError>): RequestResult<RestrictedVendorsUpdateVendorResponses, RestrictedVendorsUpdateVendorErrors, ThrowOnError> => (options.client ?? client).patch<RestrictedVendorsUpdateVendorResponses, RestrictedVendorsUpdateVendorErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/restricted/vendors/{vendor_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Packages
 */
export const restrictedPackageListPackages = <ThrowOnError extends boolean = false>(options?: Options<RestrictedPackageListPackagesData, ThrowOnError>): RequestResult<RestrictedPackageListPackagesResponses, RestrictedPackageListPackagesErrors, ThrowOnError> => (options?.client ?? client).get<RestrictedPackageListPackagesResponses, RestrictedPackageListPackagesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/restricted/package',
    ...options
});

/**
 * Get
 */
export const userMeGet = <ThrowOnError extends boolean = false>(options?: Options<UserMeGetData, ThrowOnError>): RequestResult<UserMeGetResponses, UserMeGetErrors, ThrowOnError> => (options?.client ?? client).get<UserMeGetResponses, UserMeGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/user/me',
    ...options
});

/**
 * Get User Image
 *
 * Retrieve the current profile image for a user
 *
 * Any authenticated user should be able to retrieve the profile image of any other user that
 * is part of the same org.
 */
export const userImageGetUserImage = <ThrowOnError extends boolean = false>(options: Options<UserImageGetUserImageData, ThrowOnError>): RequestResult<UserImageGetUserImageResponses, UserImageGetUserImageErrors, ThrowOnError> => (options.client ?? client).get<UserImageGetUserImageResponses, UserImageGetUserImageErrors, ThrowOnError>({
    responseType: 'blob',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/user/{user_id}/image',
    ...options
});

/**
 * Bulk Delete User Notifications
 *
 * Bulk delete notifications for the current user.
 */
export const userNotificationBulkDeleteUserNotifications = <ThrowOnError extends boolean = false>(options?: Options<UserNotificationBulkDeleteUserNotificationsData, ThrowOnError>): RequestResult<UserNotificationBulkDeleteUserNotificationsResponses, UserNotificationBulkDeleteUserNotificationsErrors, ThrowOnError> => (options?.client ?? client).delete<UserNotificationBulkDeleteUserNotificationsResponses, UserNotificationBulkDeleteUserNotificationsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/user/notification/',
    ...options
});

/**
 * List User Notifications
 *
 * List notifications for the current user.
 */
export const userNotificationListUserNotifications = <ThrowOnError extends boolean = false>(options?: Options<UserNotificationListUserNotificationsData, ThrowOnError>): RequestResult<UserNotificationListUserNotificationsResponses, UserNotificationListUserNotificationsErrors, ThrowOnError> => (options?.client ?? client).get<UserNotificationListUserNotificationsResponses, UserNotificationListUserNotificationsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/user/notification/',
    ...options
});

/**
 * Get User Notification Stats
 *
 * Get notification statistics for the current user.
 */
export const userNotificationStatsGetUserNotificationStats = <ThrowOnError extends boolean = false>(options?: Options<UserNotificationStatsGetUserNotificationStatsData, ThrowOnError>): RequestResult<UserNotificationStatsGetUserNotificationStatsResponses, UserNotificationStatsGetUserNotificationStatsErrors, ThrowOnError> => (options?.client ?? client).get<UserNotificationStatsGetUserNotificationStatsResponses, UserNotificationStatsGetUserNotificationStatsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/user/notification/stats',
    ...options
});

/**
 * Delete User Notification
 *
 * Delete (clear) a single notification.
 */
export const userNotificationDeleteUserNotification = <ThrowOnError extends boolean = false>(options: Options<UserNotificationDeleteUserNotificationData, ThrowOnError>): RequestResult<UserNotificationDeleteUserNotificationResponses, UserNotificationDeleteUserNotificationErrors, ThrowOnError> => (options.client ?? client).delete<UserNotificationDeleteUserNotificationResponses, UserNotificationDeleteUserNotificationErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/user/notification/{notification_id}',
    ...options
});

/**
 * Get User Notification
 *
 * Get a single notification by ID.
 */
export const userNotificationGetUserNotification = <ThrowOnError extends boolean = false>(options: Options<UserNotificationGetUserNotificationData, ThrowOnError>): RequestResult<UserNotificationGetUserNotificationResponses, UserNotificationGetUserNotificationErrors, ThrowOnError> => (options.client ?? client).get<UserNotificationGetUserNotificationResponses, UserNotificationGetUserNotificationErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/user/notification/{notification_id}',
    ...options
});

/**
 * Update User Notification
 *
 * Update a notification (mark as read, etc.).
 */
export const userNotificationUpdateUserNotification = <ThrowOnError extends boolean = false>(options: Options<UserNotificationUpdateUserNotificationData, ThrowOnError>): RequestResult<UserNotificationUpdateUserNotificationResponses, UserNotificationUpdateUserNotificationErrors, ThrowOnError> => (options.client ?? client).patch<UserNotificationUpdateUserNotificationResponses, UserNotificationUpdateUserNotificationErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/user/notification/{notification_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List
 */
export const vendorList = <ThrowOnError extends boolean = false>(options?: Options<VendorListData, ThrowOnError>): RequestResult<VendorListResponses, VendorListErrors, ThrowOnError> => (options?.client ?? client).get<VendorListResponses, VendorListErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/vendor/',
    ...options
});

/**
 * Get Image
 *
 * Retrieve the current profile image for an org
 *
 * Any authenticated user should be able to retrieve the profile image of an account that owns an
 * org they're part of.
 */
export const vendorImageGetImage = <ThrowOnError extends boolean = false>(options: Options<VendorImageGetImageData, ThrowOnError>): RequestResult<VendorImageGetImageResponses, VendorImageGetImageErrors, ThrowOnError> => (options.client ?? client).get<VendorImageGetImageResponses, VendorImageGetImageErrors, ThrowOnError>({
    responseType: 'blob',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/vendor/{vendor_id}/image',
    ...options
});

/**
 * List Users
 *
 * Lists all users in account
 */
export const orgAccountUserListUsers = <ThrowOnError extends boolean = false>(options: Options<OrgAccountUserListUsersData, ThrowOnError>): RequestResult<OrgAccountUserListUsersResponses, OrgAccountUserListUsersErrors, ThrowOnError> => (options.client ?? client).get<OrgAccountUserListUsersResponses, OrgAccountUserListUsersErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/account/{account_id}/user',
    ...options
});

/**
 * Delete
 */
export const orgAccountDelete = <ThrowOnError extends boolean = false>(options: Options<OrgAccountDeleteData, ThrowOnError>): RequestResult<OrgAccountDeleteResponses, OrgAccountDeleteErrors, ThrowOnError> => (options.client ?? client).delete<OrgAccountDeleteResponses, OrgAccountDeleteErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/account/{account_id}/',
    ...options
});

/**
 * Update
 */
export const orgAccountUpdate = <ThrowOnError extends boolean = false>(options: Options<OrgAccountUpdateData, ThrowOnError>): RequestResult<OrgAccountUpdateResponses, OrgAccountUpdateErrors, ThrowOnError> => (options.client ?? client).post<OrgAccountUpdateResponses, OrgAccountUpdateErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/account/{account_id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Image
 *
 * Retrieve the current profile image for an account
 *
 * Any authenticated user should be able to retrieve the profile image of an account that owns an
 * org they're part of.
 */
export const orgAccountImageGetImage = <ThrowOnError extends boolean = false>(options: Options<OrgAccountImageGetImageData, ThrowOnError>): RequestResult<OrgAccountImageGetImageResponses, OrgAccountImageGetImageErrors, ThrowOnError> => (options.client ?? client).get<OrgAccountImageGetImageResponses, OrgAccountImageGetImageErrors, ThrowOnError>({
    responseType: 'blob',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/account/{account_id}/image',
    ...options
});

/**
 * Update Image
 */
export const orgAccountImageUpdateImage = <ThrowOnError extends boolean = false>(options: Options<OrgAccountImageUpdateImageData, ThrowOnError>): RequestResult<OrgAccountImageUpdateImageResponses, OrgAccountImageUpdateImageErrors, ThrowOnError> => (options.client ?? client).post<OrgAccountImageUpdateImageResponses, OrgAccountImageUpdateImageErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/account/{account_id}/image',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Bulk Delete Org Alerts
 *
 * Bulk delete alerts for an organization.
 */
export const orgAlertBulkDeleteOrgAlerts = <ThrowOnError extends boolean = false>(options: Options<OrgAlertBulkDeleteOrgAlertsData, ThrowOnError>): RequestResult<OrgAlertBulkDeleteOrgAlertsResponses, OrgAlertBulkDeleteOrgAlertsErrors, ThrowOnError> => (options.client ?? client).delete<OrgAlertBulkDeleteOrgAlertsResponses, OrgAlertBulkDeleteOrgAlertsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/alert/',
    ...options
});

/**
 * List Org Alerts
 *
 * List alerts for an organization.
 */
export const orgAlertListOrgAlerts = <ThrowOnError extends boolean = false>(options: Options<OrgAlertListOrgAlertsData, ThrowOnError>): RequestResult<OrgAlertListOrgAlertsResponses, OrgAlertListOrgAlertsErrors, ThrowOnError> => (options.client ?? client).get<OrgAlertListOrgAlertsResponses, OrgAlertListOrgAlertsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/alert/',
    ...options
});

/**
 * Get Org Alert Stats
 *
 * Get alert statistics for an organization.
 */
export const orgAlertStatsGetOrgAlertStats = <ThrowOnError extends boolean = false>(options: Options<OrgAlertStatsGetOrgAlertStatsData, ThrowOnError>): RequestResult<OrgAlertStatsGetOrgAlertStatsResponses, OrgAlertStatsGetOrgAlertStatsErrors, ThrowOnError> => (options.client ?? client).get<OrgAlertStatsGetOrgAlertStatsResponses, OrgAlertStatsGetOrgAlertStatsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/alert/stats',
    ...options
});

/**
 * Delete Org Alert
 *
 * Delete (clear) a single alert.
 */
export const orgAlertDeleteOrgAlert = <ThrowOnError extends boolean = false>(options: Options<OrgAlertDeleteOrgAlertData, ThrowOnError>): RequestResult<OrgAlertDeleteOrgAlertResponses, OrgAlertDeleteOrgAlertErrors, ThrowOnError> => (options.client ?? client).delete<OrgAlertDeleteOrgAlertResponses, OrgAlertDeleteOrgAlertErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/alert/{alert_id}',
    ...options
});

/**
 * Get Org Alert
 *
 * Get a single alert by ID.
 */
export const orgAlertGetOrgAlert = <ThrowOnError extends boolean = false>(options: Options<OrgAlertGetOrgAlertData, ThrowOnError>): RequestResult<OrgAlertGetOrgAlertResponses, OrgAlertGetOrgAlertErrors, ThrowOnError> => (options.client ?? client).get<OrgAlertGetOrgAlertResponses, OrgAlertGetOrgAlertErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/alert/{alert_id}',
    ...options
});

/**
 * Update Org Alert
 *
 * Update an alert (clear it, etc.).
 */
export const orgAlertUpdateOrgAlert = <ThrowOnError extends boolean = false>(options: Options<OrgAlertUpdateOrgAlertData, ThrowOnError>): RequestResult<OrgAlertUpdateOrgAlertResponses, OrgAlertUpdateOrgAlertErrors, ThrowOnError> => (options.client ?? client).patch<OrgAlertUpdateOrgAlertResponses, OrgAlertUpdateOrgAlertErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/alert/{alert_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Billing Account List
 */
export const orgBillingAccountBillingAccountList = <ThrowOnError extends boolean = false>(options: Options<OrgBillingAccountBillingAccountListData, ThrowOnError>): RequestResult<OrgBillingAccountBillingAccountListResponses, OrgBillingAccountBillingAccountListErrors, ThrowOnError> => (options.client ?? client).get<OrgBillingAccountBillingAccountListResponses, OrgBillingAccountBillingAccountListErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/billing_account/',
    ...options
});

/**
 * Get
 */
export const orgBillingAccountGet = <ThrowOnError extends boolean = false>(options: Options<OrgBillingAccountGetData, ThrowOnError>): RequestResult<OrgBillingAccountGetResponses, OrgBillingAccountGetErrors, ThrowOnError> => (options.client ?? client).get<OrgBillingAccountGetResponses, OrgBillingAccountGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/billing_account/{billing_account_id}',
    ...options
});

/**
 * Get Balance
 *
 * Outstanding balance for a single billing account.
 */
export const orgBillingAccountBalanceGetBalance = <ThrowOnError extends boolean = false>(options: Options<OrgBillingAccountBalanceGetBalanceData, ThrowOnError>): RequestResult<OrgBillingAccountBalanceGetBalanceResponses, OrgBillingAccountBalanceGetBalanceErrors, ThrowOnError> => (options.client ?? client).get<OrgBillingAccountBalanceGetBalanceResponses, OrgBillingAccountBalanceGetBalanceErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/billing_account/{billing_account_id}/balance',
    ...options
});

/**
 * Service Account List
 */
export const orgBillingAccountServiceAccountServiceAccountList = <ThrowOnError extends boolean = false>(options: Options<OrgBillingAccountServiceAccountServiceAccountListData, ThrowOnError>): RequestResult<OrgBillingAccountServiceAccountServiceAccountListResponses, OrgBillingAccountServiceAccountServiceAccountListErrors, ThrowOnError> => (options.client ?? client).get<OrgBillingAccountServiceAccountServiceAccountListResponses, OrgBillingAccountServiceAccountServiceAccountListErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/billing_account/{billing_account_id}/service_account',
    ...options
});

/**
 * List Reference Commodities
 *
 * Get all reference commodities from the global catalog.
 */
export const orgCommodityReferenceListReferenceCommodities = <ThrowOnError extends boolean = false>(options: Options<OrgCommodityReferenceListReferenceCommoditiesData, ThrowOnError>): RequestResult<OrgCommodityReferenceListReferenceCommoditiesResponses, OrgCommodityReferenceListReferenceCommoditiesErrors, ThrowOnError> => (options.client ?? client).get<OrgCommodityReferenceListReferenceCommoditiesResponses, OrgCommodityReferenceListReferenceCommoditiesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/commodity/reference',
    ...options
});

/**
 * List Org Commodities
 *
 * Get organization commodities with merged reference data.
 */
export const orgCommodityListOrgCommodities = <ThrowOnError extends boolean = false>(options: Options<OrgCommodityListOrgCommoditiesData, ThrowOnError>): RequestResult<OrgCommodityListOrgCommoditiesResponses, OrgCommodityListOrgCommoditiesErrors, ThrowOnError> => (options.client ?? client).get<OrgCommodityListOrgCommoditiesResponses, OrgCommodityListOrgCommoditiesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/commodity/',
    ...options
});

/**
 * Create Org Commodity
 *
 * Create a new organization commodity (custom or override).
 */
export const orgCommodityCreateOrgCommodity = <ThrowOnError extends boolean = false>(options: Options<OrgCommodityCreateOrgCommodityData, ThrowOnError>): RequestResult<OrgCommodityCreateOrgCommodityResponses, OrgCommodityCreateOrgCommodityErrors, ThrowOnError> => (options.client ?? client).post<OrgCommodityCreateOrgCommodityResponses, OrgCommodityCreateOrgCommodityErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/commodity/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Org Commodity
 *
 * Delete an organization commodity (only custom or org override rows).
 */
export const orgCommodityDeleteOrgCommodity = <ThrowOnError extends boolean = false>(options: Options<OrgCommodityDeleteOrgCommodityData, ThrowOnError>): RequestResult<OrgCommodityDeleteOrgCommodityResponses, OrgCommodityDeleteOrgCommodityErrors, ThrowOnError> => (options.client ?? client).delete<OrgCommodityDeleteOrgCommodityResponses, OrgCommodityDeleteOrgCommodityErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/commodity/{commodity_id}',
    ...options
});

/**
 * Update Org Commodity
 *
 * Update an existing organization commodity.
 */
export const orgCommodityUpdateOrgCommodity = <ThrowOnError extends boolean = false>(options: Options<OrgCommodityUpdateOrgCommodityData, ThrowOnError>): RequestResult<OrgCommodityUpdateOrgCommodityResponses, OrgCommodityUpdateOrgCommodityErrors, ThrowOnError> => (options.client ?? client).post<OrgCommodityUpdateOrgCommodityResponses, OrgCommodityUpdateOrgCommodityErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/commodity/{commodity_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Org Tracking
 *
 * List all program tracking records for the organization.
 */
export const orgComplianceTrackingListOrgTracking = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceTrackingListOrgTrackingData, ThrowOnError>): RequestResult<OrgComplianceTrackingListOrgTrackingResponses, OrgComplianceTrackingListOrgTrackingErrors, ThrowOnError> => (options.client ?? client).get<OrgComplianceTrackingListOrgTrackingResponses, OrgComplianceTrackingListOrgTrackingErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/compliance/tracking',
    ...options
});

/**
 * Create New Tracking
 *
 * Start tracking a program for one of the org's properties by hand. The program must be one the org can
 * read, or an active PUBLIC program; tracking another org's program confirms the property's match to it,
 * which shares the property's basic details with that org.
 */
export const orgComplianceTrackingCreateNewTracking = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceTrackingCreateNewTrackingData, ThrowOnError>): RequestResult<OrgComplianceTrackingCreateNewTrackingResponses, OrgComplianceTrackingCreateNewTrackingErrors, ThrowOnError> => (options.client ?? client).put<OrgComplianceTrackingCreateNewTrackingResponses, OrgComplianceTrackingCreateNewTrackingErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/compliance/tracking',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Tracking For Property
 *
 * List all program tracking for a specific property.
 */
export const orgComplianceTrackingPropertyListTrackingForProperty = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceTrackingPropertyListTrackingForPropertyData, ThrowOnError>): RequestResult<OrgComplianceTrackingPropertyListTrackingForPropertyResponses, OrgComplianceTrackingPropertyListTrackingForPropertyErrors, ThrowOnError> => (options.client ?? client).get<OrgComplianceTrackingPropertyListTrackingForPropertyResponses, OrgComplianceTrackingPropertyListTrackingForPropertyErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/compliance/tracking/property/{property_id}',
    ...options
});

/**
 * Get Tracking Details
 *
 * Get details of a specific tracking record.
 */
export const orgComplianceTrackingGetTrackingDetails = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceTrackingGetTrackingDetailsData, ThrowOnError>): RequestResult<OrgComplianceTrackingGetTrackingDetailsResponses, OrgComplianceTrackingGetTrackingDetailsErrors, ThrowOnError> => (options.client ?? client).get<OrgComplianceTrackingGetTrackingDetailsResponses, OrgComplianceTrackingGetTrackingDetailsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/compliance/tracking/{tracking_id}',
    ...options
});

/**
 * Update Tracking Details
 *
 * Update a tracking record.
 */
export const orgComplianceTrackingUpdateTrackingDetails = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceTrackingUpdateTrackingDetailsData, ThrowOnError>): RequestResult<OrgComplianceTrackingUpdateTrackingDetailsResponses, OrgComplianceTrackingUpdateTrackingDetailsErrors, ThrowOnError> => (options.client ?? client).patch<OrgComplianceTrackingUpdateTrackingDetailsResponses, OrgComplianceTrackingUpdateTrackingDetailsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/compliance/tracking/{tracking_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Acknowledge Tracking
 *
 * Acknowledge a program tracking record.
 */
export const orgComplianceTrackingAcknowledgeAcknowledgeTracking = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceTrackingAcknowledgeAcknowledgeTrackingData, ThrowOnError>): RequestResult<OrgComplianceTrackingAcknowledgeAcknowledgeTrackingResponses, OrgComplianceTrackingAcknowledgeAcknowledgeTrackingErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceTrackingAcknowledgeAcknowledgeTrackingResponses, OrgComplianceTrackingAcknowledgeAcknowledgeTrackingErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/compliance/tracking/{tracking_id}/acknowledge',
    ...options
});

/**
 * Generate Tasks
 *
 * Generate compliance tasks from program requirements.
 */
export const orgComplianceTrackingGenerateTasksGenerateTasks = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceTrackingGenerateTasksGenerateTasksData, ThrowOnError>): RequestResult<OrgComplianceTrackingGenerateTasksGenerateTasksResponses, OrgComplianceTrackingGenerateTasksGenerateTasksErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceTrackingGenerateTasksGenerateTasksResponses, OrgComplianceTrackingGenerateTasksGenerateTasksErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/compliance/tracking/{tracking_id}/generate-tasks',
    ...options
});

/**
 * List Org Tasks
 *
 * List all compliance tasks for the organization.
 */
export const orgComplianceTasksListOrgTasks = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceTasksListOrgTasksData, ThrowOnError>): RequestResult<OrgComplianceTasksListOrgTasksResponses, OrgComplianceTasksListOrgTasksErrors, ThrowOnError> => (options.client ?? client).get<OrgComplianceTasksListOrgTasksResponses, OrgComplianceTasksListOrgTasksErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/compliance/tasks',
    ...options
});

/**
 * Create New Task
 *
 * Create a new compliance task.
 */
export const orgComplianceTasksCreateNewTask = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceTasksCreateNewTaskData, ThrowOnError>): RequestResult<OrgComplianceTasksCreateNewTaskResponses, OrgComplianceTasksCreateNewTaskErrors, ThrowOnError> => (options.client ?? client).put<OrgComplianceTasksCreateNewTaskResponses, OrgComplianceTasksCreateNewTaskErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/compliance/tasks',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Overdue Tasks
 *
 * List all overdue tasks for the organization.
 */
export const orgComplianceTasksOverdueListOverdueTasks = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceTasksOverdueListOverdueTasksData, ThrowOnError>): RequestResult<OrgComplianceTasksOverdueListOverdueTasksResponses, OrgComplianceTasksOverdueListOverdueTasksErrors, ThrowOnError> => (options.client ?? client).get<OrgComplianceTasksOverdueListOverdueTasksResponses, OrgComplianceTasksOverdueListOverdueTasksErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/compliance/tasks/overdue',
    ...options
});

/**
 * List My Tasks
 *
 * List all tasks assigned to the current user.
 */
export const orgComplianceTasksMyTasksListMyTasks = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceTasksMyTasksListMyTasksData, ThrowOnError>): RequestResult<OrgComplianceTasksMyTasksListMyTasksResponses, OrgComplianceTasksMyTasksListMyTasksErrors, ThrowOnError> => (options.client ?? client).get<OrgComplianceTasksMyTasksListMyTasksResponses, OrgComplianceTasksMyTasksListMyTasksErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/compliance/tasks/my-tasks',
    ...options
});

/**
 * List Tracking Tasks
 *
 * List all tasks for a specific tracking record.
 */
export const orgComplianceTrackingTasksListTrackingTasks = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceTrackingTasksListTrackingTasksData, ThrowOnError>): RequestResult<OrgComplianceTrackingTasksListTrackingTasksResponses, OrgComplianceTrackingTasksListTrackingTasksErrors, ThrowOnError> => (options.client ?? client).get<OrgComplianceTrackingTasksListTrackingTasksResponses, OrgComplianceTrackingTasksListTrackingTasksErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/compliance/tracking/{tracking_id}/tasks',
    ...options
});

/**
 * Delete Task
 *
 * Delete a task.
 */
export const orgComplianceTasksDeleteTask = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceTasksDeleteTaskData, ThrowOnError>): RequestResult<OrgComplianceTasksDeleteTaskResponses, OrgComplianceTasksDeleteTaskErrors, ThrowOnError> => (options.client ?? client).delete<OrgComplianceTasksDeleteTaskResponses, OrgComplianceTasksDeleteTaskErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/compliance/tasks/{task_id}',
    ...options
});

/**
 * Get Task Details
 *
 * Get details of a specific task.
 */
export const orgComplianceTasksGetTaskDetails = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceTasksGetTaskDetailsData, ThrowOnError>): RequestResult<OrgComplianceTasksGetTaskDetailsResponses, OrgComplianceTasksGetTaskDetailsErrors, ThrowOnError> => (options.client ?? client).get<OrgComplianceTasksGetTaskDetailsResponses, OrgComplianceTasksGetTaskDetailsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/compliance/tasks/{task_id}',
    ...options
});

/**
 * Update Task Details
 *
 * Update a task. 409 when completing it while a task it depends on is still open.
 */
export const orgComplianceTasksUpdateTaskDetails = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceTasksUpdateTaskDetailsData, ThrowOnError>): RequestResult<OrgComplianceTasksUpdateTaskDetailsResponses, OrgComplianceTasksUpdateTaskDetailsErrors, ThrowOnError> => (options.client ?? client).patch<OrgComplianceTasksUpdateTaskDetailsResponses, OrgComplianceTasksUpdateTaskDetailsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/compliance/tasks/{task_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Complete Task
 *
 * Mark a task as complete. 409 when a task it depends on is still open.
 */
export const orgComplianceTasksCompleteCompleteTask = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceTasksCompleteCompleteTaskData, ThrowOnError>): RequestResult<OrgComplianceTasksCompleteCompleteTaskResponses, OrgComplianceTasksCompleteCompleteTaskErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceTasksCompleteCompleteTaskResponses, OrgComplianceTasksCompleteCompleteTaskErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/compliance/tasks/{task_id}/complete',
    ...options
});

/**
 * List Tracking Track History
 */
export const orgComplianceTrackingTrackHistoryListTrackingTrackHistory = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceTrackingTrackHistoryListTrackingTrackHistoryData, ThrowOnError>): RequestResult<OrgComplianceTrackingTrackHistoryListTrackingTrackHistoryResponses, OrgComplianceTrackingTrackHistoryListTrackingTrackHistoryErrors, ThrowOnError> => (options.client ?? client).get<OrgComplianceTrackingTrackHistoryListTrackingTrackHistoryResponses, OrgComplianceTrackingTrackHistoryListTrackingTrackHistoryErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/compliance/tracking/{tracking_id}/track-history',
    ...options
});

/**
 * Change Tracking Track
 *
 * Move the tracked property to another track (pathway). Open auto-generated tasks that no longer apply
 * are cancelled and the new track's tasks are generated.
 */
export const orgComplianceTrackingTrackChangeTrackingTrack = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceTrackingTrackChangeTrackingTrackData, ThrowOnError>): RequestResult<OrgComplianceTrackingTrackChangeTrackingTrackResponses, OrgComplianceTrackingTrackChangeTrackingTrackErrors, ThrowOnError> => (options.client ?? client).put<OrgComplianceTrackingTrackChangeTrackingTrackResponses, OrgComplianceTrackingTrackChangeTrackingTrackErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/compliance/tracking/{tracking_id}/track',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Resolve Tracking Review
 *
 * Settle a tracking whose coverage could not be decided automatically (needs_review).
 */
export const orgComplianceTrackingReviewResolveTrackingReview = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceTrackingReviewResolveTrackingReviewData, ThrowOnError>): RequestResult<OrgComplianceTrackingReviewResolveTrackingReviewResponses, OrgComplianceTrackingReviewResolveTrackingReviewErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceTrackingReviewResolveTrackingReviewResponses, OrgComplianceTrackingReviewResolveTrackingReviewErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/compliance/tracking/{tracking_id}/review',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Tracking Events
 */
export const orgComplianceTrackingEventsListTrackingEvents = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceTrackingEventsListTrackingEventsData, ThrowOnError>): RequestResult<OrgComplianceTrackingEventsListTrackingEventsResponses, OrgComplianceTrackingEventsListTrackingEventsErrors, ThrowOnError> => (options.client ?? client).get<OrgComplianceTrackingEventsListTrackingEventsResponses, OrgComplianceTrackingEventsListTrackingEventsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/compliance/tracking/{tracking_id}/events',
    ...options
});

/**
 * Record Tracking Event
 *
 * Record an event (e.g. ownership_change) and create the tasks of the requirements it triggers.
 */
export const orgComplianceTrackingEventsRecordTrackingEvent = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceTrackingEventsRecordTrackingEventData, ThrowOnError>): RequestResult<OrgComplianceTrackingEventsRecordTrackingEventResponses, OrgComplianceTrackingEventsRecordTrackingEventErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceTrackingEventsRecordTrackingEventResponses, OrgComplianceTrackingEventsRecordTrackingEventErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/compliance/tracking/{tracking_id}/events',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Tracking Determinations
 */
export const orgComplianceTrackingDeterminationsListTrackingDeterminations = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceTrackingDeterminationsListTrackingDeterminationsData, ThrowOnError>): RequestResult<OrgComplianceTrackingDeterminationsListTrackingDeterminationsResponses, OrgComplianceTrackingDeterminationsListTrackingDeterminationsErrors, ThrowOnError> => (options.client ?? client).get<OrgComplianceTrackingDeterminationsListTrackingDeterminationsResponses, OrgComplianceTrackingDeterminationsListTrackingDeterminationsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/compliance/tracking/{tracking_id}/determinations',
    ...options
});

/**
 * Create Tracking Determination
 *
 * Record a relief request (or other determination); a request for a program relief starts its
 * decision clock and a reminder task.
 */
export const orgComplianceTrackingDeterminationsCreateTrackingDetermination = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceTrackingDeterminationsCreateTrackingDeterminationData, ThrowOnError>): RequestResult<OrgComplianceTrackingDeterminationsCreateTrackingDeterminationResponses, OrgComplianceTrackingDeterminationsCreateTrackingDeterminationErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceTrackingDeterminationsCreateTrackingDeterminationResponses, OrgComplianceTrackingDeterminationsCreateTrackingDeterminationErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/compliance/tracking/{tracking_id}/determinations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Decide Tracking Determination
 *
 * Record the agency's decision. A grant takes effect on the tracking's tasks (and track).
 */
export const orgComplianceDeterminationsDecisionDecideTrackingDetermination = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceDeterminationsDecisionDecideTrackingDeterminationData, ThrowOnError>): RequestResult<OrgComplianceDeterminationsDecisionDecideTrackingDeterminationResponses, OrgComplianceDeterminationsDecisionDecideTrackingDeterminationErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceDeterminationsDecisionDecideTrackingDeterminationResponses, OrgComplianceDeterminationsDecisionDecideTrackingDeterminationErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/compliance/determinations/{determination_id}/decision',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Tracking Results
 */
export const orgComplianceTrackingResultsListTrackingResults = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceTrackingResultsListTrackingResultsData, ThrowOnError>): RequestResult<OrgComplianceTrackingResultsListTrackingResultsResponses, OrgComplianceTrackingResultsListTrackingResultsErrors, ThrowOnError> => (options.client ?? client).get<OrgComplianceTrackingResultsListTrackingResultsResponses, OrgComplianceTrackingResultsListTrackingResultsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/compliance/tracking/{tracking_id}/results',
    ...options
});

/**
 * Compute Tracking Emissions
 *
 * Compute the property's emissions, limit and estimated penalty for a calendar year.
 */
export const orgComplianceTrackingResultsEmissionsComputeTrackingEmissions = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceTrackingResultsEmissionsComputeTrackingEmissionsData, ThrowOnError>): RequestResult<OrgComplianceTrackingResultsEmissionsComputeTrackingEmissionsResponses, OrgComplianceTrackingResultsEmissionsComputeTrackingEmissionsErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceTrackingResultsEmissionsComputeTrackingEmissionsResponses, OrgComplianceTrackingResultsEmissionsComputeTrackingEmissionsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/compliance/tracking/{tracking_id}/results/emissions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Evaluate Tracking Standard
 *
 * Evaluate whether the building met the standard at the start of the period (DC BEPS Period 1) from
 * its verified annual metrics; optionally release it when it did.
 */
export const orgComplianceTrackingResultsStandardEvaluateTrackingStandard = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceTrackingResultsStandardEvaluateTrackingStandardData, ThrowOnError>): RequestResult<OrgComplianceTrackingResultsStandardEvaluateTrackingStandardResponses, OrgComplianceTrackingResultsStandardEvaluateTrackingStandardErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceTrackingResultsStandardEvaluateTrackingStandardResponses, OrgComplianceTrackingResultsStandardEvaluateTrackingStandardErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/compliance/tracking/{tracking_id}/results/standard',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Tracking Acp Exposure
 *
 * Estimate of the alternative compliance payment for planning (never an invoice).
 */
export const orgComplianceTrackingAcpExposureGetTrackingAcpExposure = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceTrackingAcpExposureGetTrackingAcpExposureData, ThrowOnError>): RequestResult<OrgComplianceTrackingAcpExposureGetTrackingAcpExposureResponses, OrgComplianceTrackingAcpExposureGetTrackingAcpExposureErrors, ThrowOnError> => (options.client ?? client).get<OrgComplianceTrackingAcpExposureGetTrackingAcpExposureResponses, OrgComplianceTrackingAcpExposureGetTrackingAcpExposureErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/compliance/tracking/{tracking_id}/acp-exposure',
    ...options
});

/**
 * Mark Tracking Requirement Satisfied
 *
 * Record that the owner already met a requirement outside Viaduct (owner-attested completion).
 */
export const orgComplianceTrackingRequirementsSatisfiedMarkTrackingRequirementSatisfied = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceTrackingRequirementsSatisfiedMarkTrackingRequirementSatisfiedData, ThrowOnError>): RequestResult<OrgComplianceTrackingRequirementsSatisfiedMarkTrackingRequirementSatisfiedResponses, OrgComplianceTrackingRequirementsSatisfiedMarkTrackingRequirementSatisfiedErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceTrackingRequirementsSatisfiedMarkTrackingRequirementSatisfiedResponses, OrgComplianceTrackingRequirementsSatisfiedMarkTrackingRequirementSatisfiedErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/compliance/tracking/{tracking_id}/requirements/{requirement_id}/satisfied',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Mark Requirement Satisfied For Properties
 *
 * Owner-attested completion of one requirement for many tracked properties (e.g. the LL88 reports an
 * owner filed before tracking them in Viaduct). Properties not tracked in the cycle are skipped.
 */
export const orgComplianceRequirementsSatisfiedMarkRequirementSatisfiedForProperties = <ThrowOnError extends boolean = false>(options: Options<OrgComplianceRequirementsSatisfiedMarkRequirementSatisfiedForPropertiesData, ThrowOnError>): RequestResult<OrgComplianceRequirementsSatisfiedMarkRequirementSatisfiedForPropertiesResponses, OrgComplianceRequirementsSatisfiedMarkRequirementSatisfiedForPropertiesErrors, ThrowOnError> => (options.client ?? client).post<OrgComplianceRequirementsSatisfiedMarkRequirementSatisfiedForPropertiesResponses, OrgComplianceRequirementsSatisfiedMarkRequirementSatisfiedForPropertiesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/compliance/requirements/satisfied',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Property Agency Status
 *
 * The agency's published compliance status for the property (e.g. Philadelphia's Reported / Not
 * Reported lists), from the current versions of agency status lists it was matched to.
 */
export const orgCompliancePropertyAgencyStatusGetPropertyAgencyStatus = <ThrowOnError extends boolean = false>(options: Options<OrgCompliancePropertyAgencyStatusGetPropertyAgencyStatusData, ThrowOnError>): RequestResult<OrgCompliancePropertyAgencyStatusGetPropertyAgencyStatusResponses, OrgCompliancePropertyAgencyStatusGetPropertyAgencyStatusErrors, ThrowOnError> => (options.client ?? client).get<OrgCompliancePropertyAgencyStatusGetPropertyAgencyStatusResponses, OrgCompliancePropertyAgencyStatusGetPropertyAgencyStatusErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/compliance/property/{property_id}/agency-status',
    ...options
});

/**
 * List Coverage Lists
 *
 * Lists owned by the org and by the platform.
 */
export const orgCoverageListListCoverageLists = <ThrowOnError extends boolean = false>(options: Options<OrgCoverageListListCoverageListsData, ThrowOnError>): RequestResult<OrgCoverageListListCoverageListsResponses, OrgCoverageListListCoverageListsErrors, ThrowOnError> => (options.client ?? client).get<OrgCoverageListListCoverageListsResponses, OrgCoverageListListCoverageListsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/coverage-list',
    ...options
});

/**
 * List Coverage List Anomalies
 */
export const orgCoverageListAnomaliesListCoverageListAnomalies = <ThrowOnError extends boolean = false>(options: Options<OrgCoverageListAnomaliesListCoverageListAnomaliesData, ThrowOnError>): RequestResult<OrgCoverageListAnomaliesListCoverageListAnomaliesResponses, OrgCoverageListAnomaliesListCoverageListAnomaliesErrors, ThrowOnError> => (options.client ?? client).get<OrgCoverageListAnomaliesListCoverageListAnomaliesResponses, OrgCoverageListAnomaliesListCoverageListAnomaliesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/coverage-list/{list_id}/anomalies',
    ...options
});

/**
 * List Coverage List Matches
 *
 * The org's properties matched to the list (and the ambiguous ones, with their candidate rows).
 */
export const orgCoverageListMatchesListCoverageListMatches = <ThrowOnError extends boolean = false>(options: Options<OrgCoverageListMatchesListCoverageListMatchesData, ThrowOnError>): RequestResult<OrgCoverageListMatchesListCoverageListMatchesResponses, OrgCoverageListMatchesListCoverageListMatchesErrors, ThrowOnError> => (options.client ?? client).get<OrgCoverageListMatchesListCoverageListMatchesResponses, OrgCoverageListMatchesListCoverageListMatchesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/coverage-list/{list_id}/matches',
    ...options
});

/**
 * Match Coverage List
 *
 * Match the org's properties to the current version of a list. A matched row is evidence for the
 * property's match to every active program whose flag marks the row: new matches are proposed to the org,
 * and properties already tracked in such a program take the row's track. Ambiguous rows are recorded, never
 * resolved; identifiers are never written onto properties. A dry run reports the outcome and writes
 * nothing.
 */
export const orgCoverageListMatchMatchCoverageList = <ThrowOnError extends boolean = false>(options: Options<OrgCoverageListMatchMatchCoverageListData, ThrowOnError>): RequestResult<OrgCoverageListMatchMatchCoverageListResponses, OrgCoverageListMatchMatchCoverageListErrors, ThrowOnError> => (options.client ?? client).post<OrgCoverageListMatchMatchCoverageListResponses, OrgCoverageListMatchMatchCoverageListErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/coverage-list/match',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Dashboards
 */
export const orgDashboardListDashboards = <ThrowOnError extends boolean = false>(options: Options<OrgDashboardListDashboardsData, ThrowOnError>): RequestResult<OrgDashboardListDashboardsResponses, OrgDashboardListDashboardsErrors, ThrowOnError> => (options.client ?? client).get<OrgDashboardListDashboardsResponses, OrgDashboardListDashboardsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/dashboard/',
    ...options
});

/**
 * Create Dashboard
 */
export const orgDashboardCreateDashboard = <ThrowOnError extends boolean = false>(options: Options<OrgDashboardCreateDashboardData, ThrowOnError>): RequestResult<OrgDashboardCreateDashboardResponses, OrgDashboardCreateDashboardErrors, ThrowOnError> => (options.client ?? client).put<OrgDashboardCreateDashboardResponses, OrgDashboardCreateDashboardErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/dashboard/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Dashboard
 */
export const orgDashboardDeleteDashboard = <ThrowOnError extends boolean = false>(options: Options<OrgDashboardDeleteDashboardData, ThrowOnError>): RequestResult<OrgDashboardDeleteDashboardResponses, OrgDashboardDeleteDashboardErrors, ThrowOnError> => (options.client ?? client).delete<OrgDashboardDeleteDashboardResponses, OrgDashboardDeleteDashboardErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/dashboard/{dashboard_id}',
    ...options
});

/**
 * Get Dashboard
 */
export const orgDashboardGetDashboard = <ThrowOnError extends boolean = false>(options: Options<OrgDashboardGetDashboardData, ThrowOnError>): RequestResult<OrgDashboardGetDashboardResponses, OrgDashboardGetDashboardErrors, ThrowOnError> => (options.client ?? client).get<OrgDashboardGetDashboardResponses, OrgDashboardGetDashboardErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/dashboard/{dashboard_id}',
    ...options
});

/**
 * Update Dashboard
 */
export const orgDashboardUpdateDashboard = <ThrowOnError extends boolean = false>(options: Options<OrgDashboardUpdateDashboardData, ThrowOnError>): RequestResult<OrgDashboardUpdateDashboardResponses, OrgDashboardUpdateDashboardErrors, ThrowOnError> => (options.client ?? client).patch<OrgDashboardUpdateDashboardResponses, OrgDashboardUpdateDashboardErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/dashboard/{dashboard_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Dashboard Data
 *
 * Batch-execute every data-bearing block's view.
 *
 * Returns `{block_index_string: QueryResult}`. Static (text) blocks are
 * omitted so the renderer can skip them. The optional body carries the
 * dynamic filter overlay from the dashboard's filter panel.
 */
export const orgDashboardDataGetDashboardData = <ThrowOnError extends boolean = false>(options: Options<OrgDashboardDataGetDashboardDataData, ThrowOnError>): RequestResult<OrgDashboardDataGetDashboardDataResponses, OrgDashboardDataGetDashboardDataErrors, ThrowOnError> => (options.client ?? client).post<OrgDashboardDataGetDashboardDataResponses, OrgDashboardDataGetDashboardDataErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/dashboard/{dashboard_id}/data',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Duplicate Dashboard
 *
 * Create a new personal dashboard that's an independent copy of an existing one.
 *
 * Personal (non-shared) views referenced by the source dashboard are also
 * duplicated so the new dashboard is fully self-contained. Shared views
 * are passed through by reference and remain shared.
 */
export const orgDashboardDuplicateDuplicateDashboard = <ThrowOnError extends boolean = false>(options: Options<OrgDashboardDuplicateDuplicateDashboardData, ThrowOnError>): RequestResult<OrgDashboardDuplicateDuplicateDashboardResponses, OrgDashboardDuplicateDuplicateDashboardErrors, ThrowOnError> => (options.client ?? client).post<OrgDashboardDuplicateDuplicateDashboardResponses, OrgDashboardDuplicateDuplicateDashboardErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/dashboard/{dashboard_id}/duplicate',
    ...options
});

/**
 * List
 */
export const orgDepartmentList = <ThrowOnError extends boolean = false>(options: Options<OrgDepartmentListData, ThrowOnError>): RequestResult<OrgDepartmentListResponses, OrgDepartmentListErrors, ThrowOnError> => (options.client ?? client).get<OrgDepartmentListResponses, OrgDepartmentListErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/department/',
    ...options
});

/**
 * Create
 */
export const orgDepartmentCreate = <ThrowOnError extends boolean = false>(options: Options<OrgDepartmentCreateData, ThrowOnError>): RequestResult<OrgDepartmentCreateResponses, OrgDepartmentCreateErrors, ThrowOnError> => (options.client ?? client).post<OrgDepartmentCreateResponses, OrgDepartmentCreateErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/department/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get
 */
export const orgDepartmentGet = <ThrowOnError extends boolean = false>(options: Options<OrgDepartmentGetData, ThrowOnError>): RequestResult<OrgDepartmentGetResponses, OrgDepartmentGetErrors, ThrowOnError> => (options.client ?? client).get<OrgDepartmentGetResponses, OrgDepartmentGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/department/{department_id}',
    ...options
});

/**
 * Update
 */
export const orgDepartmentUpdate = <ThrowOnError extends boolean = false>(options: Options<OrgDepartmentUpdateData, ThrowOnError>): RequestResult<OrgDepartmentUpdateResponses, OrgDepartmentUpdateErrors, ThrowOnError> => (options.client ?? client).post<OrgDepartmentUpdateResponses, OrgDepartmentUpdateErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/department/{department_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Files
 *
 * List all files visible to this user
 */
export const orgFileGetFiles = <ThrowOnError extends boolean = false>(options: Options<OrgFileGetFilesData, ThrowOnError>): RequestResult<OrgFileGetFilesResponses, OrgFileGetFilesErrors, ThrowOnError> => (options.client ?? client).get<OrgFileGetFilesResponses, OrgFileGetFilesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/file/',
    ...options
});

/**
 * Upload Files
 */
export const orgFileUploadFiles = <ThrowOnError extends boolean = false>(options: Options<OrgFileUploadFilesData, ThrowOnError>): RequestResult<OrgFileUploadFilesResponses, OrgFileUploadFilesErrors, ThrowOnError> => (options.client ?? client).post<OrgFileUploadFilesResponses, OrgFileUploadFilesErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/file/',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Get File Set
 *
 * List all files in this file set
 */
export const orgFileGetFileSet = <ThrowOnError extends boolean = false>(options: Options<OrgFileGetFileSetData, ThrowOnError>): RequestResult<OrgFileGetFileSetResponses, OrgFileGetFileSetErrors, ThrowOnError> => (options.client ?? client).get<OrgFileGetFileSetResponses, OrgFileGetFileSetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/file/{file_set_id}',
    ...options
});

/**
 * Get File Contents
 */
export const orgFileContentsGetFileContents = <ThrowOnError extends boolean = false>(options: Options<OrgFileContentsGetFileContentsData, ThrowOnError>): RequestResult<OrgFileContentsGetFileContentsResponses, OrgFileContentsGetFileContentsErrors, ThrowOnError> => (options.client ?? client).get<OrgFileContentsGetFileContentsResponses, OrgFileContentsGetFileContentsErrors, ThrowOnError>({
    responseType: 'blob',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/file/contents/{file_id}',
    ...options
});

/**
 * List
 */
export const orgIngestJobList = <ThrowOnError extends boolean = false>(options: Options<OrgIngestJobListData, ThrowOnError>): RequestResult<OrgIngestJobListResponses, OrgIngestJobListErrors, ThrowOnError> => (options.client ?? client).get<OrgIngestJobListResponses, OrgIngestJobListErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/ingest_job/',
    ...options
});

/**
 * Create
 */
export const orgIngestJobCreate = <ThrowOnError extends boolean = false>(options: Options<OrgIngestJobCreateData, ThrowOnError>): RequestResult<OrgIngestJobCreateResponses, OrgIngestJobCreateErrors, ThrowOnError> => (options.client ?? client).put<OrgIngestJobCreateResponses, OrgIngestJobCreateErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/ingest_job/',
    ...options
});

/**
 * Get
 */
export const orgIngestJobGet = <ThrowOnError extends boolean = false>(options: Options<OrgIngestJobGetData, ThrowOnError>): RequestResult<OrgIngestJobGetResponses, OrgIngestJobGetErrors, ThrowOnError> => (options.client ?? client).get<OrgIngestJobGetResponses, OrgIngestJobGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/ingest_job/{ingest_job_id}',
    ...options
});

/**
 * Update
 */
export const orgIngestJobUpdate = <ThrowOnError extends boolean = false>(options: Options<OrgIngestJobUpdateData, ThrowOnError>): RequestResult<OrgIngestJobUpdateResponses, OrgIngestJobUpdateErrors, ThrowOnError> => (options.client ?? client).patch<OrgIngestJobUpdateResponses, OrgIngestJobUpdateErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/ingest_job/{ingest_job_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Initiatives
 *
 * List all initiatives for the current organization.
 */
export const orgInitiativesListInitiatives = <ThrowOnError extends boolean = false>(options: Options<OrgInitiativesListInitiativesData, ThrowOnError>): RequestResult<OrgInitiativesListInitiativesResponses, OrgInitiativesListInitiativesErrors, ThrowOnError> => (options.client ?? client).get<OrgInitiativesListInitiativesResponses, OrgInitiativesListInitiativesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/initiatives/',
    ...options
});

/**
 * Create New Initiative
 *
 * Create a new initiative.
 */
export const orgInitiativesCreateNewInitiative = <ThrowOnError extends boolean = false>(options: Options<OrgInitiativesCreateNewInitiativeData, ThrowOnError>): RequestResult<OrgInitiativesCreateNewInitiativeResponses, OrgInitiativesCreateNewInitiativeErrors, ThrowOnError> => (options.client ?? client).put<OrgInitiativesCreateNewInitiativeResponses, OrgInitiativesCreateNewInitiativeErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/initiatives/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Initiative Endpoint
 *
 * Soft delete an initiative.
 */
export const orgInitiativesDeleteInitiativeEndpoint = <ThrowOnError extends boolean = false>(options: Options<OrgInitiativesDeleteInitiativeEndpointData, ThrowOnError>): RequestResult<OrgInitiativesDeleteInitiativeEndpointResponses, OrgInitiativesDeleteInitiativeEndpointErrors, ThrowOnError> => (options.client ?? client).delete<OrgInitiativesDeleteInitiativeEndpointResponses, OrgInitiativesDeleteInitiativeEndpointErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/initiatives/{initiative_id}',
    ...options
});

/**
 * Get Initiative Details
 *
 * Get detailed information about a specific initiative.
 */
export const orgInitiativesGetInitiativeDetails = <ThrowOnError extends boolean = false>(options: Options<OrgInitiativesGetInitiativeDetailsData, ThrowOnError>): RequestResult<OrgInitiativesGetInitiativeDetailsResponses, OrgInitiativesGetInitiativeDetailsErrors, ThrowOnError> => (options.client ?? client).get<OrgInitiativesGetInitiativeDetailsResponses, OrgInitiativesGetInitiativeDetailsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/initiatives/{initiative_id}',
    ...options
});

/**
 * Update Initiative Details
 *
 * Update an existing initiative.
 */
export const orgInitiativesUpdateInitiativeDetails = <ThrowOnError extends boolean = false>(options: Options<OrgInitiativesUpdateInitiativeDetailsData, ThrowOnError>): RequestResult<OrgInitiativesUpdateInitiativeDetailsResponses, OrgInitiativesUpdateInitiativeDetailsErrors, ThrowOnError> => (options.client ?? client).patch<OrgInitiativesUpdateInitiativeDetailsResponses, OrgInitiativesUpdateInitiativeDetailsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/initiatives/{initiative_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Initiative Task
 *
 * Create a new task for an initiative.
 */
export const orgInitiativesTasksCreateInitiativeTask = <ThrowOnError extends boolean = false>(options: Options<OrgInitiativesTasksCreateInitiativeTaskData, ThrowOnError>): RequestResult<OrgInitiativesTasksCreateInitiativeTaskResponses, OrgInitiativesTasksCreateInitiativeTaskErrors, ThrowOnError> => (options.client ?? client).post<OrgInitiativesTasksCreateInitiativeTaskResponses, OrgInitiativesTasksCreateInitiativeTaskErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/initiatives/{initiative_id}/tasks',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Initiative Task
 *
 * Delete a task.
 */
export const orgInitiativesTasksDeleteInitiativeTask = <ThrowOnError extends boolean = false>(options: Options<OrgInitiativesTasksDeleteInitiativeTaskData, ThrowOnError>): RequestResult<OrgInitiativesTasksDeleteInitiativeTaskResponses, OrgInitiativesTasksDeleteInitiativeTaskErrors, ThrowOnError> => (options.client ?? client).delete<OrgInitiativesTasksDeleteInitiativeTaskResponses, OrgInitiativesTasksDeleteInitiativeTaskErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/initiatives/{initiative_id}/tasks/{task_id}',
    ...options
});

/**
 * Update Initiative Task
 *
 * Update an existing task.
 */
export const orgInitiativesTasksUpdateInitiativeTask = <ThrowOnError extends boolean = false>(options: Options<OrgInitiativesTasksUpdateInitiativeTaskData, ThrowOnError>): RequestResult<OrgInitiativesTasksUpdateInitiativeTaskResponses, OrgInitiativesTasksUpdateInitiativeTaskErrors, ThrowOnError> => (options.client ?? client).patch<OrgInitiativesTasksUpdateInitiativeTaskResponses, OrgInitiativesTasksUpdateInitiativeTaskErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/initiatives/{initiative_id}/tasks/{task_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Complete Initiative Task
 *
 * Mark a task as complete.
 */
export const orgInitiativesTasksCompleteCompleteInitiativeTask = <ThrowOnError extends boolean = false>(options: Options<OrgInitiativesTasksCompleteCompleteInitiativeTaskData, ThrowOnError>): RequestResult<OrgInitiativesTasksCompleteCompleteInitiativeTaskResponses, OrgInitiativesTasksCompleteCompleteInitiativeTaskErrors, ThrowOnError> => (options.client ?? client).post<OrgInitiativesTasksCompleteCompleteInitiativeTaskResponses, OrgInitiativesTasksCompleteCompleteInitiativeTaskErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/initiatives/{initiative_id}/tasks/{task_id}/complete',
    ...options
});

/**
 * Create Initiative Milestone
 *
 * Create a new milestone for an initiative.
 */
export const orgInitiativesMilestonesCreateInitiativeMilestone = <ThrowOnError extends boolean = false>(options: Options<OrgInitiativesMilestonesCreateInitiativeMilestoneData, ThrowOnError>): RequestResult<OrgInitiativesMilestonesCreateInitiativeMilestoneResponses, OrgInitiativesMilestonesCreateInitiativeMilestoneErrors, ThrowOnError> => (options.client ?? client).post<OrgInitiativesMilestonesCreateInitiativeMilestoneResponses, OrgInitiativesMilestonesCreateInitiativeMilestoneErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/initiatives/{initiative_id}/milestones',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Initiative Milestone
 *
 * Update an existing milestone.
 */
export const orgInitiativesMilestonesUpdateInitiativeMilestone = <ThrowOnError extends boolean = false>(options: Options<OrgInitiativesMilestonesUpdateInitiativeMilestoneData, ThrowOnError>): RequestResult<OrgInitiativesMilestonesUpdateInitiativeMilestoneResponses, OrgInitiativesMilestonesUpdateInitiativeMilestoneErrors, ThrowOnError> => (options.client ?? client).patch<OrgInitiativesMilestonesUpdateInitiativeMilestoneResponses, OrgInitiativesMilestonesUpdateInitiativeMilestoneErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/initiatives/{initiative_id}/milestones/{milestone_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Complete Initiative Milestone
 *
 * Mark a milestone as complete.
 */
export const orgInitiativesMilestonesCompleteCompleteInitiativeMilestone = <ThrowOnError extends boolean = false>(options: Options<OrgInitiativesMilestonesCompleteCompleteInitiativeMilestoneData, ThrowOnError>): RequestResult<OrgInitiativesMilestonesCompleteCompleteInitiativeMilestoneResponses, OrgInitiativesMilestonesCompleteCompleteInitiativeMilestoneErrors, ThrowOnError> => (options.client ?? client).post<OrgInitiativesMilestonesCompleteCompleteInitiativeMilestoneResponses, OrgInitiativesMilestonesCompleteCompleteInitiativeMilestoneErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/initiatives/{initiative_id}/milestones/{milestone_id}/complete',
    ...options
});

/**
 * Add Initiative Impact
 *
 * Add an impact metric to an initiative, task, or milestone.
 */
export const orgInitiativesImpactsAddInitiativeImpact = <ThrowOnError extends boolean = false>(options: Options<OrgInitiativesImpactsAddInitiativeImpactData, ThrowOnError>): RequestResult<OrgInitiativesImpactsAddInitiativeImpactResponses, OrgInitiativesImpactsAddInitiativeImpactErrors, ThrowOnError> => (options.client ?? client).post<OrgInitiativesImpactsAddInitiativeImpactResponses, OrgInitiativesImpactsAddInitiativeImpactErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/initiatives/{initiative_id}/impacts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Initiative Progress
 *
 * Get calculated progress and impact data for an initiative.
 */
export const orgInitiativesProgressGetInitiativeProgress = <ThrowOnError extends boolean = false>(options: Options<OrgInitiativesProgressGetInitiativeProgressData, ThrowOnError>): RequestResult<OrgInitiativesProgressGetInitiativeProgressResponses, OrgInitiativesProgressGetInitiativeProgressErrors, ThrowOnError> => (options.client ?? client).get<OrgInitiativesProgressGetInitiativeProgressResponses, OrgInitiativesProgressGetInitiativeProgressErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/initiatives/{initiative_id}/progress',
    ...options
});

/**
 * Get Summary
 *
 * Get insights summary for the current org
 */
export const orgInsightsGetSummary = <ThrowOnError extends boolean = false>(options: Options<OrgInsightsGetSummaryData, ThrowOnError>): RequestResult<OrgInsightsGetSummaryResponses, OrgInsightsGetSummaryErrors, ThrowOnError> => (options.client ?? client).get<OrgInsightsGetSummaryResponses, OrgInsightsGetSummaryErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/insights/',
    ...options
});

/**
 * Get Missing Issues
 *
 * Get missing data issues for the current org
 */
export const orgInsightsMissingGetMissingIssues = <ThrowOnError extends boolean = false>(options: Options<OrgInsightsMissingGetMissingIssuesData, ThrowOnError>): RequestResult<OrgInsightsMissingGetMissingIssuesResponses, OrgInsightsMissingGetMissingIssuesErrors, ThrowOnError> => (options.client ?? client).get<OrgInsightsMissingGetMissingIssuesResponses, OrgInsightsMissingGetMissingIssuesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/insights/missing',
    ...options
});

/**
 * Get Incorrect Issues
 *
 * Get incorrect data issues for the current org
 */
export const orgInsightsIncorrectGetIncorrectIssues = <ThrowOnError extends boolean = false>(options: Options<OrgInsightsIncorrectGetIncorrectIssuesData, ThrowOnError>): RequestResult<OrgInsightsIncorrectGetIncorrectIssuesResponses, OrgInsightsIncorrectGetIncorrectIssuesErrors, ThrowOnError> => (options.client ?? client).get<OrgInsightsIncorrectGetIncorrectIssuesResponses, OrgInsightsIncorrectGetIncorrectIssuesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/insights/incorrect',
    ...options
});

/**
 * Get Duplicate Issues
 *
 * Get duplicate data issues for the current org
 */
export const orgInsightsDuplicatesGetDuplicateIssues = <ThrowOnError extends boolean = false>(options: Options<OrgInsightsDuplicatesGetDuplicateIssuesData, ThrowOnError>): RequestResult<OrgInsightsDuplicatesGetDuplicateIssuesResponses, OrgInsightsDuplicatesGetDuplicateIssuesErrors, ThrowOnError> => (options.client ?? client).get<OrgInsightsDuplicatesGetDuplicateIssuesResponses, OrgInsightsDuplicatesGetDuplicateIssuesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/insights/duplicates',
    ...options
});

/**
 * List Org Integrations
 *
 * List all vendors in the current org
 */
export const orgIntegrationListOrgIntegrations = <ThrowOnError extends boolean = false>(options: Options<OrgIntegrationListOrgIntegrationsData, ThrowOnError>): RequestResult<OrgIntegrationListOrgIntegrationsResponses, OrgIntegrationListOrgIntegrationsErrors, ThrowOnError> => (options.client ?? client).get<OrgIntegrationListOrgIntegrationsResponses, OrgIntegrationListOrgIntegrationsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/integration/',
    ...options
});

/**
 * Get Image
 *
 * Retrieve the current profile image for an org
 *
 * Any authenticated user should be able to retrieve the profile image of an account that owns an
 * org they're part of.
 */
export const orgIntegrationImageGetImage = <ThrowOnError extends boolean = false>(options: Options<OrgIntegrationImageGetImageData, ThrowOnError>): RequestResult<OrgIntegrationImageGetImageResponses, OrgIntegrationImageGetImageErrors, ThrowOnError> => (options.client ?? client).get<OrgIntegrationImageGetImageResponses, OrgIntegrationImageGetImageErrors, ThrowOnError>({
    responseType: 'blob',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/integration/{integration_id}/image',
    ...options
});

/**
 * List Invitations
 */
export const orgInvitationListInvitations = <ThrowOnError extends boolean = false>(options: Options<OrgInvitationListInvitationsData, ThrowOnError>): RequestResult<OrgInvitationListInvitationsResponses, OrgInvitationListInvitationsErrors, ThrowOnError> => (options.client ?? client).get<OrgInvitationListInvitationsResponses, OrgInvitationListInvitationsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/invitation/',
    ...options
});

/**
 * Create
 */
export const orgInvitationCreate = <ThrowOnError extends boolean = false>(options: Options<OrgInvitationCreateData, ThrowOnError>): RequestResult<OrgInvitationCreateResponses, OrgInvitationCreateErrors, ThrowOnError> => (options.client ?? client).post<OrgInvitationCreateResponses, OrgInvitationCreateErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/invitation/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Read
 */
export const orgInvitationRead = <ThrowOnError extends boolean = false>(options: Options<OrgInvitationReadData, ThrowOnError>): RequestResult<OrgInvitationReadResponses, OrgInvitationReadErrors, ThrowOnError> => (options.client ?? client).get<OrgInvitationReadResponses, OrgInvitationReadErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/invitation/{invitation_id}',
    ...options
});

/**
 * Update
 */
export const orgInvitationUpdate = <ThrowOnError extends boolean = false>(options: Options<OrgInvitationUpdateData, ThrowOnError>): RequestResult<OrgInvitationUpdateResponses, OrgInvitationUpdateErrors, ThrowOnError> => (options.client ?? client).patch<OrgInvitationUpdateResponses, OrgInvitationUpdateErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/invitation/{invitation_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lookup Bounds
 */
export const orgJurisdictionBoundsLookupBounds = <ThrowOnError extends boolean = false>(options: Options<OrgJurisdictionBoundsLookupBoundsData, ThrowOnError>): RequestResult<OrgJurisdictionBoundsLookupBoundsResponses, OrgJurisdictionBoundsLookupBoundsErrors, ThrowOnError> => (options.client ?? client).get<OrgJurisdictionBoundsLookupBoundsResponses, OrgJurisdictionBoundsLookupBoundsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/jurisdiction/bounds',
    ...options
});

/**
 * List Jurisdictions
 *
 * Get the jurisdictions for the current organization.
 */
export const orgJurisdictionListJurisdictions = <ThrowOnError extends boolean = false>(options: Options<OrgJurisdictionListJurisdictionsData, ThrowOnError>): RequestResult<OrgJurisdictionListJurisdictionsResponses, OrgJurisdictionListJurisdictionsErrors, ThrowOnError> => (options.client ?? client).get<OrgJurisdictionListJurisdictionsResponses, OrgJurisdictionListJurisdictionsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/jurisdiction/',
    ...options
});

/**
 * Create Org Jurisdiction
 *
 * Create a jurisdiction for the current organization.
 */
export const orgJurisdictionCreateOrgJurisdiction = <ThrowOnError extends boolean = false>(options: Options<OrgJurisdictionCreateOrgJurisdictionData, ThrowOnError>): RequestResult<OrgJurisdictionCreateOrgJurisdictionResponses, OrgJurisdictionCreateOrgJurisdictionErrors, ThrowOnError> => (options.client ?? client).put<OrgJurisdictionCreateOrgJurisdictionResponses, OrgJurisdictionCreateOrgJurisdictionErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/jurisdiction/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Deactivate Jurisdiction Endpoint
 *
 * Deactivate a jurisdiction.
 */
export const orgJurisdictionDeactivateJurisdictionEndpoint = <ThrowOnError extends boolean = false>(options: Options<OrgJurisdictionDeactivateJurisdictionEndpointData, ThrowOnError>): RequestResult<OrgJurisdictionDeactivateJurisdictionEndpointResponses, OrgJurisdictionDeactivateJurisdictionEndpointErrors, ThrowOnError> => (options.client ?? client).delete<OrgJurisdictionDeactivateJurisdictionEndpointResponses, OrgJurisdictionDeactivateJurisdictionEndpointErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/jurisdiction/{jurisdiction_id}',
    ...options
});

/**
 * Get Jurisdiction Details
 *
 * Get details of a specific jurisdiction.
 */
export const orgJurisdictionGetJurisdictionDetails = <ThrowOnError extends boolean = false>(options: Options<OrgJurisdictionGetJurisdictionDetailsData, ThrowOnError>): RequestResult<OrgJurisdictionGetJurisdictionDetailsResponses, OrgJurisdictionGetJurisdictionDetailsErrors, ThrowOnError> => (options.client ?? client).get<OrgJurisdictionGetJurisdictionDetailsResponses, OrgJurisdictionGetJurisdictionDetailsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/jurisdiction/{jurisdiction_id}',
    ...options
});

/**
 * Update Jurisdiction Details
 *
 * Update a jurisdiction.
 */
export const orgJurisdictionUpdateJurisdictionDetails = <ThrowOnError extends boolean = false>(options: Options<OrgJurisdictionUpdateJurisdictionDetailsData, ThrowOnError>): RequestResult<OrgJurisdictionUpdateJurisdictionDetailsResponses, OrgJurisdictionUpdateJurisdictionDetailsErrors, ThrowOnError> => (options.client ?? client).patch<OrgJurisdictionUpdateJurisdictionDetailsResponses, OrgJurisdictionUpdateJurisdictionDetailsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/jurisdiction/{jurisdiction_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Upload Boundary File
 *
 * Upload a geospatial file for use in jurisdiction boundary definition.
 *
 * Supports GeoJSON, Shapefile, and KML/KMZ formats.
 */
export const orgJurisdictionUploadBoundaryUploadBoundaryFile = <ThrowOnError extends boolean = false>(options: Options<OrgJurisdictionUploadBoundaryUploadBoundaryFileData, ThrowOnError>): RequestResult<OrgJurisdictionUploadBoundaryUploadBoundaryFileResponses, OrgJurisdictionUploadBoundaryUploadBoundaryFileErrors, ThrowOnError> => (options.client ?? client).post<OrgJurisdictionUploadBoundaryUploadBoundaryFileResponses, OrgJurisdictionUploadBoundaryUploadBoundaryFileErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/jurisdiction/upload-boundary',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * List Meters
 *
 * List meters for the current organization
 */
export const orgMeterListMeters = <ThrowOnError extends boolean = false>(options: Options<OrgMeterListMetersData, ThrowOnError>): RequestResult<OrgMeterListMetersResponses, OrgMeterListMetersErrors, ThrowOnError> => (options.client ?? client).get<OrgMeterListMetersResponses, OrgMeterListMetersErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/meter/',
    ...options
});

/**
 * Create Meter
 *
 * Update a meter's properties
 */
export const orgMeterCreateMeter = <ThrowOnError extends boolean = false>(options: Options<OrgMeterCreateMeterData, ThrowOnError>): RequestResult<OrgMeterCreateMeterResponses, OrgMeterCreateMeterErrors, ThrowOnError> => (options.client ?? client).post<OrgMeterCreateMeterResponses, OrgMeterCreateMeterErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/meter/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Meter
 *
 * Delete (deactivate) a meter
 */
export const orgMeterDeleteMeter = <ThrowOnError extends boolean = false>(options: Options<OrgMeterDeleteMeterData, ThrowOnError>): RequestResult<OrgMeterDeleteMeterResponses, OrgMeterDeleteMeterErrors, ThrowOnError> => (options.client ?? client).delete<OrgMeterDeleteMeterResponses, OrgMeterDeleteMeterErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/meter/{meter_id}',
    ...options
});

/**
 * Get Meter
 *
 * Get details about a specific meter
 */
export const orgMeterGetMeter = <ThrowOnError extends boolean = false>(options: Options<OrgMeterGetMeterData, ThrowOnError>): RequestResult<OrgMeterGetMeterResponses, OrgMeterGetMeterErrors, ThrowOnError> => (options.client ?? client).get<OrgMeterGetMeterResponses, OrgMeterGetMeterErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/meter/{meter_id}',
    ...options
});

/**
 * Update Meter
 *
 * Update a meter's properties
 */
export const orgMeterUpdateMeter = <ThrowOnError extends boolean = false>(options: Options<OrgMeterUpdateMeterData, ThrowOnError>): RequestResult<OrgMeterUpdateMeterResponses, OrgMeterUpdateMeterErrors, ThrowOnError> => (options.client ?? client).patch<OrgMeterUpdateMeterResponses, OrgMeterUpdateMeterErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/meter/{meter_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Capabilities
 */
export const orgMeterCapabilityListCapabilities = <ThrowOnError extends boolean = false>(options: Options<OrgMeterCapabilityListCapabilitiesData, ThrowOnError>): RequestResult<OrgMeterCapabilityListCapabilitiesResponses, OrgMeterCapabilityListCapabilitiesErrors, ThrowOnError> => (options.client ?? client).get<OrgMeterCapabilityListCapabilitiesResponses, OrgMeterCapabilityListCapabilitiesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/meter/{meter_id}/capability/',
    ...options
});

/**
 * Add Capability
 */
export const orgMeterCapabilityAddCapability = <ThrowOnError extends boolean = false>(options: Options<OrgMeterCapabilityAddCapabilityData, ThrowOnError>): RequestResult<OrgMeterCapabilityAddCapabilityResponses, OrgMeterCapabilityAddCapabilityErrors, ThrowOnError> => (options.client ?? client).put<OrgMeterCapabilityAddCapabilityResponses, OrgMeterCapabilityAddCapabilityErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/meter/{meter_id}/capability/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Capability
 */
export const orgMeterCapabilityRemoveCapability = <ThrowOnError extends boolean = false>(options: Options<OrgMeterCapabilityRemoveCapabilityData, ThrowOnError>): RequestResult<OrgMeterCapabilityRemoveCapabilityResponses, OrgMeterCapabilityRemoveCapabilityErrors, ThrowOnError> => (options.client ?? client).delete<OrgMeterCapabilityRemoveCapabilityResponses, OrgMeterCapabilityRemoveCapabilityErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/meter/{meter_id}/capability/{capability_id}',
    ...options
});

/**
 * Get Capability
 */
export const orgMeterCapabilityGetCapability = <ThrowOnError extends boolean = false>(options: Options<OrgMeterCapabilityGetCapabilityData, ThrowOnError>): RequestResult<OrgMeterCapabilityGetCapabilityResponses, OrgMeterCapabilityGetCapabilityErrors, ThrowOnError> => (options.client ?? client).get<OrgMeterCapabilityGetCapabilityResponses, OrgMeterCapabilityGetCapabilityErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/meter/{meter_id}/capability/{capability_id}',
    ...options
});

/**
 * Update Capability
 */
export const orgMeterCapabilityUpdateCapability = <ThrowOnError extends boolean = false>(options: Options<OrgMeterCapabilityUpdateCapabilityData, ThrowOnError>): RequestResult<OrgMeterCapabilityUpdateCapabilityResponses, OrgMeterCapabilityUpdateCapabilityErrors, ThrowOnError> => (options.client ?? client).post<OrgMeterCapabilityUpdateCapabilityResponses, OrgMeterCapabilityUpdateCapabilityErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/meter/{meter_id}/capability/{capability_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Readings
 */
export const orgMeterReadingListReadings = <ThrowOnError extends boolean = false>(options: Options<OrgMeterReadingListReadingsData, ThrowOnError>): RequestResult<OrgMeterReadingListReadingsResponses, OrgMeterReadingListReadingsErrors, ThrowOnError> => (options.client ?? client).get<OrgMeterReadingListReadingsResponses, OrgMeterReadingListReadingsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/meter/{meter_id}/reading/',
    ...options
});

/**
 * Create Reading
 */
export const orgMeterReadingCreateReading = <ThrowOnError extends boolean = false>(options: Options<OrgMeterReadingCreateReadingData, ThrowOnError>): RequestResult<OrgMeterReadingCreateReadingResponses, OrgMeterReadingCreateReadingErrors, ThrowOnError> => (options.client ?? client).put<OrgMeterReadingCreateReadingResponses, OrgMeterReadingCreateReadingErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/meter/{meter_id}/reading/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Reading
 */
export const orgMeterReadingDeleteReading = <ThrowOnError extends boolean = false>(options: Options<OrgMeterReadingDeleteReadingData, ThrowOnError>): RequestResult<OrgMeterReadingDeleteReadingResponses, OrgMeterReadingDeleteReadingErrors, ThrowOnError> => (options.client ?? client).delete<OrgMeterReadingDeleteReadingResponses, OrgMeterReadingDeleteReadingErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/meter/{meter_id}/reading/{reading_id}',
    ...options
});

/**
 * Get Reading
 */
export const orgMeterReadingGetReading = <ThrowOnError extends boolean = false>(options: Options<OrgMeterReadingGetReadingData, ThrowOnError>): RequestResult<OrgMeterReadingGetReadingResponses, OrgMeterReadingGetReadingErrors, ThrowOnError> => (options.client ?? client).get<OrgMeterReadingGetReadingResponses, OrgMeterReadingGetReadingErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/meter/{meter_id}/reading/{reading_id}',
    ...options
});

/**
 * Update Reading
 */
export const orgMeterReadingUpdateReading = <ThrowOnError extends boolean = false>(options: Options<OrgMeterReadingUpdateReadingData, ThrowOnError>): RequestResult<OrgMeterReadingUpdateReadingResponses, OrgMeterReadingUpdateReadingErrors, ThrowOnError> => (options.client ?? client).post<OrgMeterReadingUpdateReadingResponses, OrgMeterReadingUpdateReadingErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/meter/{meter_id}/reading/{reading_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Channels
 *
 * Which of this meter's channels carry interval data, and over what window.
 */
export const orgMeterIntervalChannelsListChannels = <ThrowOnError extends boolean = false>(options: Options<OrgMeterIntervalChannelsListChannelsData, ThrowOnError>): RequestResult<OrgMeterIntervalChannelsListChannelsResponses, OrgMeterIntervalChannelsListChannelsErrors, ThrowOnError> => (options.client ?? client).get<OrgMeterIntervalChannelsListChannelsResponses, OrgMeterIntervalChannelsListChannelsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/meter/{meter_id}/interval/channels',
    ...options
});

/**
 * Get Interval Series
 *
 * Interval readings for one channel, downsampled to fit.
 *
 * `grain=auto` picks the finest grain whose result stays under `max_points`
 * and reports which one it used. This endpoint deliberately has no
 * "give me everything" mode: a year of 15-minute data is ~35,000 points per
 * channel, which no chart can draw and no browser should receive. Use the
 * async export path for bulk extraction.
 */
export const orgMeterIntervalGetIntervalSeries = <ThrowOnError extends boolean = false>(options: Options<OrgMeterIntervalGetIntervalSeriesData, ThrowOnError>): RequestResult<OrgMeterIntervalGetIntervalSeriesResponses, OrgMeterIntervalGetIntervalSeriesErrors, ThrowOnError> => (options.client ?? client).get<OrgMeterIntervalGetIntervalSeriesResponses, OrgMeterIntervalGetIntervalSeriesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/meter/{meter_id}/interval/',
    ...options
});

/**
 * Get Interval Summary
 *
 * Peak, baseload, load factor and coverage for one channel over a window.
 */
export const orgMeterIntervalSummaryGetIntervalSummary = <ThrowOnError extends boolean = false>(options: Options<OrgMeterIntervalSummaryGetIntervalSummaryData, ThrowOnError>): RequestResult<OrgMeterIntervalSummaryGetIntervalSummaryResponses, OrgMeterIntervalSummaryGetIntervalSummaryErrors, ThrowOnError> => (options.client ?? client).get<OrgMeterIntervalSummaryGetIntervalSummaryResponses, OrgMeterIntervalSummaryGetIntervalSummaryErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/meter/{meter_id}/interval/summary',
    ...options
});

/**
 * Push Interval Batch
 *
 * Push readings for one channel.
 *
 * For gateways, BMS exports and ETL jobs that have no file to upload. Goes
 * through the same normalize/upsert path as file ingest, so it inherits the
 * same guarantees: re-pushing a window is a no-op, and an estimated reading
 * never overwrites a stored actual one.
 */
export const orgMeterIntervalBatchPushIntervalBatch = <ThrowOnError extends boolean = false>(options: Options<OrgMeterIntervalBatchPushIntervalBatchData, ThrowOnError>): RequestResult<OrgMeterIntervalBatchPushIntervalBatchResponses, OrgMeterIntervalBatchPushIntervalBatchErrors, ThrowOnError> => (options.client ?? client).post<OrgMeterIntervalBatchPushIntervalBatchResponses, OrgMeterIntervalBatchPushIntervalBatchErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/meter/{meter_id}/interval/batch',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Meter Measure Types
 */
export const orgMeterMeasureTypeListMeterMeasureTypes = <ThrowOnError extends boolean = false>(options: Options<OrgMeterMeasureTypeListMeterMeasureTypesData, ThrowOnError>): RequestResult<OrgMeterMeasureTypeListMeterMeasureTypesResponses, OrgMeterMeasureTypeListMeterMeasureTypesErrors, ThrowOnError> => (options.client ?? client).get<OrgMeterMeasureTypeListMeterMeasureTypesResponses, OrgMeterMeasureTypeListMeterMeasureTypesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/meter-measure-type/',
    ...options
});

/**
 * List Meter Types
 */
export const orgMeterTypeListMeterTypes = <ThrowOnError extends boolean = false>(options: Options<OrgMeterTypeListMeterTypesData, ThrowOnError>): RequestResult<OrgMeterTypeListMeterTypesResponses, OrgMeterTypeListMeterTypesErrors, ThrowOnError> => (options.client ?? client).get<OrgMeterTypeListMeterTypesResponses, OrgMeterTypeListMeterTypesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/meter-type/',
    ...options
});

/**
 * Get
 */
export const orgUserMeGet = <ThrowOnError extends boolean = false>(options: Options<OrgUserMeGetData, ThrowOnError>): RequestResult<OrgUserMeGetResponses, OrgUserMeGetErrors, ThrowOnError> => (options.client ?? client).get<OrgUserMeGetResponses, OrgUserMeGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/user/me',
    ...options
});

/**
 * List Users
 *
 * Lists all
 */
export const orgUserListUsers = <ThrowOnError extends boolean = false>(options: Options<OrgUserListUsersData, ThrowOnError>): RequestResult<OrgUserListUsersResponses, OrgUserListUsersErrors, ThrowOnError> => (options.client ?? client).get<OrgUserListUsersResponses, OrgUserListUsersErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/user/',
    ...options
});

/**
 * Create
 */
export const orgUserCreate = <ThrowOnError extends boolean = false>(options: Options<OrgUserCreateData, ThrowOnError>): RequestResult<OrgUserCreateResponses, OrgUserCreateErrors, ThrowOnError> => (options.client ?? client).post<OrgUserCreateResponses, OrgUserCreateErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/user/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete User
 */
export const orgUserDeleteUser = <ThrowOnError extends boolean = false>(options: Options<OrgUserDeleteUserData, ThrowOnError>): RequestResult<OrgUserDeleteUserResponses, OrgUserDeleteUserErrors, ThrowOnError> => (options.client ?? client).delete<OrgUserDeleteUserResponses, OrgUserDeleteUserErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/user/{user_id}',
    ...options
});

/**
 * Update User
 */
export const orgUserUpdateUser = <ThrowOnError extends boolean = false>(options: Options<OrgUserUpdateUserData, ThrowOnError>): RequestResult<OrgUserUpdateUserResponses, OrgUserUpdateUserErrors, ThrowOnError> => (options.client ?? client).post<OrgUserUpdateUserResponses, OrgUserUpdateUserErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/user/{user_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Image
 */
export const orgUserImageUpdateImage = <ThrowOnError extends boolean = false>(options: Options<OrgUserImageUpdateImageData, ThrowOnError>): RequestResult<OrgUserImageUpdateImageResponses, OrgUserImageUpdateImageErrors, ThrowOnError> => (options.client ?? client).post<OrgUserImageUpdateImageResponses, OrgUserImageUpdateImageErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/user/{user_id}/image',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * List Org Vendors
 *
 * List all vendors in the current org
 */
export const orgVendorListOrgVendors = <ThrowOnError extends boolean = false>(options: Options<OrgVendorListOrgVendorsData, ThrowOnError>): RequestResult<OrgVendorListOrgVendorsResponses, OrgVendorListOrgVendorsErrors, ThrowOnError> => (options.client ?? client).get<OrgVendorListOrgVendorsResponses, OrgVendorListOrgVendorsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/vendor/',
    ...options
});

/**
 * Get
 *
 * Get details about a specific vendor in the current org
 */
export const orgVendorGet = <ThrowOnError extends boolean = false>(options: Options<OrgVendorGetData, ThrowOnError>): RequestResult<OrgVendorGetResponses, OrgVendorGetErrors, ThrowOnError> => (options.client ?? client).get<OrgVendorGetResponses, OrgVendorGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/vendor/{vendor_id}',
    ...options
});

/**
 * Create Update
 */
export const orgVendorCreateUpdate = <ThrowOnError extends boolean = false>(options: Options<OrgVendorCreateUpdateData, ThrowOnError>): RequestResult<OrgVendorCreateUpdateResponses, OrgVendorCreateUpdateErrors, ThrowOnError> => (options.client ?? client).post<OrgVendorCreateUpdateResponses, OrgVendorCreateUpdateErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/vendor/{vendor_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Balance
 *
 * Outstanding balance for the current org's relationship with this vendor.
 */
export const orgVendorBalanceGetBalance = <ThrowOnError extends boolean = false>(options: Options<OrgVendorBalanceGetBalanceData, ThrowOnError>): RequestResult<OrgVendorBalanceGetBalanceResponses, OrgVendorBalanceGetBalanceErrors, ThrowOnError> => (options.client ?? client).get<OrgVendorBalanceGetBalanceResponses, OrgVendorBalanceGetBalanceErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/vendor/{vendor_id}/balance',
    ...options
});

/**
 * Get Properties
 */
export const orgVendorPropertiesGetProperties = <ThrowOnError extends boolean = false>(options: Options<OrgVendorPropertiesGetPropertiesData, ThrowOnError>): RequestResult<OrgVendorPropertiesGetPropertiesResponses, OrgVendorPropertiesGetPropertiesErrors, ThrowOnError> => (options.client ?? client).get<OrgVendorPropertiesGetPropertiesResponses, OrgVendorPropertiesGetPropertiesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/vendor/{vendor_id}/properties',
    ...options
});

/**
 * Billing Account List
 */
export const orgVendorBillingAccountBillingAccountList = <ThrowOnError extends boolean = false>(options: Options<OrgVendorBillingAccountBillingAccountListData, ThrowOnError>): RequestResult<OrgVendorBillingAccountBillingAccountListResponses, OrgVendorBillingAccountBillingAccountListErrors, ThrowOnError> => (options.client ?? client).get<OrgVendorBillingAccountBillingAccountListResponses, OrgVendorBillingAccountBillingAccountListErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/vendor/{vendor_id}/billing_account',
    ...options
});

/**
 * Update Billing Account
 */
export const orgVendorBillingAccountUpdateBillingAccount = <ThrowOnError extends boolean = false>(options: Options<OrgVendorBillingAccountUpdateBillingAccountData, ThrowOnError>): RequestResult<OrgVendorBillingAccountUpdateBillingAccountResponses, OrgVendorBillingAccountUpdateBillingAccountErrors, ThrowOnError> => (options.client ?? client).post<OrgVendorBillingAccountUpdateBillingAccountResponses, OrgVendorBillingAccountUpdateBillingAccountErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/vendor/{vendor_id}/billing_account/{billing_account_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Service Account List
 */
export const orgVendorServiceAccountServiceAccountList = <ThrowOnError extends boolean = false>(options: Options<OrgVendorServiceAccountServiceAccountListData, ThrowOnError>): RequestResult<OrgVendorServiceAccountServiceAccountListResponses, OrgVendorServiceAccountServiceAccountListErrors, ThrowOnError> => (options.client ?? client).get<OrgVendorServiceAccountServiceAccountListResponses, OrgVendorServiceAccountServiceAccountListErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/vendor/{vendor_id}/service_account',
    ...options
});

/**
 * Get Billing Account Properties
 */
export const orgVendorBillingAccountPropertiesGetBillingAccountProperties = <ThrowOnError extends boolean = false>(options: Options<OrgVendorBillingAccountPropertiesGetBillingAccountPropertiesData, ThrowOnError>): RequestResult<OrgVendorBillingAccountPropertiesGetBillingAccountPropertiesResponses, OrgVendorBillingAccountPropertiesGetBillingAccountPropertiesErrors, ThrowOnError> => (options.client ?? client).get<OrgVendorBillingAccountPropertiesGetBillingAccountPropertiesResponses, OrgVendorBillingAccountPropertiesGetBillingAccountPropertiesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/vendor/{vendor_id}/billing_account/{billing_account_id}/properties',
    ...options
});

/**
 * Get Service Account
 */
export const orgVendorServiceAccountGetServiceAccount = <ThrowOnError extends boolean = false>(options: Options<OrgVendorServiceAccountGetServiceAccountData, ThrowOnError>): RequestResult<OrgVendorServiceAccountGetServiceAccountResponses, OrgVendorServiceAccountGetServiceAccountErrors, ThrowOnError> => (options.client ?? client).get<OrgVendorServiceAccountGetServiceAccountResponses, OrgVendorServiceAccountGetServiceAccountErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/vendor/{vendor_id}/service_account/{service_account_id}',
    ...options
});

/**
 * Update Service Account
 */
export const orgVendorServiceAccountUpdateServiceAccount = <ThrowOnError extends boolean = false>(options: Options<OrgVendorServiceAccountUpdateServiceAccountData, ThrowOnError>): RequestResult<OrgVendorServiceAccountUpdateServiceAccountResponses, OrgVendorServiceAccountUpdateServiceAccountErrors, ThrowOnError> => (options.client ?? client).post<OrgVendorServiceAccountUpdateServiceAccountResponses, OrgVendorServiceAccountUpdateServiceAccountErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/vendor/{vendor_id}/service_account/{service_account_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Service Account Properties
 */
export const orgVendorServiceAccountPropertiesGetServiceAccountProperties = <ThrowOnError extends boolean = false>(options: Options<OrgVendorServiceAccountPropertiesGetServiceAccountPropertiesData, ThrowOnError>): RequestResult<OrgVendorServiceAccountPropertiesGetServiceAccountPropertiesResponses, OrgVendorServiceAccountPropertiesGetServiceAccountPropertiesErrors, ThrowOnError> => (options.client ?? client).get<OrgVendorServiceAccountPropertiesGetServiceAccountPropertiesResponses, OrgVendorServiceAccountPropertiesGetServiceAccountPropertiesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/vendor/{vendor_id}/service_account/{service_account_id}/properties',
    ...options
});

/**
 * List Orgs
 */
export const orgListListOrgs = <ThrowOnError extends boolean = false>(options: Options<OrgListListOrgsData, ThrowOnError>): RequestResult<OrgListListOrgsResponses, OrgListListOrgsErrors, ThrowOnError> => (options.client ?? client).get<OrgListListOrgsResponses, OrgListListOrgsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/list',
    ...options
});

/**
 * Update
 */
export const orgUpdate = <ThrowOnError extends boolean = false>(options: Options<OrgUpdateData, ThrowOnError>): RequestResult<OrgUpdateResponses, OrgUpdateErrors, ThrowOnError> => (options.client ?? client).post<OrgUpdateResponses, OrgUpdateErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Org Image
 *
 * Retrieve the current profile image for an org
 *
 * Any authenticated user should be able to retrieve the profile image of any org
 */
export const orgImageGetOrgImage = <ThrowOnError extends boolean = false>(options: Options<OrgImageGetOrgImageData, ThrowOnError>): RequestResult<OrgImageGetOrgImageResponses, OrgImageGetOrgImageErrors, ThrowOnError> => (options.client ?? client).get<OrgImageGetOrgImageResponses, OrgImageGetOrgImageErrors, ThrowOnError>({
    responseType: 'blob',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/image',
    ...options
});

/**
 * Update Image
 */
export const orgImageUpdateImage = <ThrowOnError extends boolean = false>(options: Options<OrgImageUpdateImageData, ThrowOnError>): RequestResult<OrgImageUpdateImageResponses, OrgImageUpdateImageErrors, ThrowOnError> => (options.client ?? client).post<OrgImageUpdateImageResponses, OrgImageUpdateImageErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/image',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Get Digest
 */
export const orgDigestGetDigest = <ThrowOnError extends boolean = false>(options: Options<OrgDigestGetDigestData, ThrowOnError>): RequestResult<OrgDigestGetDigestResponses, OrgDigestGetDigestErrors, ThrowOnError> => (options.client ?? client).get<OrgDigestGetDigestResponses, OrgDigestGetDigestErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/digest',
    ...options
});

/**
 * List Payments
 *
 * List payments for the current org, optionally filtered by allocation or date.
 */
export const orgPaymentListPayments = <ThrowOnError extends boolean = false>(options: Options<OrgPaymentListPaymentsData, ThrowOnError>): RequestResult<OrgPaymentListPaymentsResponses, OrgPaymentListPaymentsErrors, ThrowOnError> => (options.client ?? client).get<OrgPaymentListPaymentsResponses, OrgPaymentListPaymentsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/payment/',
    ...options
});

/**
 * Create
 *
 * Record a payment.
 *
 * Allocation rules: ``billing_account_id`` is required. Setting
 * ``service_account_id``, ``statement_id``, or ``statement_service_details_id``
 * further narrows the allocation. A ``statement_service_details_id`` requires
 * a matching ``statement_id`` and ``service_account_id``.
 */
export const orgPaymentCreate = <ThrowOnError extends boolean = false>(options: Options<OrgPaymentCreateData, ThrowOnError>): RequestResult<OrgPaymentCreateResponses, OrgPaymentCreateErrors, ThrowOnError> => (options.client ?? client).post<OrgPaymentCreateResponses, OrgPaymentCreateErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/payment/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Org Balance
 *
 * Org-wide outstanding balance summed across all billing accounts.
 */
export const orgPaymentBalanceGetOrgBalance = <ThrowOnError extends boolean = false>(options: Options<OrgPaymentBalanceGetOrgBalanceData, ThrowOnError>): RequestResult<OrgPaymentBalanceGetOrgBalanceResponses, OrgPaymentBalanceGetOrgBalanceErrors, ThrowOnError> => (options.client ?? client).get<OrgPaymentBalanceGetOrgBalanceResponses, OrgPaymentBalanceGetOrgBalanceErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/payment/balance',
    ...options
});

/**
 * List Upcoming
 *
 * Statements with money still owed, ordered by due date.
 *
 * Due date is computed as ``statement_date + 30 days`` (no explicit field
 * exists on statements today). Past-due statements are included by default.
 */
export const orgPaymentUpcomingListUpcoming = <ThrowOnError extends boolean = false>(options: Options<OrgPaymentUpcomingListUpcomingData, ThrowOnError>): RequestResult<OrgPaymentUpcomingListUpcomingResponses, OrgPaymentUpcomingListUpcomingErrors, ThrowOnError> => (options.client ?? client).get<OrgPaymentUpcomingListUpcomingResponses, OrgPaymentUpcomingListUpcomingErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/payment/upcoming',
    ...options
});

/**
 * Delete
 *
 * Delete a payment.
 */
export const orgPaymentDelete = <ThrowOnError extends boolean = false>(options: Options<OrgPaymentDeleteData, ThrowOnError>): RequestResult<OrgPaymentDeleteResponses, OrgPaymentDeleteErrors, ThrowOnError> => (options.client ?? client).delete<OrgPaymentDeleteResponses, OrgPaymentDeleteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/payment/{payment_id}',
    ...options
});

/**
 * Update
 *
 * Update a payment. Editing a parser-imported payment marks it as user-managed.
 */
export const orgPaymentUpdate = <ThrowOnError extends boolean = false>(options: Options<OrgPaymentUpdateData, ThrowOnError>): RequestResult<OrgPaymentUpdateResponses, OrgPaymentUpdateErrors, ThrowOnError> => (options.client ?? client).patch<OrgPaymentUpdateResponses, OrgPaymentUpdateErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/payment/{payment_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List All Programs
 */
export const orgProgramListAllPrograms = <ThrowOnError extends boolean = false>(options: Options<OrgProgramListAllProgramsData, ThrowOnError>): RequestResult<OrgProgramListAllProgramsResponses, OrgProgramListAllProgramsErrors, ThrowOnError> => (options.client ?? client).get<OrgProgramListAllProgramsResponses, OrgProgramListAllProgramsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/',
    ...options
});

/**
 * Create New Program
 */
export const orgProgramCreateNewProgram = <ThrowOnError extends boolean = false>(options: Options<OrgProgramCreateNewProgramData, ThrowOnError>): RequestResult<OrgProgramCreateNewProgramResponses, OrgProgramCreateNewProgramErrors, ThrowOnError> => (options.client ?? client).put<OrgProgramCreateNewProgramResponses, OrgProgramCreateNewProgramErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Program
 */
export const orgProgramDeleteProgram = <ThrowOnError extends boolean = false>(options: Options<OrgProgramDeleteProgramData, ThrowOnError>): RequestResult<OrgProgramDeleteProgramResponses, OrgProgramDeleteProgramErrors, ThrowOnError> => (options.client ?? client).delete<OrgProgramDeleteProgramResponses, OrgProgramDeleteProgramErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}',
    ...options
});

/**
 * Get Program Details
 */
export const orgProgramGetProgramDetails = <ThrowOnError extends boolean = false>(options: Options<OrgProgramGetProgramDetailsData, ThrowOnError>): RequestResult<OrgProgramGetProgramDetailsResponses, OrgProgramGetProgramDetailsErrors, ThrowOnError> => (options.client ?? client).get<OrgProgramGetProgramDetailsResponses, OrgProgramGetProgramDetailsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}',
    ...options
});

/**
 * Update Program Details
 */
export const orgProgramUpdateProgramDetails = <ThrowOnError extends boolean = false>(options: Options<OrgProgramUpdateProgramDetailsData, ThrowOnError>): RequestResult<OrgProgramUpdateProgramDetailsResponses, OrgProgramUpdateProgramDetailsErrors, ThrowOnError> => (options.client ?? client).patch<OrgProgramUpdateProgramDetailsResponses, OrgProgramUpdateProgramDetailsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Set Program Status
 *
 * Set the program's status. Properties are matched to a program only while it is ACTIVE (with an
 * ACTIVE cycle): activating it proposes it to the orgs of matching properties (in the background), and
 * any other status withdraws its open proposals.
 */
export const orgProgramStatusSetProgramStatus = <ThrowOnError extends boolean = false>(options: Options<OrgProgramStatusSetProgramStatusData, ThrowOnError>): RequestResult<OrgProgramStatusSetProgramStatusResponses, OrgProgramStatusSetProgramStatusErrors, ThrowOnError> => (options.client ?? client).post<OrgProgramStatusSetProgramStatusResponses, OrgProgramStatusSetProgramStatusErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Program Cycles
 */
export const orgProgramCyclesListProgramCycles = <ThrowOnError extends boolean = false>(options: Options<OrgProgramCyclesListProgramCyclesData, ThrowOnError>): RequestResult<OrgProgramCyclesListProgramCyclesResponses, OrgProgramCyclesListProgramCyclesErrors, ThrowOnError> => (options.client ?? client).get<OrgProgramCyclesListProgramCyclesResponses, OrgProgramCyclesListProgramCyclesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/cycles',
    ...options
});

/**
 * Create Program Cycle
 */
export const orgProgramCyclesCreateProgramCycle = <ThrowOnError extends boolean = false>(options: Options<OrgProgramCyclesCreateProgramCycleData, ThrowOnError>): RequestResult<OrgProgramCyclesCreateProgramCycleResponses, OrgProgramCyclesCreateProgramCycleErrors, ThrowOnError> => (options.client ?? client).post<OrgProgramCyclesCreateProgramCycleResponses, OrgProgramCyclesCreateProgramCycleErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/cycles',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Latest Cycle
 */
export const orgProgramCyclesLatestGetLatestCycle = <ThrowOnError extends boolean = false>(options: Options<OrgProgramCyclesLatestGetLatestCycleData, ThrowOnError>): RequestResult<OrgProgramCyclesLatestGetLatestCycleResponses, OrgProgramCyclesLatestGetLatestCycleErrors, ThrowOnError> => (options.client ?? client).get<OrgProgramCyclesLatestGetLatestCycleResponses, OrgProgramCyclesLatestGetLatestCycleErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/cycles/latest',
    ...options
});

/**
 * Get Cycle
 */
export const orgProgramCyclesGetCycle = <ThrowOnError extends boolean = false>(options: Options<OrgProgramCyclesGetCycleData, ThrowOnError>): RequestResult<OrgProgramCyclesGetCycleResponses, OrgProgramCyclesGetCycleErrors, ThrowOnError> => (options.client ?? client).get<OrgProgramCyclesGetCycleResponses, OrgProgramCyclesGetCycleErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}',
    ...options
});

/**
 * Update Program Cycle
 */
export const orgProgramCyclesUpdateProgramCycle = <ThrowOnError extends boolean = false>(options: Options<OrgProgramCyclesUpdateProgramCycleData, ThrowOnError>): RequestResult<OrgProgramCyclesUpdateProgramCycleResponses, OrgProgramCyclesUpdateProgramCycleErrors, ThrowOnError> => (options.client ?? client).patch<OrgProgramCyclesUpdateProgramCycleResponses, OrgProgramCyclesUpdateProgramCycleErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Activate Cycle
 */
export const orgProgramCyclesActivateActivateCycle = <ThrowOnError extends boolean = false>(options: Options<OrgProgramCyclesActivateActivateCycleData, ThrowOnError>): RequestResult<OrgProgramCyclesActivateActivateCycleResponses, OrgProgramCyclesActivateActivateCycleErrors, ThrowOnError> => (options.client ?? client).post<OrgProgramCyclesActivateActivateCycleResponses, OrgProgramCyclesActivateActivateCycleErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/activate',
    ...options
});

/**
 * List Cycle Criteria
 */
export const orgProgramCyclesCriteriaListCycleCriteria = <ThrowOnError extends boolean = false>(options: Options<OrgProgramCyclesCriteriaListCycleCriteriaData, ThrowOnError>): RequestResult<OrgProgramCyclesCriteriaListCycleCriteriaResponses, OrgProgramCyclesCriteriaListCycleCriteriaErrors, ThrowOnError> => (options.client ?? client).get<OrgProgramCyclesCriteriaListCycleCriteriaResponses, OrgProgramCyclesCriteriaListCycleCriteriaErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/criteria',
    ...options
});

/**
 * Create Cycle Criteria
 */
export const orgProgramCyclesCriteriaCreateCycleCriteria = <ThrowOnError extends boolean = false>(options: Options<OrgProgramCyclesCriteriaCreateCycleCriteriaData, ThrowOnError>): RequestResult<OrgProgramCyclesCriteriaCreateCycleCriteriaResponses, OrgProgramCyclesCriteriaCreateCycleCriteriaErrors, ThrowOnError> => (options.client ?? client).post<OrgProgramCyclesCriteriaCreateCycleCriteriaResponses, OrgProgramCyclesCriteriaCreateCycleCriteriaErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/criteria',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Cycle Criteria
 */
export const orgProgramCyclesCriteriaDeleteCycleCriteria = <ThrowOnError extends boolean = false>(options: Options<OrgProgramCyclesCriteriaDeleteCycleCriteriaData, ThrowOnError>): RequestResult<OrgProgramCyclesCriteriaDeleteCycleCriteriaResponses, OrgProgramCyclesCriteriaDeleteCycleCriteriaErrors, ThrowOnError> => (options.client ?? client).delete<OrgProgramCyclesCriteriaDeleteCycleCriteriaResponses, OrgProgramCyclesCriteriaDeleteCycleCriteriaErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/criteria/{criteria_id}',
    ...options
});

/**
 * Update Cycle Criteria
 */
export const orgProgramCyclesCriteriaUpdateCycleCriteria = <ThrowOnError extends boolean = false>(options: Options<OrgProgramCyclesCriteriaUpdateCycleCriteriaData, ThrowOnError>): RequestResult<OrgProgramCyclesCriteriaUpdateCycleCriteriaResponses, OrgProgramCyclesCriteriaUpdateCycleCriteriaErrors, ThrowOnError> => (options.client ?? client).patch<OrgProgramCyclesCriteriaUpdateCycleCriteriaResponses, OrgProgramCyclesCriteriaUpdateCycleCriteriaErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/criteria/{criteria_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Cycle Requirements
 */
export const orgProgramCyclesRequirementsListCycleRequirements = <ThrowOnError extends boolean = false>(options: Options<OrgProgramCyclesRequirementsListCycleRequirementsData, ThrowOnError>): RequestResult<OrgProgramCyclesRequirementsListCycleRequirementsResponses, OrgProgramCyclesRequirementsListCycleRequirementsErrors, ThrowOnError> => (options.client ?? client).get<OrgProgramCyclesRequirementsListCycleRequirementsResponses, OrgProgramCyclesRequirementsListCycleRequirementsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/requirements',
    ...options
});

/**
 * Create Cycle Requirement
 */
export const orgProgramCyclesRequirementsCreateCycleRequirement = <ThrowOnError extends boolean = false>(options: Options<OrgProgramCyclesRequirementsCreateCycleRequirementData, ThrowOnError>): RequestResult<OrgProgramCyclesRequirementsCreateCycleRequirementResponses, OrgProgramCyclesRequirementsCreateCycleRequirementErrors, ThrowOnError> => (options.client ?? client).post<OrgProgramCyclesRequirementsCreateCycleRequirementResponses, OrgProgramCyclesRequirementsCreateCycleRequirementErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/requirements',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Cycle Requirement
 */
export const orgProgramCyclesRequirementsDeleteCycleRequirement = <ThrowOnError extends boolean = false>(options: Options<OrgProgramCyclesRequirementsDeleteCycleRequirementData, ThrowOnError>): RequestResult<OrgProgramCyclesRequirementsDeleteCycleRequirementResponses, OrgProgramCyclesRequirementsDeleteCycleRequirementErrors, ThrowOnError> => (options.client ?? client).delete<OrgProgramCyclesRequirementsDeleteCycleRequirementResponses, OrgProgramCyclesRequirementsDeleteCycleRequirementErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/requirements/{requirement_id}',
    ...options
});

/**
 * Update Cycle Requirement
 */
export const orgProgramCyclesRequirementsUpdateCycleRequirement = <ThrowOnError extends boolean = false>(options: Options<OrgProgramCyclesRequirementsUpdateCycleRequirementData, ThrowOnError>): RequestResult<OrgProgramCyclesRequirementsUpdateCycleRequirementResponses, OrgProgramCyclesRequirementsUpdateCycleRequirementErrors, ThrowOnError> => (options.client ?? client).patch<OrgProgramCyclesRequirementsUpdateCycleRequirementResponses, OrgProgramCyclesRequirementsUpdateCycleRequirementErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/requirements/{requirement_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Cycle Deadlines
 */
export const orgProgramCyclesDeadlinesListCycleDeadlines = <ThrowOnError extends boolean = false>(options: Options<OrgProgramCyclesDeadlinesListCycleDeadlinesData, ThrowOnError>): RequestResult<OrgProgramCyclesDeadlinesListCycleDeadlinesResponses, OrgProgramCyclesDeadlinesListCycleDeadlinesErrors, ThrowOnError> => (options.client ?? client).get<OrgProgramCyclesDeadlinesListCycleDeadlinesResponses, OrgProgramCyclesDeadlinesListCycleDeadlinesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/deadlines',
    ...options
});

/**
 * Create Cycle Deadline
 */
export const orgProgramCyclesDeadlinesCreateCycleDeadline = <ThrowOnError extends boolean = false>(options: Options<OrgProgramCyclesDeadlinesCreateCycleDeadlineData, ThrowOnError>): RequestResult<OrgProgramCyclesDeadlinesCreateCycleDeadlineResponses, OrgProgramCyclesDeadlinesCreateCycleDeadlineErrors, ThrowOnError> => (options.client ?? client).post<OrgProgramCyclesDeadlinesCreateCycleDeadlineResponses, OrgProgramCyclesDeadlinesCreateCycleDeadlineErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/deadlines',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Cycle Deadline
 */
export const orgProgramCyclesDeadlinesDeleteCycleDeadline = <ThrowOnError extends boolean = false>(options: Options<OrgProgramCyclesDeadlinesDeleteCycleDeadlineData, ThrowOnError>): RequestResult<OrgProgramCyclesDeadlinesDeleteCycleDeadlineResponses, OrgProgramCyclesDeadlinesDeleteCycleDeadlineErrors, ThrowOnError> => (options.client ?? client).delete<OrgProgramCyclesDeadlinesDeleteCycleDeadlineResponses, OrgProgramCyclesDeadlinesDeleteCycleDeadlineErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/deadlines/{deadline_id}',
    ...options
});

/**
 * Update Cycle Deadline
 */
export const orgProgramCyclesDeadlinesUpdateCycleDeadline = <ThrowOnError extends boolean = false>(options: Options<OrgProgramCyclesDeadlinesUpdateCycleDeadlineData, ThrowOnError>): RequestResult<OrgProgramCyclesDeadlinesUpdateCycleDeadlineResponses, OrgProgramCyclesDeadlinesUpdateCycleDeadlineErrors, ThrowOnError> => (options.client ?? client).patch<OrgProgramCyclesDeadlinesUpdateCycleDeadlineResponses, OrgProgramCyclesDeadlinesUpdateCycleDeadlineErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/deadlines/{deadline_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Program Template Criteria
 */
export const orgProgramTemplateCriteriaListProgramTemplateCriteria = <ThrowOnError extends boolean = false>(options: Options<OrgProgramTemplateCriteriaListProgramTemplateCriteriaData, ThrowOnError>): RequestResult<OrgProgramTemplateCriteriaListProgramTemplateCriteriaResponses, OrgProgramTemplateCriteriaListProgramTemplateCriteriaErrors, ThrowOnError> => (options.client ?? client).get<OrgProgramTemplateCriteriaListProgramTemplateCriteriaResponses, OrgProgramTemplateCriteriaListProgramTemplateCriteriaErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/template/criteria',
    ...options
});

/**
 * Create Program Template Criteria
 */
export const orgProgramTemplateCriteriaCreateProgramTemplateCriteria = <ThrowOnError extends boolean = false>(options: Options<OrgProgramTemplateCriteriaCreateProgramTemplateCriteriaData, ThrowOnError>): RequestResult<OrgProgramTemplateCriteriaCreateProgramTemplateCriteriaResponses, OrgProgramTemplateCriteriaCreateProgramTemplateCriteriaErrors, ThrowOnError> => (options.client ?? client).post<OrgProgramTemplateCriteriaCreateProgramTemplateCriteriaResponses, OrgProgramTemplateCriteriaCreateProgramTemplateCriteriaErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/template/criteria',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Program Template Criteria
 */
export const orgProgramTemplateCriteriaDeleteProgramTemplateCriteria = <ThrowOnError extends boolean = false>(options: Options<OrgProgramTemplateCriteriaDeleteProgramTemplateCriteriaData, ThrowOnError>): RequestResult<OrgProgramTemplateCriteriaDeleteProgramTemplateCriteriaResponses, OrgProgramTemplateCriteriaDeleteProgramTemplateCriteriaErrors, ThrowOnError> => (options.client ?? client).delete<OrgProgramTemplateCriteriaDeleteProgramTemplateCriteriaResponses, OrgProgramTemplateCriteriaDeleteProgramTemplateCriteriaErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/template/criteria/{criteria_id}',
    ...options
});

/**
 * Update Program Template Criteria
 */
export const orgProgramTemplateCriteriaUpdateProgramTemplateCriteria = <ThrowOnError extends boolean = false>(options: Options<OrgProgramTemplateCriteriaUpdateProgramTemplateCriteriaData, ThrowOnError>): RequestResult<OrgProgramTemplateCriteriaUpdateProgramTemplateCriteriaResponses, OrgProgramTemplateCriteriaUpdateProgramTemplateCriteriaErrors, ThrowOnError> => (options.client ?? client).patch<OrgProgramTemplateCriteriaUpdateProgramTemplateCriteriaResponses, OrgProgramTemplateCriteriaUpdateProgramTemplateCriteriaErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/template/criteria/{criteria_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Program Template Requirements
 */
export const orgProgramTemplateRequirementsListProgramTemplateRequirements = <ThrowOnError extends boolean = false>(options: Options<OrgProgramTemplateRequirementsListProgramTemplateRequirementsData, ThrowOnError>): RequestResult<OrgProgramTemplateRequirementsListProgramTemplateRequirementsResponses, OrgProgramTemplateRequirementsListProgramTemplateRequirementsErrors, ThrowOnError> => (options.client ?? client).get<OrgProgramTemplateRequirementsListProgramTemplateRequirementsResponses, OrgProgramTemplateRequirementsListProgramTemplateRequirementsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/template/requirements',
    ...options
});

/**
 * Create Program Template Requirement
 */
export const orgProgramTemplateRequirementsCreateProgramTemplateRequirement = <ThrowOnError extends boolean = false>(options: Options<OrgProgramTemplateRequirementsCreateProgramTemplateRequirementData, ThrowOnError>): RequestResult<OrgProgramTemplateRequirementsCreateProgramTemplateRequirementResponses, OrgProgramTemplateRequirementsCreateProgramTemplateRequirementErrors, ThrowOnError> => (options.client ?? client).post<OrgProgramTemplateRequirementsCreateProgramTemplateRequirementResponses, OrgProgramTemplateRequirementsCreateProgramTemplateRequirementErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/template/requirements',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Program Template Requirement
 */
export const orgProgramTemplateRequirementsDeleteProgramTemplateRequirement = <ThrowOnError extends boolean = false>(options: Options<OrgProgramTemplateRequirementsDeleteProgramTemplateRequirementData, ThrowOnError>): RequestResult<OrgProgramTemplateRequirementsDeleteProgramTemplateRequirementResponses, OrgProgramTemplateRequirementsDeleteProgramTemplateRequirementErrors, ThrowOnError> => (options.client ?? client).delete<OrgProgramTemplateRequirementsDeleteProgramTemplateRequirementResponses, OrgProgramTemplateRequirementsDeleteProgramTemplateRequirementErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/template/requirements/{requirement_id}',
    ...options
});

/**
 * Update Program Template Requirement
 */
export const orgProgramTemplateRequirementsUpdateProgramTemplateRequirement = <ThrowOnError extends boolean = false>(options: Options<OrgProgramTemplateRequirementsUpdateProgramTemplateRequirementData, ThrowOnError>): RequestResult<OrgProgramTemplateRequirementsUpdateProgramTemplateRequirementResponses, OrgProgramTemplateRequirementsUpdateProgramTemplateRequirementErrors, ThrowOnError> => (options.client ?? client).patch<OrgProgramTemplateRequirementsUpdateProgramTemplateRequirementResponses, OrgProgramTemplateRequirementsUpdateProgramTemplateRequirementErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/template/requirements/{requirement_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Program Template Deadlines
 */
export const orgProgramTemplateDeadlinesListProgramTemplateDeadlines = <ThrowOnError extends boolean = false>(options: Options<OrgProgramTemplateDeadlinesListProgramTemplateDeadlinesData, ThrowOnError>): RequestResult<OrgProgramTemplateDeadlinesListProgramTemplateDeadlinesResponses, OrgProgramTemplateDeadlinesListProgramTemplateDeadlinesErrors, ThrowOnError> => (options.client ?? client).get<OrgProgramTemplateDeadlinesListProgramTemplateDeadlinesResponses, OrgProgramTemplateDeadlinesListProgramTemplateDeadlinesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/template/deadlines',
    ...options
});

/**
 * Create Program Template Deadline
 */
export const orgProgramTemplateDeadlinesCreateProgramTemplateDeadline = <ThrowOnError extends boolean = false>(options: Options<OrgProgramTemplateDeadlinesCreateProgramTemplateDeadlineData, ThrowOnError>): RequestResult<OrgProgramTemplateDeadlinesCreateProgramTemplateDeadlineResponses, OrgProgramTemplateDeadlinesCreateProgramTemplateDeadlineErrors, ThrowOnError> => (options.client ?? client).post<OrgProgramTemplateDeadlinesCreateProgramTemplateDeadlineResponses, OrgProgramTemplateDeadlinesCreateProgramTemplateDeadlineErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/template/deadlines',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Program Template Deadline
 */
export const orgProgramTemplateDeadlinesDeleteProgramTemplateDeadline = <ThrowOnError extends boolean = false>(options: Options<OrgProgramTemplateDeadlinesDeleteProgramTemplateDeadlineData, ThrowOnError>): RequestResult<OrgProgramTemplateDeadlinesDeleteProgramTemplateDeadlineResponses, OrgProgramTemplateDeadlinesDeleteProgramTemplateDeadlineErrors, ThrowOnError> => (options.client ?? client).delete<OrgProgramTemplateDeadlinesDeleteProgramTemplateDeadlineResponses, OrgProgramTemplateDeadlinesDeleteProgramTemplateDeadlineErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/template/deadlines/{deadline_id}',
    ...options
});

/**
 * Update Program Template Deadline
 */
export const orgProgramTemplateDeadlinesUpdateProgramTemplateDeadline = <ThrowOnError extends boolean = false>(options: Options<OrgProgramTemplateDeadlinesUpdateProgramTemplateDeadlineData, ThrowOnError>): RequestResult<OrgProgramTemplateDeadlinesUpdateProgramTemplateDeadlineResponses, OrgProgramTemplateDeadlinesUpdateProgramTemplateDeadlineErrors, ThrowOnError> => (options.client ?? client).patch<OrgProgramTemplateDeadlinesUpdateProgramTemplateDeadlineResponses, OrgProgramTemplateDeadlinesUpdateProgramTemplateDeadlineErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/template/deadlines/{deadline_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Program Properties
 *
 * List program properties in this program's jurisdiction.
 */
export const orgProgramPropertiesListProgramProperties = <ThrowOnError extends boolean = false>(options: Options<OrgProgramPropertiesListProgramPropertiesData, ThrowOnError>): RequestResult<OrgProgramPropertiesListProgramPropertiesResponses, OrgProgramPropertiesListProgramPropertiesErrors, ThrowOnError> => (options.client ?? client).get<OrgProgramPropertiesListProgramPropertiesResponses, OrgProgramPropertiesListProgramPropertiesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/properties/',
    ...options
});

/**
 * Create Program Property
 *
 * Create a property in the program's jurisdiction.
 */
export const orgProgramPropertiesCreateProgramProperty = <ThrowOnError extends boolean = false>(options: Options<OrgProgramPropertiesCreateProgramPropertyData, ThrowOnError>): RequestResult<OrgProgramPropertiesCreateProgramPropertyResponses, OrgProgramPropertiesCreateProgramPropertyErrors, ThrowOnError> => (options.client ?? client).post<OrgProgramPropertiesCreateProgramPropertyResponses, OrgProgramPropertiesCreateProgramPropertyErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/properties/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Program Property
 */
export const orgProgramPropertiesDeleteProgramProperty = <ThrowOnError extends boolean = false>(options: Options<OrgProgramPropertiesDeleteProgramPropertyData, ThrowOnError>): RequestResult<OrgProgramPropertiesDeleteProgramPropertyResponses, OrgProgramPropertiesDeleteProgramPropertyErrors, ThrowOnError> => (options.client ?? client).delete<OrgProgramPropertiesDeleteProgramPropertyResponses, OrgProgramPropertiesDeleteProgramPropertyErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/properties/{property_id}',
    ...options
});

/**
 * Update Program Property
 */
export const orgProgramPropertiesUpdateProgramProperty = <ThrowOnError extends boolean = false>(options: Options<OrgProgramPropertiesUpdateProgramPropertyData, ThrowOnError>): RequestResult<OrgProgramPropertiesUpdateProgramPropertyResponses, OrgProgramPropertiesUpdateProgramPropertyErrors, ThrowOnError> => (options.client ?? client).patch<OrgProgramPropertiesUpdateProgramPropertyResponses, OrgProgramPropertiesUpdateProgramPropertyErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/properties/{property_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Auto Match Candidates
 *
 * Return Energy-Management properties that are candidates for linking.
 *
 * Includes:
 * - Same-org EM properties (always eligible).
 * - Cross-org EM properties only when an APPROVED DBPropertyShareRequest exists.
 */
export const orgProgramPropertiesAutoMatchCandidatesListAutoMatchCandidates = <ThrowOnError extends boolean = false>(options: Options<OrgProgramPropertiesAutoMatchCandidatesListAutoMatchCandidatesData, ThrowOnError>): RequestResult<OrgProgramPropertiesAutoMatchCandidatesListAutoMatchCandidatesResponses, OrgProgramPropertiesAutoMatchCandidatesListAutoMatchCandidatesErrors, ThrowOnError> => (options.client ?? client).get<OrgProgramPropertiesAutoMatchCandidatesListAutoMatchCandidatesResponses, OrgProgramPropertiesAutoMatchCandidatesListAutoMatchCandidatesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/properties/auto-match-candidates',
    ...options
});

/**
 * Unlink Program Property
 */
export const orgProgramPropertiesLinkUnlinkProgramProperty = <ThrowOnError extends boolean = false>(options: Options<OrgProgramPropertiesLinkUnlinkProgramPropertyData, ThrowOnError>): RequestResult<OrgProgramPropertiesLinkUnlinkProgramPropertyResponses, OrgProgramPropertiesLinkUnlinkProgramPropertyErrors, ThrowOnError> => (options.client ?? client).delete<OrgProgramPropertiesLinkUnlinkProgramPropertyResponses, OrgProgramPropertiesLinkUnlinkProgramPropertyErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/properties/{property_id}/link/{em_property_id}',
    ...options
});

/**
 * Link Program Property
 *
 * Link a program property to an Energy Management property.
 *
 * Cross-org links require an APPROVED DBPropertyShareRequest for the program.
 */
export const orgProgramPropertiesLinkLinkProgramProperty = <ThrowOnError extends boolean = false>(options: Options<OrgProgramPropertiesLinkLinkProgramPropertyData, ThrowOnError>): RequestResult<OrgProgramPropertiesLinkLinkProgramPropertyResponses, OrgProgramPropertiesLinkLinkProgramPropertyErrors, ThrowOnError> => (options.client ?? client).post<OrgProgramPropertiesLinkLinkProgramPropertyResponses, OrgProgramPropertiesLinkLinkProgramPropertyErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/properties/{property_id}/link/{em_property_id}',
    ...options
});

/**
 * List Cycle Enrollments
 */
export const orgProgramCyclesEnrollmentsListCycleEnrollments = <ThrowOnError extends boolean = false>(options: Options<OrgProgramCyclesEnrollmentsListCycleEnrollmentsData, ThrowOnError>): RequestResult<OrgProgramCyclesEnrollmentsListCycleEnrollmentsResponses, OrgProgramCyclesEnrollmentsListCycleEnrollmentsErrors, ThrowOnError> => (options.client ?? client).get<OrgProgramCyclesEnrollmentsListCycleEnrollmentsResponses, OrgProgramCyclesEnrollmentsListCycleEnrollmentsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/enrollments',
    ...options
});

/**
 * Create Cycle Enrollment
 */
export const orgProgramCyclesEnrollmentsCreateCycleEnrollment = <ThrowOnError extends boolean = false>(options: Options<OrgProgramCyclesEnrollmentsCreateCycleEnrollmentData, ThrowOnError>): RequestResult<OrgProgramCyclesEnrollmentsCreateCycleEnrollmentResponses, OrgProgramCyclesEnrollmentsCreateCycleEnrollmentErrors, ThrowOnError> => (options.client ?? client).post<OrgProgramCyclesEnrollmentsCreateCycleEnrollmentResponses, OrgProgramCyclesEnrollmentsCreateCycleEnrollmentErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/enrollments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Cycle Enrollment
 */
export const orgProgramCyclesEnrollmentsUpdateCycleEnrollment = <ThrowOnError extends boolean = false>(options: Options<OrgProgramCyclesEnrollmentsUpdateCycleEnrollmentData, ThrowOnError>): RequestResult<OrgProgramCyclesEnrollmentsUpdateCycleEnrollmentResponses, OrgProgramCyclesEnrollmentsUpdateCycleEnrollmentErrors, ThrowOnError> => (options.client ?? client).patch<OrgProgramCyclesEnrollmentsUpdateCycleEnrollmentResponses, OrgProgramCyclesEnrollmentsUpdateCycleEnrollmentErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/enrollments/{enrollment_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Cycle Compliance
 */
export const orgProgramCyclesComplianceListCycleCompliance = <ThrowOnError extends boolean = false>(options: Options<OrgProgramCyclesComplianceListCycleComplianceData, ThrowOnError>): RequestResult<OrgProgramCyclesComplianceListCycleComplianceResponses, OrgProgramCyclesComplianceListCycleComplianceErrors, ThrowOnError> => (options.client ?? client).get<OrgProgramCyclesComplianceListCycleComplianceResponses, OrgProgramCyclesComplianceListCycleComplianceErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/compliance',
    ...options
});

/**
 * Create Cycle Compliance Record
 */
export const orgProgramCyclesComplianceCreateCycleComplianceRecord = <ThrowOnError extends boolean = false>(options: Options<OrgProgramCyclesComplianceCreateCycleComplianceRecordData, ThrowOnError>): RequestResult<OrgProgramCyclesComplianceCreateCycleComplianceRecordResponses, OrgProgramCyclesComplianceCreateCycleComplianceRecordErrors, ThrowOnError> => (options.client ?? client).post<OrgProgramCyclesComplianceCreateCycleComplianceRecordResponses, OrgProgramCyclesComplianceCreateCycleComplianceRecordErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/compliance',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Cycle Compliance Record
 */
export const orgProgramCyclesComplianceUpdateCycleComplianceRecord = <ThrowOnError extends boolean = false>(options: Options<OrgProgramCyclesComplianceUpdateCycleComplianceRecordData, ThrowOnError>): RequestResult<OrgProgramCyclesComplianceUpdateCycleComplianceRecordResponses, OrgProgramCyclesComplianceUpdateCycleComplianceRecordErrors, ThrowOnError> => (options.client ?? client).patch<OrgProgramCyclesComplianceUpdateCycleComplianceRecordResponses, OrgProgramCyclesComplianceUpdateCycleComplianceRecordErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/compliance/{record_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Cycle Compliance Stats
 */
export const orgProgramCyclesComplianceStatsGetCycleComplianceStats = <ThrowOnError extends boolean = false>(options: Options<OrgProgramCyclesComplianceStatsGetCycleComplianceStatsData, ThrowOnError>): RequestResult<OrgProgramCyclesComplianceStatsGetCycleComplianceStatsResponses, OrgProgramCyclesComplianceStatsGetCycleComplianceStatsErrors, ThrowOnError> => (options.client ?? client).get<OrgProgramCyclesComplianceStatsGetCycleComplianceStatsResponses, OrgProgramCyclesComplianceStatsGetCycleComplianceStatsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/compliance/stats',
    ...options
});

/**
 * Evaluate Cycle Compliance
 *
 * Queue a compliance re-evaluation for every enrollment in this cycle.
 *
 * Dispatches `evaluate_cycle_task` to Celery (after the request commits) so
 * the request returns quickly even for citywide cycles with many enrollments.
 * Clients should refresh the compliance list shortly after.
 */
export const orgProgramCyclesComplianceEvaluateEvaluateCycleCompliance = <ThrowOnError extends boolean = false>(options: Options<OrgProgramCyclesComplianceEvaluateEvaluateCycleComplianceData, ThrowOnError>): RequestResult<OrgProgramCyclesComplianceEvaluateEvaluateCycleComplianceResponses, OrgProgramCyclesComplianceEvaluateEvaluateCycleComplianceErrors, ThrowOnError> => (options.client ?? client).post<OrgProgramCyclesComplianceEvaluateEvaluateCycleComplianceResponses, OrgProgramCyclesComplianceEvaluateEvaluateCycleComplianceErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/compliance/evaluate',
    ...options
});

/**
 * List Cycle Forms
 */
export const orgProgramCyclesFormsListCycleForms = <ThrowOnError extends boolean = false>(options: Options<OrgProgramCyclesFormsListCycleFormsData, ThrowOnError>): RequestResult<OrgProgramCyclesFormsListCycleFormsResponses, OrgProgramCyclesFormsListCycleFormsErrors, ThrowOnError> => (options.client ?? client).get<OrgProgramCyclesFormsListCycleFormsResponses, OrgProgramCyclesFormsListCycleFormsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/forms',
    ...options
});

/**
 * Create Cycle Form
 */
export const orgProgramCyclesFormsCreateCycleForm = <ThrowOnError extends boolean = false>(options: Options<OrgProgramCyclesFormsCreateCycleFormData, ThrowOnError>): RequestResult<OrgProgramCyclesFormsCreateCycleFormResponses, OrgProgramCyclesFormsCreateCycleFormErrors, ThrowOnError> => (options.client ?? client).post<OrgProgramCyclesFormsCreateCycleFormResponses, OrgProgramCyclesFormsCreateCycleFormErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/forms',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Cycle Form
 */
export const orgProgramCyclesFormsDeleteCycleForm = <ThrowOnError extends boolean = false>(options: Options<OrgProgramCyclesFormsDeleteCycleFormData, ThrowOnError>): RequestResult<OrgProgramCyclesFormsDeleteCycleFormResponses, OrgProgramCyclesFormsDeleteCycleFormErrors, ThrowOnError> => (options.client ?? client).delete<OrgProgramCyclesFormsDeleteCycleFormResponses, OrgProgramCyclesFormsDeleteCycleFormErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/forms/{form_id}',
    ...options
});

/**
 * Update Cycle Form
 */
export const orgProgramCyclesFormsUpdateCycleForm = <ThrowOnError extends boolean = false>(options: Options<OrgProgramCyclesFormsUpdateCycleFormData, ThrowOnError>): RequestResult<OrgProgramCyclesFormsUpdateCycleFormResponses, OrgProgramCyclesFormsUpdateCycleFormErrors, ThrowOnError> => (options.client ?? client).patch<OrgProgramCyclesFormsUpdateCycleFormResponses, OrgProgramCyclesFormsUpdateCycleFormErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/forms/{form_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Form Submissions
 */
export const orgProgramCyclesFormsSubmissionsListFormSubmissions = <ThrowOnError extends boolean = false>(options: Options<OrgProgramCyclesFormsSubmissionsListFormSubmissionsData, ThrowOnError>): RequestResult<OrgProgramCyclesFormsSubmissionsListFormSubmissionsResponses, OrgProgramCyclesFormsSubmissionsListFormSubmissionsErrors, ThrowOnError> => (options.client ?? client).get<OrgProgramCyclesFormsSubmissionsListFormSubmissionsResponses, OrgProgramCyclesFormsSubmissionsListFormSubmissionsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/forms/{form_id}/submissions',
    ...options
});

/**
 * Upsert Owner Form Submission
 *
 * Idempotent: create a DRAFT submission for this (form, property, user)
 * if one doesn't exist, else update its responses.
 */
export const orgProgramCyclesFormsSubmissionsUpsertOwnerFormSubmission = <ThrowOnError extends boolean = false>(options: Options<OrgProgramCyclesFormsSubmissionsUpsertOwnerFormSubmissionData, ThrowOnError>): RequestResult<OrgProgramCyclesFormsSubmissionsUpsertOwnerFormSubmissionResponses, OrgProgramCyclesFormsSubmissionsUpsertOwnerFormSubmissionErrors, ThrowOnError> => (options.client ?? client).post<OrgProgramCyclesFormsSubmissionsUpsertOwnerFormSubmissionResponses, OrgProgramCyclesFormsSubmissionsUpsertOwnerFormSubmissionErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/forms/{form_id}/submissions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Review Form Submission
 */
export const orgProgramCyclesFormsSubmissionsReviewFormSubmission = <ThrowOnError extends boolean = false>(options: Options<OrgProgramCyclesFormsSubmissionsReviewFormSubmissionData, ThrowOnError>): RequestResult<OrgProgramCyclesFormsSubmissionsReviewFormSubmissionResponses, OrgProgramCyclesFormsSubmissionsReviewFormSubmissionErrors, ThrowOnError> => (options.client ?? client).patch<OrgProgramCyclesFormsSubmissionsReviewFormSubmissionResponses, OrgProgramCyclesFormsSubmissionsReviewFormSubmissionErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/forms/submissions/{submission_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Cycle Portals
 */
export const orgProgramCyclesPortalsListCyclePortals = <ThrowOnError extends boolean = false>(options: Options<OrgProgramCyclesPortalsListCyclePortalsData, ThrowOnError>): RequestResult<OrgProgramCyclesPortalsListCyclePortalsResponses, OrgProgramCyclesPortalsListCyclePortalsErrors, ThrowOnError> => (options.client ?? client).get<OrgProgramCyclesPortalsListCyclePortalsResponses, OrgProgramCyclesPortalsListCyclePortalsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/portals',
    ...options
});

/**
 * Create Cycle Portal
 */
export const orgProgramCyclesPortalsCreateCyclePortal = <ThrowOnError extends boolean = false>(options: Options<OrgProgramCyclesPortalsCreateCyclePortalData, ThrowOnError>): RequestResult<OrgProgramCyclesPortalsCreateCyclePortalResponses, OrgProgramCyclesPortalsCreateCyclePortalErrors, ThrowOnError> => (options.client ?? client).post<OrgProgramCyclesPortalsCreateCyclePortalResponses, OrgProgramCyclesPortalsCreateCyclePortalErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/portals',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Cycle Portal
 */
export const orgProgramCyclesPortalsDeleteCyclePortal = <ThrowOnError extends boolean = false>(options: Options<OrgProgramCyclesPortalsDeleteCyclePortalData, ThrowOnError>): RequestResult<OrgProgramCyclesPortalsDeleteCyclePortalResponses, OrgProgramCyclesPortalsDeleteCyclePortalErrors, ThrowOnError> => (options.client ?? client).delete<OrgProgramCyclesPortalsDeleteCyclePortalResponses, OrgProgramCyclesPortalsDeleteCyclePortalErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/portals/{portal_id}',
    ...options
});

/**
 * Update Cycle Portal
 */
export const orgProgramCyclesPortalsUpdateCyclePortal = <ThrowOnError extends boolean = false>(options: Options<OrgProgramCyclesPortalsUpdateCyclePortalData, ThrowOnError>): RequestResult<OrgProgramCyclesPortalsUpdateCyclePortalResponses, OrgProgramCyclesPortalsUpdateCyclePortalErrors, ThrowOnError> => (options.client ?? client).patch<OrgProgramCyclesPortalsUpdateCyclePortalResponses, OrgProgramCyclesPortalsUpdateCyclePortalErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/portals/{portal_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Portal Submissions
 */
export const orgProgramCyclesPortalsSubmissionsListPortalSubmissions = <ThrowOnError extends boolean = false>(options: Options<OrgProgramCyclesPortalsSubmissionsListPortalSubmissionsData, ThrowOnError>): RequestResult<OrgProgramCyclesPortalsSubmissionsListPortalSubmissionsResponses, OrgProgramCyclesPortalsSubmissionsListPortalSubmissionsErrors, ThrowOnError> => (options.client ?? client).get<OrgProgramCyclesPortalsSubmissionsListPortalSubmissionsResponses, OrgProgramCyclesPortalsSubmissionsListPortalSubmissionsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/portals/{portal_id}/submissions',
    ...options
});

/**
 * Upload Owner Portal Submission
 *
 * Authenticated property owner uploads a file to satisfy a portal-backed requirement.
 */
export const orgProgramCyclesPortalsSubmissionsUploadOwnerPortalSubmission = <ThrowOnError extends boolean = false>(options: Options<OrgProgramCyclesPortalsSubmissionsUploadOwnerPortalSubmissionData, ThrowOnError>): RequestResult<OrgProgramCyclesPortalsSubmissionsUploadOwnerPortalSubmissionResponses, OrgProgramCyclesPortalsSubmissionsUploadOwnerPortalSubmissionErrors, ThrowOnError> => (options.client ?? client).post<OrgProgramCyclesPortalsSubmissionsUploadOwnerPortalSubmissionResponses, OrgProgramCyclesPortalsSubmissionsUploadOwnerPortalSubmissionErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/portals/{portal_id}/submissions',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Review Portal Submission
 */
export const orgProgramCyclesPortalsSubmissionsReviewPortalSubmission = <ThrowOnError extends boolean = false>(options: Options<OrgProgramCyclesPortalsSubmissionsReviewPortalSubmissionData, ThrowOnError>): RequestResult<OrgProgramCyclesPortalsSubmissionsReviewPortalSubmissionResponses, OrgProgramCyclesPortalsSubmissionsReviewPortalSubmissionErrors, ThrowOnError> => (options.client ?? client).patch<OrgProgramCyclesPortalsSubmissionsReviewPortalSubmissionResponses, OrgProgramCyclesPortalsSubmissionsReviewPortalSubmissionErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/portals/submissions/{submission_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Form Definition
 *
 * Return the form's schema + metadata. Requires the user to belong to an
 * org that has at least one tracking for this program.
 */
export const orgProgramCyclesFormsDefinitionGetFormDefinition = <ThrowOnError extends boolean = false>(options: Options<OrgProgramCyclesFormsDefinitionGetFormDefinitionData, ThrowOnError>): RequestResult<OrgProgramCyclesFormsDefinitionGetFormDefinitionResponses, OrgProgramCyclesFormsDefinitionGetFormDefinitionErrors, ThrowOnError> => (options.client ?? client).get<OrgProgramCyclesFormsDefinitionGetFormDefinitionResponses, OrgProgramCyclesFormsDefinitionGetFormDefinitionErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/forms/{form_id}/definition',
    ...options
});

/**
 * Submit Owner Form Submission
 *
 * Transition a DRAFT submission to SUBMITTED.
 */
export const orgProgramCyclesFormsSubmissionsSubmitSubmitOwnerFormSubmission = <ThrowOnError extends boolean = false>(options: Options<OrgProgramCyclesFormsSubmissionsSubmitSubmitOwnerFormSubmissionData, ThrowOnError>): RequestResult<OrgProgramCyclesFormsSubmissionsSubmitSubmitOwnerFormSubmissionResponses, OrgProgramCyclesFormsSubmissionsSubmitSubmitOwnerFormSubmissionErrors, ThrowOnError> => (options.client ?? client).post<OrgProgramCyclesFormsSubmissionsSubmitSubmitOwnerFormSubmissionResponses, OrgProgramCyclesFormsSubmissionsSubmitSubmitOwnerFormSubmissionErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/forms/{form_id}/submissions/{submission_id}/submit',
    ...options
});

/**
 * Get My Form Submission
 *
 * Return the current user's most-recent submission for this (form, property)
 * if any, regardless of status.
 */
export const orgProgramCyclesFormsMySubmissionGetMyFormSubmission = <ThrowOnError extends boolean = false>(options: Options<OrgProgramCyclesFormsMySubmissionGetMyFormSubmissionData, ThrowOnError>): RequestResult<OrgProgramCyclesFormsMySubmissionGetMyFormSubmissionResponses, OrgProgramCyclesFormsMySubmissionGetMyFormSubmissionErrors, ThrowOnError> => (options.client ?? client).get<OrgProgramCyclesFormsMySubmissionGetMyFormSubmissionResponses, OrgProgramCyclesFormsMySubmissionGetMyFormSubmissionErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/forms/{form_id}/my-submission',
    ...options
});

/**
 * List My Portal Submissions
 *
 * List the user's portal submissions for a (portal, property) pair.
 */
export const orgProgramCyclesPortalsMySubmissionsListMyPortalSubmissions = <ThrowOnError extends boolean = false>(options: Options<OrgProgramCyclesPortalsMySubmissionsListMyPortalSubmissionsData, ThrowOnError>): RequestResult<OrgProgramCyclesPortalsMySubmissionsListMyPortalSubmissionsResponses, OrgProgramCyclesPortalsMySubmissionsListMyPortalSubmissionsErrors, ThrowOnError> => (options.client ?? client).get<OrgProgramCyclesPortalsMySubmissionsListMyPortalSubmissionsResponses, OrgProgramCyclesPortalsMySubmissionsListMyPortalSubmissionsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/portals/{portal_id}/my-submissions',
    ...options
});

/**
 * Get My Portal Submission
 */
export const orgProgramCyclesPortalsSubmissionsGetMyPortalSubmission = <ThrowOnError extends boolean = false>(options: Options<OrgProgramCyclesPortalsSubmissionsGetMyPortalSubmissionData, ThrowOnError>): RequestResult<OrgProgramCyclesPortalsSubmissionsGetMyPortalSubmissionResponses, OrgProgramCyclesPortalsSubmissionsGetMyPortalSubmissionErrors, ThrowOnError> => (options.client ?? client).get<OrgProgramCyclesPortalsSubmissionsGetMyPortalSubmissionResponses, OrgProgramCyclesPortalsSubmissionsGetMyPortalSubmissionErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/portals/{portal_id}/submissions/{submission_id}',
    ...options
});

/**
 * List Communication Templates
 */
export const orgProgramCommunicationsTemplatesListCommunicationTemplates = <ThrowOnError extends boolean = false>(options: Options<OrgProgramCommunicationsTemplatesListCommunicationTemplatesData, ThrowOnError>): RequestResult<OrgProgramCommunicationsTemplatesListCommunicationTemplatesResponses, OrgProgramCommunicationsTemplatesListCommunicationTemplatesErrors, ThrowOnError> => (options.client ?? client).get<OrgProgramCommunicationsTemplatesListCommunicationTemplatesResponses, OrgProgramCommunicationsTemplatesListCommunicationTemplatesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/communications/templates',
    ...options
});

/**
 * Create Communication Template
 */
export const orgProgramCommunicationsTemplatesCreateCommunicationTemplate = <ThrowOnError extends boolean = false>(options: Options<OrgProgramCommunicationsTemplatesCreateCommunicationTemplateData, ThrowOnError>): RequestResult<OrgProgramCommunicationsTemplatesCreateCommunicationTemplateResponses, OrgProgramCommunicationsTemplatesCreateCommunicationTemplateErrors, ThrowOnError> => (options.client ?? client).post<OrgProgramCommunicationsTemplatesCreateCommunicationTemplateResponses, OrgProgramCommunicationsTemplatesCreateCommunicationTemplateErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/communications/templates',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Communication Template
 */
export const orgProgramCommunicationsTemplatesDeleteCommunicationTemplate = <ThrowOnError extends boolean = false>(options: Options<OrgProgramCommunicationsTemplatesDeleteCommunicationTemplateData, ThrowOnError>): RequestResult<OrgProgramCommunicationsTemplatesDeleteCommunicationTemplateResponses, OrgProgramCommunicationsTemplatesDeleteCommunicationTemplateErrors, ThrowOnError> => (options.client ?? client).delete<OrgProgramCommunicationsTemplatesDeleteCommunicationTemplateResponses, OrgProgramCommunicationsTemplatesDeleteCommunicationTemplateErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/communications/templates/{template_id}',
    ...options
});

/**
 * Update Communication Template
 */
export const orgProgramCommunicationsTemplatesUpdateCommunicationTemplate = <ThrowOnError extends boolean = false>(options: Options<OrgProgramCommunicationsTemplatesUpdateCommunicationTemplateData, ThrowOnError>): RequestResult<OrgProgramCommunicationsTemplatesUpdateCommunicationTemplateResponses, OrgProgramCommunicationsTemplatesUpdateCommunicationTemplateErrors, ThrowOnError> => (options.client ?? client).patch<OrgProgramCommunicationsTemplatesUpdateCommunicationTemplateResponses, OrgProgramCommunicationsTemplatesUpdateCommunicationTemplateErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/communications/templates/{template_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Share Request
 *
 * A program org requests share access for a cross-org EM property.
 */
export const orgProgramPropertyShareRequestsCreateShareRequest = <ThrowOnError extends boolean = false>(options: Options<OrgProgramPropertyShareRequestsCreateShareRequestData, ThrowOnError>): RequestResult<OrgProgramPropertyShareRequestsCreateShareRequestResponses, OrgProgramPropertyShareRequestsCreateShareRequestErrors, ThrowOnError> => (options.client ?? client).post<OrgProgramPropertyShareRequestsCreateShareRequestResponses, OrgProgramPropertyShareRequestsCreateShareRequestErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/property-share-requests/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Outgoing Share Requests
 *
 * Requests this org has made. Optionally filtered by `program_id` so a
 * program-scoped UI can show only sharing related to one program.
 */
export const orgProgramPropertyShareRequestsOutgoingListOutgoingShareRequests = <ThrowOnError extends boolean = false>(options: Options<OrgProgramPropertyShareRequestsOutgoingListOutgoingShareRequestsData, ThrowOnError>): RequestResult<OrgProgramPropertyShareRequestsOutgoingListOutgoingShareRequestsResponses, OrgProgramPropertyShareRequestsOutgoingListOutgoingShareRequestsErrors, ThrowOnError> => (options.client ?? client).get<OrgProgramPropertyShareRequestsOutgoingListOutgoingShareRequestsResponses, OrgProgramPropertyShareRequestsOutgoingListOutgoingShareRequestsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/property-share-requests/outgoing',
    ...options
});

/**
 * List Incoming Share Requests
 *
 * Requests asking for access to this org's properties. Optionally filtered
 * by `program_id` to show only sharing related to a specific program.
 */
export const orgProgramPropertyShareRequestsIncomingListIncomingShareRequests = <ThrowOnError extends boolean = false>(options: Options<OrgProgramPropertyShareRequestsIncomingListIncomingShareRequestsData, ThrowOnError>): RequestResult<OrgProgramPropertyShareRequestsIncomingListIncomingShareRequestsResponses, OrgProgramPropertyShareRequestsIncomingListIncomingShareRequestsErrors, ThrowOnError> => (options.client ?? client).get<OrgProgramPropertyShareRequestsIncomingListIncomingShareRequestsResponses, OrgProgramPropertyShareRequestsIncomingListIncomingShareRequestsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/property-share-requests/incoming',
    ...options
});

/**
 * Approve Share Request
 */
export const orgProgramPropertyShareRequestsApproveApproveShareRequest = <ThrowOnError extends boolean = false>(options: Options<OrgProgramPropertyShareRequestsApproveApproveShareRequestData, ThrowOnError>): RequestResult<OrgProgramPropertyShareRequestsApproveApproveShareRequestResponses, OrgProgramPropertyShareRequestsApproveApproveShareRequestErrors, ThrowOnError> => (options.client ?? client).post<OrgProgramPropertyShareRequestsApproveApproveShareRequestResponses, OrgProgramPropertyShareRequestsApproveApproveShareRequestErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/property-share-requests/{request_id}/approve',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Deny Share Request
 */
export const orgProgramPropertyShareRequestsDenyDenyShareRequest = <ThrowOnError extends boolean = false>(options: Options<OrgProgramPropertyShareRequestsDenyDenyShareRequestData, ThrowOnError>): RequestResult<OrgProgramPropertyShareRequestsDenyDenyShareRequestResponses, OrgProgramPropertyShareRequestsDenyDenyShareRequestErrors, ThrowOnError> => (options.client ?? client).post<OrgProgramPropertyShareRequestsDenyDenyShareRequestResponses, OrgProgramPropertyShareRequestsDenyDenyShareRequestErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/property-share-requests/{request_id}/deny',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revoke Share Request
 *
 * Target org revokes a previously-approved share.
 */
export const orgProgramPropertyShareRequestsRevokeRevokeShareRequest = <ThrowOnError extends boolean = false>(options: Options<OrgProgramPropertyShareRequestsRevokeRevokeShareRequestData, ThrowOnError>): RequestResult<OrgProgramPropertyShareRequestsRevokeRevokeShareRequestResponses, OrgProgramPropertyShareRequestsRevokeRevokeShareRequestErrors, ThrowOnError> => (options.client ?? client).post<OrgProgramPropertyShareRequestsRevokeRevokeShareRequestResponses, OrgProgramPropertyShareRequestsRevokeRevokeShareRequestErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/property-share-requests/{request_id}/revoke',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Citywide Report
 *
 * Aggregate compliance numbers for a cycle, with breakdowns by property type and GFA bucket.
 */
export const orgProgramCyclesReportsCitywideCitywideReport = <ThrowOnError extends boolean = false>(options: Options<OrgProgramCyclesReportsCitywideCitywideReportData, ThrowOnError>): RequestResult<OrgProgramCyclesReportsCitywideCitywideReportResponses, OrgProgramCyclesReportsCitywideCitywideReportErrors, ThrowOnError> => (options.client ?? client).get<OrgProgramCyclesReportsCitywideCitywideReportResponses, OrgProgramCyclesReportsCitywideCitywideReportErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/reports/citywide',
    ...options
});

/**
 * Program Dashboard
 *
 * Live metrics for a cycle detail dashboard.
 */
export const orgProgramCyclesReportsDashboardProgramDashboard = <ThrowOnError extends boolean = false>(options: Options<OrgProgramCyclesReportsDashboardProgramDashboardData, ThrowOnError>): RequestResult<OrgProgramCyclesReportsDashboardProgramDashboardResponses, OrgProgramCyclesReportsDashboardProgramDashboardErrors, ThrowOnError> => (options.client ?? client).get<OrgProgramCyclesReportsDashboardProgramDashboardResponses, OrgProgramCyclesReportsDashboardProgramDashboardErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/reports/dashboard',
    ...options
});

/**
 * Disclosure Export
 *
 * Public-disclosure CSV export. Each row is one enrolled property's
 * compliance status for the cycle.
 */
export const orgProgramCyclesReportsDisclosureCsvDisclosureExport = <ThrowOnError extends boolean = false>(options: Options<OrgProgramCyclesReportsDisclosureCsvDisclosureExportData, ThrowOnError>): RequestResult<OrgProgramCyclesReportsDisclosureCsvDisclosureExportResponses, OrgProgramCyclesReportsDisclosureCsvDisclosureExportErrors, ThrowOnError> => (options.client ?? client).get<OrgProgramCyclesReportsDisclosureCsvDisclosureExportResponses, OrgProgramCyclesReportsDisclosureCsvDisclosureExportErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/cycles/{cycle_id}/reports/disclosure.csv',
    ...options
});

/**
 * List Program Tracks
 */
export const orgProgramTracksListProgramTracks = <ThrowOnError extends boolean = false>(options: Options<OrgProgramTracksListProgramTracksData, ThrowOnError>): RequestResult<OrgProgramTracksListProgramTracksResponses, OrgProgramTracksListProgramTracksErrors, ThrowOnError> => (options.client ?? client).get<OrgProgramTracksListProgramTracksResponses, OrgProgramTracksListProgramTracksErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/tracks',
    ...options
});

/**
 * List Program Sources
 */
export const orgProgramSourcesListProgramSources = <ThrowOnError extends boolean = false>(options: Options<OrgProgramSourcesListProgramSourcesData, ThrowOnError>): RequestResult<OrgProgramSourcesListProgramSourcesResponses, OrgProgramSourcesListProgramSourcesErrors, ThrowOnError> => (options.client ?? client).get<OrgProgramSourcesListProgramSourcesResponses, OrgProgramSourcesListProgramSourcesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/sources',
    ...options
});

/**
 * Get Program Reference
 */
export const orgProgramReferenceGetProgramReference = <ThrowOnError extends boolean = false>(options: Options<OrgProgramReferenceGetProgramReferenceData, ThrowOnError>): RequestResult<OrgProgramReferenceGetProgramReferenceResponses, OrgProgramReferenceGetProgramReferenceErrors, ThrowOnError> => (options.client ?? client).get<OrgProgramReferenceGetProgramReferenceResponses, OrgProgramReferenceGetProgramReferenceErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/reference',
    ...options
});

/**
 * List Program Definition History
 *
 * Every version of the program's definition records (optionally one kind or one record).
 */
export const orgProgramDefinitionHistoryListProgramDefinitionHistory = <ThrowOnError extends boolean = false>(options: Options<OrgProgramDefinitionHistoryListProgramDefinitionHistoryData, ThrowOnError>): RequestResult<OrgProgramDefinitionHistoryListProgramDefinitionHistoryResponses, OrgProgramDefinitionHistoryListProgramDefinitionHistoryErrors, ThrowOnError> => (options.client ?? client).get<OrgProgramDefinitionHistoryListProgramDefinitionHistoryResponses, OrgProgramDefinitionHistoryListProgramDefinitionHistoryErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/definition-history',
    ...options
});

/**
 * List Program Import Runs
 */
export const orgProgramImportRunsListProgramImportRuns = <ThrowOnError extends boolean = false>(options: Options<OrgProgramImportRunsListProgramImportRunsData, ThrowOnError>): RequestResult<OrgProgramImportRunsListProgramImportRunsResponses, OrgProgramImportRunsListProgramImportRunsErrors, ThrowOnError> => (options.client ?? client).get<OrgProgramImportRunsListProgramImportRunsResponses, OrgProgramImportRunsListProgramImportRunsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program/{program_id}/import-runs',
    ...options
});

/**
 * List Catalog Programs
 *
 * The programs the caller's org can read: those it administers, and those matched to (or tracked for)
 * its properties.
 */
export const orgProgramCatalogListCatalogPrograms = <ThrowOnError extends boolean = false>(options: Options<OrgProgramCatalogListCatalogProgramsData, ThrowOnError>): RequestResult<OrgProgramCatalogListCatalogProgramsResponses, OrgProgramCatalogListCatalogProgramsErrors, ThrowOnError> => (options.client ?? client).get<OrgProgramCatalogListCatalogProgramsResponses, OrgProgramCatalogListCatalogProgramsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program-catalog',
    ...options
});

/**
 * Get Catalog Program
 *
 * A readable program with its tracks, cycles and their rows, sources and reference tables.
 */
export const orgProgramCatalogGetCatalogProgram = <ThrowOnError extends boolean = false>(options: Options<OrgProgramCatalogGetCatalogProgramData, ThrowOnError>): RequestResult<OrgProgramCatalogGetCatalogProgramResponses, OrgProgramCatalogGetCatalogProgramErrors, ThrowOnError> => (options.client ?? client).get<OrgProgramCatalogGetCatalogProgramResponses, OrgProgramCatalogGetCatalogProgramErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program-catalog/{program_id}',
    ...options
});

/**
 * List Program Matches
 *
 * The org's program matches, open ones by default.
 */
export const orgProgramMatchListProgramMatches = <ThrowOnError extends boolean = false>(options: Options<OrgProgramMatchListProgramMatchesData, ThrowOnError>): RequestResult<OrgProgramMatchListProgramMatchesResponses, OrgProgramMatchListProgramMatchesErrors, ThrowOnError> => (options.client ?? client).get<OrgProgramMatchListProgramMatchesResponses, OrgProgramMatchListProgramMatchesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program-match',
    ...options
});

/**
 * Get Program Match
 */
export const orgProgramMatchGetProgramMatch = <ThrowOnError extends boolean = false>(options: Options<OrgProgramMatchGetProgramMatchData, ThrowOnError>): RequestResult<OrgProgramMatchGetProgramMatchResponses, OrgProgramMatchGetProgramMatchErrors, ThrowOnError> => (options.client ?? client).get<OrgProgramMatchGetProgramMatchResponses, OrgProgramMatchGetProgramMatchErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program-match/{match_id}',
    ...options
});

/**
 * Confirm Program Match
 *
 * Confirm the match: agree to its disclosure (shared with the program's org, when another org
 * administers it) and start tracking the program for the property. A declined match can be confirmed
 * later.
 */
export const orgProgramMatchConfirmConfirmProgramMatch = <ThrowOnError extends boolean = false>(options: Options<OrgProgramMatchConfirmConfirmProgramMatchData, ThrowOnError>): RequestResult<OrgProgramMatchConfirmConfirmProgramMatchResponses, OrgProgramMatchConfirmConfirmProgramMatchErrors, ThrowOnError> => (options.client ?? client).post<OrgProgramMatchConfirmConfirmProgramMatchResponses, OrgProgramMatchConfirmConfirmProgramMatchErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program-match/{match_id}/confirm',
    ...options
});

/**
 * Decline Program Match
 *
 * Decline an open match: the program is not proposed for the property again. Nothing is shared.
 */
export const orgProgramMatchDeclineDeclineProgramMatch = <ThrowOnError extends boolean = false>(options: Options<OrgProgramMatchDeclineDeclineProgramMatchData, ThrowOnError>): RequestResult<OrgProgramMatchDeclineDeclineProgramMatchResponses, OrgProgramMatchDeclineDeclineProgramMatchErrors, ThrowOnError> => (options.client ?? client).post<OrgProgramMatchDeclineDeclineProgramMatchResponses, OrgProgramMatchDeclineDeclineProgramMatchErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/program-match/{match_id}/decline',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Preferences
 */
export const orgPreferencesGetPreferences = <ThrowOnError extends boolean = false>(options: Options<OrgPreferencesGetPreferencesData, ThrowOnError>): RequestResult<OrgPreferencesGetPreferencesResponses, OrgPreferencesGetPreferencesErrors, ThrowOnError> => (options.client ?? client).get<OrgPreferencesGetPreferencesResponses, OrgPreferencesGetPreferencesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/preferences/',
    ...options
});

/**
 * Set Preferences
 */
export const orgPreferencesSetPreferences = <ThrowOnError extends boolean = false>(options: Options<OrgPreferencesSetPreferencesData, ThrowOnError>): RequestResult<OrgPreferencesSetPreferencesResponses, OrgPreferencesSetPreferencesErrors, ThrowOnError> => (options.client ?? client).post<OrgPreferencesSetPreferencesResponses, OrgPreferencesSetPreferencesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/preferences/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List
 */
export const orgPropertyList = <ThrowOnError extends boolean = false>(options: Options<OrgPropertyListData, ThrowOnError>): RequestResult<OrgPropertyListResponses, OrgPropertyListErrors, ThrowOnError> => (options.client ?? client).get<OrgPropertyListResponses, OrgPropertyListErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/property/',
    ...options
});

/**
 * Create
 */
export const orgPropertyCreate = <ThrowOnError extends boolean = false>(options: Options<OrgPropertyCreateData, ThrowOnError>): RequestResult<OrgPropertyCreateResponses, OrgPropertyCreateErrors, ThrowOnError> => (options.client ?? client).post<OrgPropertyCreateResponses, OrgPropertyCreateErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/property/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update
 */
export const orgPropertyUpdate = <ThrowOnError extends boolean = false>(options: Options<OrgPropertyUpdateData, ThrowOnError>): RequestResult<OrgPropertyUpdateResponses, OrgPropertyUpdateErrors, ThrowOnError> => (options.client ?? client).post<OrgPropertyUpdateResponses, OrgPropertyUpdateErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/property/{property_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Service History
 */
export const orgPropertyServiceHistoryGetServiceHistory = <ThrowOnError extends boolean = false>(options: Options<OrgPropertyServiceHistoryGetServiceHistoryData, ThrowOnError>): RequestResult<OrgPropertyServiceHistoryGetServiceHistoryResponses, OrgPropertyServiceHistoryGetServiceHistoryErrors, ThrowOnError> => (options.client ?? client).get<OrgPropertyServiceHistoryGetServiceHistoryResponses, OrgPropertyServiceHistoryGetServiceHistoryErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/property/{property_id}/service_history',
    ...options
});

/**
 * Get Property Program Facts
 */
export const orgPropertyProgramFactsGetPropertyProgramFacts = <ThrowOnError extends boolean = false>(options: Options<OrgPropertyProgramFactsGetPropertyProgramFactsData, ThrowOnError>): RequestResult<OrgPropertyProgramFactsGetPropertyProgramFactsResponses, OrgPropertyProgramFactsGetPropertyProgramFactsErrors, ThrowOnError> => (options.client ?? client).get<OrgPropertyProgramFactsGetPropertyProgramFactsResponses, OrgPropertyProgramFactsGetPropertyProgramFactsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/property/{property_id}/program-facts',
    ...options
});

/**
 * Set Property Program Facts
 *
 * Replace the owner-supplied criteria facts (e.g. {"site.is_tax_class_one": true}). A null value
 * removes a fact.
 */
export const orgPropertyProgramFactsSetPropertyProgramFacts = <ThrowOnError extends boolean = false>(options: Options<OrgPropertyProgramFactsSetPropertyProgramFactsData, ThrowOnError>): RequestResult<OrgPropertyProgramFactsSetPropertyProgramFactsResponses, OrgPropertyProgramFactsSetPropertyProgramFactsErrors, ThrowOnError> => (options.client ?? client).put<OrgPropertyProgramFactsSetPropertyProgramFactsResponses, OrgPropertyProgramFactsSetPropertyProgramFactsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/property/{property_id}/program-facts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Property Uses
 */
export const orgPropertyUsesListPropertyUses = <ThrowOnError extends boolean = false>(options: Options<OrgPropertyUsesListPropertyUsesData, ThrowOnError>): RequestResult<OrgPropertyUsesListPropertyUsesResponses, OrgPropertyUsesListPropertyUsesErrors, ThrowOnError> => (options.client ?? client).get<OrgPropertyUsesListPropertyUsesResponses, OrgPropertyUsesListPropertyUsesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/property/{property_id}/uses',
    ...options
});

/**
 * Replace Property Uses
 *
 * Replace the property's current uses: current rows are ended the day before `effective_on` and the
 * given uses start on it. Ended uses stay as history.
 */
export const orgPropertyUsesReplacePropertyUses = <ThrowOnError extends boolean = false>(options: Options<OrgPropertyUsesReplacePropertyUsesData, ThrowOnError>): RequestResult<OrgPropertyUsesReplacePropertyUsesResponses, OrgPropertyUsesReplacePropertyUsesErrors, ThrowOnError> => (options.client ?? client).put<OrgPropertyUsesReplacePropertyUsesResponses, OrgPropertyUsesReplacePropertyUsesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/property/{property_id}/uses',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Property Metrics
 */
export const orgPropertyMetricsListPropertyMetrics = <ThrowOnError extends boolean = false>(options: Options<OrgPropertyMetricsListPropertyMetricsData, ThrowOnError>): RequestResult<OrgPropertyMetricsListPropertyMetricsResponses, OrgPropertyMetricsListPropertyMetricsErrors, ThrowOnError> => (options.client ?? client).get<OrgPropertyMetricsListPropertyMetricsResponses, OrgPropertyMetricsListPropertyMetricsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/property/{property_id}/metrics',
    ...options
});

/**
 * Set Property Metric
 *
 * Create or update one annual metric value (by metric, year and source).
 */
export const orgPropertyMetricsSetPropertyMetric = <ThrowOnError extends boolean = false>(options: Options<OrgPropertyMetricsSetPropertyMetricData, ThrowOnError>): RequestResult<OrgPropertyMetricsSetPropertyMetricResponses, OrgPropertyMetricsSetPropertyMetricErrors, ThrowOnError> => (options.client ?? client).put<OrgPropertyMetricsSetPropertyMetricResponses, OrgPropertyMetricsSetPropertyMetricErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/property/{property_id}/metrics',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Import Property Metrics
 *
 * Import annual metrics for the org's properties from CSV (property_identifier,metric_key,year,value,unit).
 * With dry_run (the default) nothing is written and every row's outcome is returned.
 */
export const orgPropertyMetricsImportImportPropertyMetrics = <ThrowOnError extends boolean = false>(options: Options<OrgPropertyMetricsImportImportPropertyMetricsData, ThrowOnError>): RequestResult<OrgPropertyMetricsImportImportPropertyMetricsResponses, OrgPropertyMetricsImportImportPropertyMetricsErrors, ThrowOnError> => (options.client ?? client).post<OrgPropertyMetricsImportImportPropertyMetricsResponses, OrgPropertyMetricsImportImportPropertyMetricsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/property/metrics/import',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Property Tenant Spaces
 *
 * Current tenant spaces with their coverage under the program's tenant-space rule, and the exposure for
 * missing sub-meters.
 */
export const orgPropertyTenantSpacesListPropertyTenantSpaces = <ThrowOnError extends boolean = false>(options: Options<OrgPropertyTenantSpacesListPropertyTenantSpacesData, ThrowOnError>): RequestResult<OrgPropertyTenantSpacesListPropertyTenantSpacesResponses, OrgPropertyTenantSpacesListPropertyTenantSpacesErrors, ThrowOnError> => (options.client ?? client).get<OrgPropertyTenantSpacesListPropertyTenantSpacesResponses, OrgPropertyTenantSpacesListPropertyTenantSpacesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/property/{property_id}/tenant-spaces',
    ...options
});

/**
 * Create Property Tenant Space
 */
export const orgPropertyTenantSpacesCreatePropertyTenantSpace = <ThrowOnError extends boolean = false>(options: Options<OrgPropertyTenantSpacesCreatePropertyTenantSpaceData, ThrowOnError>): RequestResult<OrgPropertyTenantSpacesCreatePropertyTenantSpaceResponses, OrgPropertyTenantSpacesCreatePropertyTenantSpaceErrors, ThrowOnError> => (options.client ?? client).post<OrgPropertyTenantSpacesCreatePropertyTenantSpaceResponses, OrgPropertyTenantSpacesCreatePropertyTenantSpaceErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/property/{property_id}/tenant-spaces',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Property Tenant Space
 *
 * Update a tenant space; set effective_to to end it (spaces are kept as history).
 */
export const orgPropertyTenantSpacesUpdatePropertyTenantSpace = <ThrowOnError extends boolean = false>(options: Options<OrgPropertyTenantSpacesUpdatePropertyTenantSpaceData, ThrowOnError>): RequestResult<OrgPropertyTenantSpacesUpdatePropertyTenantSpaceResponses, OrgPropertyTenantSpacesUpdatePropertyTenantSpaceErrors, ThrowOnError> => (options.client ?? client).patch<OrgPropertyTenantSpacesUpdatePropertyTenantSpaceResponses, OrgPropertyTenantSpacesUpdatePropertyTenantSpaceErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/property/{property_id}/tenant-spaces/{space_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Export Property Tenant Spaces
 *
 * The list of tenant spaces with their coverage (for the LL88 sub-metering report).
 */
export const orgPropertyTenantSpacesExportCsvExportPropertyTenantSpaces = <ThrowOnError extends boolean = false>(options: Options<OrgPropertyTenantSpacesExportCsvExportPropertyTenantSpacesData, ThrowOnError>): RequestResult<OrgPropertyTenantSpacesExportCsvExportPropertyTenantSpacesResponses, OrgPropertyTenantSpacesExportCsvExportPropertyTenantSpacesErrors, ThrowOnError> => (options.client ?? client).get<OrgPropertyTenantSpacesExportCsvExportPropertyTenantSpacesResponses, OrgPropertyTenantSpacesExportCsvExportPropertyTenantSpacesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/property/{property_id}/tenant-spaces/export.csv',
    ...options
});

/**
 * Import Property Tenant Spaces
 *
 * Diff a tenant-space CSV (the export format) against the property's spaces by name; with apply, write
 * the creates, updates and ends (nothing is written when any row has an error).
 */
export const orgPropertyTenantSpacesImportImportPropertyTenantSpaces = <ThrowOnError extends boolean = false>(options: Options<OrgPropertyTenantSpacesImportImportPropertyTenantSpacesData, ThrowOnError>): RequestResult<OrgPropertyTenantSpacesImportImportPropertyTenantSpacesResponses, OrgPropertyTenantSpacesImportImportPropertyTenantSpacesErrors, ThrowOnError> => (options.client ?? client).post<OrgPropertyTenantSpacesImportImportPropertyTenantSpacesResponses, OrgPropertyTenantSpacesImportImportPropertyTenantSpacesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/property/{property_id}/tenant-spaces/import',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Property Attestations
 */
export const orgPropertyAttestationsListPropertyAttestations = <ThrowOnError extends boolean = false>(options: Options<OrgPropertyAttestationsListPropertyAttestationsData, ThrowOnError>): RequestResult<OrgPropertyAttestationsListPropertyAttestationsResponses, OrgPropertyAttestationsListPropertyAttestationsErrors, ThrowOnError> => (options.client ?? client).get<OrgPropertyAttestationsListPropertyAttestationsResponses, OrgPropertyAttestationsListPropertyAttestationsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/property/{property_id}/attestations',
    ...options
});

/**
 * Create Property Attestation
 */
export const orgPropertyAttestationsCreatePropertyAttestation = <ThrowOnError extends boolean = false>(options: Options<OrgPropertyAttestationsCreatePropertyAttestationData, ThrowOnError>): RequestResult<OrgPropertyAttestationsCreatePropertyAttestationResponses, OrgPropertyAttestationsCreatePropertyAttestationErrors, ThrowOnError> => (options.client ?? client).post<OrgPropertyAttestationsCreatePropertyAttestationResponses, OrgPropertyAttestationsCreatePropertyAttestationErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/property/{property_id}/attestations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Property Attestation
 */
export const orgPropertyAttestationsUpdatePropertyAttestation = <ThrowOnError extends boolean = false>(options: Options<OrgPropertyAttestationsUpdatePropertyAttestationData, ThrowOnError>): RequestResult<OrgPropertyAttestationsUpdatePropertyAttestationResponses, OrgPropertyAttestationsUpdatePropertyAttestationErrors, ThrowOnError> => (options.client ?? client).patch<OrgPropertyAttestationsUpdatePropertyAttestationResponses, OrgPropertyAttestationsUpdatePropertyAttestationErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/property/{property_id}/attestations/{attestation_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Property Readiness
 *
 * Whether the property has a full calendar year of energy and water data, per commodity.
 */
export const orgPropertyReadinessGetPropertyReadiness = <ThrowOnError extends boolean = false>(options: Options<OrgPropertyReadinessGetPropertyReadinessData, ThrowOnError>): RequestResult<OrgPropertyReadinessGetPropertyReadinessResponses, OrgPropertyReadinessGetPropertyReadinessErrors, ThrowOnError> => (options.client ?? client).get<OrgPropertyReadinessGetPropertyReadinessResponses, OrgPropertyReadinessGetPropertyReadinessErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/property/{property_id}/readiness',
    ...options
});

/**
 * Get Data
 *
 * Retrieve data for the given query spec.
 *
 * Can be used to run an ad-hoc query. Used by the view/dashboard builder for previews.
 */
export const orgQueryDataGetData = <ThrowOnError extends boolean = false>(options: Options<OrgQueryDataGetDataData, ThrowOnError>): RequestResult<OrgQueryDataGetDataResponses, OrgQueryDataGetDataErrors, ThrowOnError> => (options.client ?? client).post<OrgQueryDataGetDataResponses, OrgQueryDataGetDataErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/query/data',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Execute Query Batch
 *
 * Run many queries in one HTTP call. Used by dashboard pages.
 */
export const orgQueryBatchExecuteQueryBatch = <ThrowOnError extends boolean = false>(options: Options<OrgQueryBatchExecuteQueryBatchData, ThrowOnError>): RequestResult<OrgQueryBatchExecuteQueryBatchResponses, OrgQueryBatchExecuteQueryBatchErrors, ThrowOnError> => (options.client ?? client).post<OrgQueryBatchExecuteQueryBatchResponses, OrgQueryBatchExecuteQueryBatchErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/query/batch',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Export Job
 *
 * Enqueue an async export job. Returns immediately with a job id.
 */
export const orgQueryExportCreateExportJob = <ThrowOnError extends boolean = false>(options: Options<OrgQueryExportCreateExportJobData, ThrowOnError>): RequestResult<OrgQueryExportCreateExportJobResponses, OrgQueryExportCreateExportJobErrors, ThrowOnError> => (options.client ?? client).post<OrgQueryExportCreateExportJobResponses, OrgQueryExportCreateExportJobErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/query/export',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Export Job
 */
export const orgQueryExportGetExportJob = <ThrowOnError extends boolean = false>(options: Options<OrgQueryExportGetExportJobData, ThrowOnError>): RequestResult<OrgQueryExportGetExportJobResponses, OrgQueryExportGetExportJobErrors, ThrowOnError> => (options.client ?? client).get<OrgQueryExportGetExportJobResponses, OrgQueryExportGetExportJobErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/query/export/{job_id}',
    ...options
});

/**
 * Get Metric Catalog
 */
export const orgQueryCatalogMetricsGetMetricCatalog = <ThrowOnError extends boolean = false>(options: Options<OrgQueryCatalogMetricsGetMetricCatalogData, ThrowOnError>): RequestResult<OrgQueryCatalogMetricsGetMetricCatalogResponses, OrgQueryCatalogMetricsGetMetricCatalogErrors, ThrowOnError> => (options.client ?? client).get<OrgQueryCatalogMetricsGetMetricCatalogResponses, OrgQueryCatalogMetricsGetMetricCatalogErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/query/catalog/metrics',
    ...options
});

/**
 * Get Dimension Catalog
 */
export const orgQueryCatalogDimensionsGetDimensionCatalog = <ThrowOnError extends boolean = false>(options: Options<OrgQueryCatalogDimensionsGetDimensionCatalogData, ThrowOnError>): RequestResult<OrgQueryCatalogDimensionsGetDimensionCatalogResponses, OrgQueryCatalogDimensionsGetDimensionCatalogErrors, ThrowOnError> => (options.client ?? client).get<OrgQueryCatalogDimensionsGetDimensionCatalogResponses, OrgQueryCatalogDimensionsGetDimensionCatalogErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/query/catalog/dimensions',
    ...options
});

/**
 * List Saved Filters
 */
export const orgSavedFilterListSavedFilters = <ThrowOnError extends boolean = false>(options: Options<OrgSavedFilterListSavedFiltersData, ThrowOnError>): RequestResult<OrgSavedFilterListSavedFiltersResponses, OrgSavedFilterListSavedFiltersErrors, ThrowOnError> => (options.client ?? client).get<OrgSavedFilterListSavedFiltersResponses, OrgSavedFilterListSavedFiltersErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/saved-filter/',
    ...options
});

/**
 * Create
 */
export const orgSavedFilterCreate = <ThrowOnError extends boolean = false>(options: Options<OrgSavedFilterCreateData, ThrowOnError>): RequestResult<OrgSavedFilterCreateResponses, OrgSavedFilterCreateErrors, ThrowOnError> => (options.client ?? client).put<OrgSavedFilterCreateResponses, OrgSavedFilterCreateErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/saved-filter/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete
 */
export const orgSavedFilterDelete = <ThrowOnError extends boolean = false>(options: Options<OrgSavedFilterDeleteData, ThrowOnError>): RequestResult<OrgSavedFilterDeleteResponses, OrgSavedFilterDeleteErrors, ThrowOnError> => (options.client ?? client).delete<OrgSavedFilterDeleteResponses, OrgSavedFilterDeleteErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/saved-filter/{saved_filter_id}',
    ...options
});

/**
 * Update
 */
export const orgSavedFilterUpdate = <ThrowOnError extends boolean = false>(options: Options<OrgSavedFilterUpdateData, ThrowOnError>): RequestResult<OrgSavedFilterUpdateResponses, OrgSavedFilterUpdateErrors, ThrowOnError> => (options.client ?? client).patch<OrgSavedFilterUpdateResponses, OrgSavedFilterUpdateErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/saved-filter/{saved_filter_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Views
 */
export const orgViewListViews = <ThrowOnError extends boolean = false>(options: Options<OrgViewListViewsData, ThrowOnError>): RequestResult<OrgViewListViewsResponses, OrgViewListViewsErrors, ThrowOnError> => (options.client ?? client).get<OrgViewListViewsResponses, OrgViewListViewsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/view/',
    ...options
});

/**
 * Create View
 */
export const orgViewCreateView = <ThrowOnError extends boolean = false>(options: Options<OrgViewCreateViewData, ThrowOnError>): RequestResult<OrgViewCreateViewResponses, OrgViewCreateViewErrors, ThrowOnError> => (options.client ?? client).put<OrgViewCreateViewResponses, OrgViewCreateViewErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/view/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Templates
 *
 * Available view templates a user can instantiate into a personal view.
 *
 * No permission check: any authenticated user can see what's in the
 * template library. Permission gates on actually creating from one are
 * handled by `create_from_template`.
 */
export const orgViewTemplateListTemplates = <ThrowOnError extends boolean = false>(options: Options<OrgViewTemplateListTemplatesData, ThrowOnError>): RequestResult<OrgViewTemplateListTemplatesResponses, OrgViewTemplateListTemplatesErrors, ThrowOnError> => (options.client ?? client).get<OrgViewTemplateListTemplatesResponses, OrgViewTemplateListTemplatesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/view/template',
    ...options
});

/**
 * Create From Template
 */
export const orgViewFromTemplateCreateFromTemplate = <ThrowOnError extends boolean = false>(options: Options<OrgViewFromTemplateCreateFromTemplateData, ThrowOnError>): RequestResult<OrgViewFromTemplateCreateFromTemplateResponses, OrgViewFromTemplateCreateFromTemplateErrors, ThrowOnError> => (options.client ?? client).post<OrgViewFromTemplateCreateFromTemplateResponses, OrgViewFromTemplateCreateFromTemplateErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/view/from-template',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Dashboard Template Library
 *
 * Available dashboard templates a user can instantiate.
 *
 * Instantiating creates one personal DBView per data-bearing block + one
 * DBDashboard. Lives on the view router because instantiation is owned by
 * the view service.
 */
export const orgViewDashboardTemplateListDashboardTemplateLibrary = <ThrowOnError extends boolean = false>(options: Options<OrgViewDashboardTemplateListDashboardTemplateLibraryData, ThrowOnError>): RequestResult<OrgViewDashboardTemplateListDashboardTemplateLibraryResponses, OrgViewDashboardTemplateListDashboardTemplateLibraryErrors, ThrowOnError> => (options.client ?? client).get<OrgViewDashboardTemplateListDashboardTemplateLibraryResponses, OrgViewDashboardTemplateListDashboardTemplateLibraryErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/view/dashboard-template',
    ...options
});

/**
 * Create Dashboard From Template
 */
export const orgViewDashboardTemplateInstantiateCreateDashboardFromTemplate = <ThrowOnError extends boolean = false>(options: Options<OrgViewDashboardTemplateInstantiateCreateDashboardFromTemplateData, ThrowOnError>): RequestResult<OrgViewDashboardTemplateInstantiateCreateDashboardFromTemplateResponses, OrgViewDashboardTemplateInstantiateCreateDashboardFromTemplateErrors, ThrowOnError> => (options.client ?? client).post<OrgViewDashboardTemplateInstantiateCreateDashboardFromTemplateResponses, OrgViewDashboardTemplateInstantiateCreateDashboardFromTemplateErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/view/dashboard-template/instantiate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete View
 */
export const orgViewDeleteView = <ThrowOnError extends boolean = false>(options: Options<OrgViewDeleteViewData, ThrowOnError>): RequestResult<OrgViewDeleteViewResponses, OrgViewDeleteViewErrors, ThrowOnError> => (options.client ?? client).delete<OrgViewDeleteViewResponses, OrgViewDeleteViewErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/view/{view_id}',
    ...options
});

/**
 * Get View
 */
export const orgViewGetView = <ThrowOnError extends boolean = false>(options: Options<OrgViewGetViewData, ThrowOnError>): RequestResult<OrgViewGetViewResponses, OrgViewGetViewErrors, ThrowOnError> => (options.client ?? client).get<OrgViewGetViewResponses, OrgViewGetViewErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/view/{view_id}',
    ...options
});

/**
 * Update View
 */
export const orgViewUpdateView = <ThrowOnError extends boolean = false>(options: Options<OrgViewUpdateViewData, ThrowOnError>): RequestResult<OrgViewUpdateViewResponses, OrgViewUpdateViewErrors, ThrowOnError> => (options.client ?? client).patch<OrgViewUpdateViewResponses, OrgViewUpdateViewErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/view/{view_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Duplicate View
 *
 * Create a new personal view that's an independent copy of an existing one.
 *
 * The duplicate is owned by the caller (`is_shared=False`), starts editable
 * and deletable, and is named `Copy of <original>` unless renamed later.
 */
export const orgViewDuplicateDuplicateView = <ThrowOnError extends boolean = false>(options: Options<OrgViewDuplicateDuplicateViewData, ThrowOnError>): RequestResult<OrgViewDuplicateDuplicateViewResponses, OrgViewDuplicateDuplicateViewErrors, ThrowOnError> => (options.client ?? client).post<OrgViewDuplicateDuplicateViewResponses, OrgViewDuplicateDuplicateViewErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/view/{view_id}/duplicate',
    ...options
});

/**
 * Get Data
 *
 * Execute the view's persisted spec, optionally with a dynamic overlay.
 *
 * The body is optional; a request with no body runs the saved spec
 * unchanged (and hits the engine's result cache).
 */
export const orgViewDataGetData = <ThrowOnError extends boolean = false>(options: Options<OrgViewDataGetDataData, ThrowOnError>): RequestResult<OrgViewDataGetDataResponses, OrgViewDataGetDataErrors, ThrowOnError> => (options.client ?? client).post<OrgViewDataGetDataResponses, OrgViewDataGetDataErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/view/{view_id}/data',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Targets
 */
export const orgTargetListTargets = <ThrowOnError extends boolean = false>(options: Options<OrgTargetListTargetsData, ThrowOnError>): RequestResult<OrgTargetListTargetsResponses, OrgTargetListTargetsErrors, ThrowOnError> => (options.client ?? client).get<OrgTargetListTargetsResponses, OrgTargetListTargetsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/target/',
    ...options
});

/**
 * Create
 */
export const orgTargetCreate = <ThrowOnError extends boolean = false>(options: Options<OrgTargetCreateData, ThrowOnError>): RequestResult<OrgTargetCreateResponses, OrgTargetCreateErrors, ThrowOnError> => (options.client ?? client).put<OrgTargetCreateResponses, OrgTargetCreateErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/target/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Progress
 */
export const orgTargetProgressListProgress = <ThrowOnError extends boolean = false>(options: Options<OrgTargetProgressListProgressData, ThrowOnError>): RequestResult<OrgTargetProgressListProgressResponses, OrgTargetProgressListProgressErrors, ThrowOnError> => (options.client ?? client).get<OrgTargetProgressListProgressResponses, OrgTargetProgressListProgressErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/target/progress',
    ...options
});

/**
 * Get Series
 */
export const orgTargetSeriesGetSeries = <ThrowOnError extends boolean = false>(options: Options<OrgTargetSeriesGetSeriesData, ThrowOnError>): RequestResult<OrgTargetSeriesGetSeriesResponses, OrgTargetSeriesGetSeriesErrors, ThrowOnError> => (options.client ?? client).get<OrgTargetSeriesGetSeriesResponses, OrgTargetSeriesGetSeriesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/target/{target_id}/series',
    ...options
});

/**
 * Delete
 */
export const orgTargetDelete = <ThrowOnError extends boolean = false>(options: Options<OrgTargetDeleteData, ThrowOnError>): RequestResult<OrgTargetDeleteResponses, OrgTargetDeleteErrors, ThrowOnError> => (options.client ?? client).delete<OrgTargetDeleteResponses, OrgTargetDeleteErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/target/{target_id}',
    ...options
});

/**
 * Update
 */
export const orgTargetUpdate = <ThrowOnError extends boolean = false>(options: Options<OrgTargetUpdateData, ThrowOnError>): RequestResult<OrgTargetUpdateResponses, OrgTargetUpdateErrors, ThrowOnError> => (options.client ?? client).patch<OrgTargetUpdateResponses, OrgTargetUpdateErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/target/{target_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Search
 *
 * Search across all entity types within the organization.
 *
 * Returns results grouped by category (Properties, Vendors, Meters, etc.)
 */
export const orgSearchSearch = <ThrowOnError extends boolean = false>(options: Options<OrgSearchSearchData, ThrowOnError>): RequestResult<OrgSearchSearchResponses, OrgSearchSearchErrors, ThrowOnError> => (options.client ?? client).get<OrgSearchSearchResponses, OrgSearchSearchErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/search/',
    ...options
});

/**
 * Service Account List
 */
export const orgServiceAccountServiceAccountList = <ThrowOnError extends boolean = false>(options: Options<OrgServiceAccountServiceAccountListData, ThrowOnError>): RequestResult<OrgServiceAccountServiceAccountListResponses, OrgServiceAccountServiceAccountListErrors, ThrowOnError> => (options.client ?? client).get<OrgServiceAccountServiceAccountListResponses, OrgServiceAccountServiceAccountListErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/service_account/',
    ...options
});

/**
 * Get Balance
 *
 * Outstanding balance for a single service account.
 */
export const orgServiceAccountBalanceGetBalance = <ThrowOnError extends boolean = false>(options: Options<OrgServiceAccountBalanceGetBalanceData, ThrowOnError>): RequestResult<OrgServiceAccountBalanceGetBalanceResponses, OrgServiceAccountBalanceGetBalanceErrors, ThrowOnError> => (options.client ?? client).get<OrgServiceAccountBalanceGetBalanceResponses, OrgServiceAccountBalanceGetBalanceErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/service_account/{service_account_id}/balance',
    ...options
});

/**
 * List
 *
 * List all statements for the current org
 */
export const orgStatementList = <ThrowOnError extends boolean = false>(options: Options<OrgStatementListData, ThrowOnError>): RequestResult<OrgStatementListResponses, OrgStatementListErrors, ThrowOnError> => (options.client ?? client).get<OrgStatementListResponses, OrgStatementListErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/statement/',
    ...options
});

/**
 * Delete
 *
 * Delete a statement, optionally cascading the delete to attached payments.
 */
export const orgStatementDelete = <ThrowOnError extends boolean = false>(options: Options<OrgStatementDeleteData, ThrowOnError>): RequestResult<OrgStatementDeleteResponses, OrgStatementDeleteErrors, ThrowOnError> => (options.client ?? client).delete<OrgStatementDeleteResponses, OrgStatementDeleteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/statement/{statement_id}',
    ...options
});

/**
 * Get
 *
 * Get details of the given statement
 */
export const orgStatementGet = <ThrowOnError extends boolean = false>(options: Options<OrgStatementGetData, ThrowOnError>): RequestResult<OrgStatementGetResponses, OrgStatementGetErrors, ThrowOnError> => (options.client ?? client).get<OrgStatementGetResponses, OrgStatementGetErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/statement/{statement_id}',
    ...options
});

/**
 * Update
 *
 * Update a statement's identifiers
 */
export const orgStatementUpdate = <ThrowOnError extends boolean = false>(options: Options<OrgStatementUpdateData, ThrowOnError>): RequestResult<OrgStatementUpdateResponses, OrgStatementUpdateErrors, ThrowOnError> => (options.client ?? client).patch<OrgStatementUpdateResponses, OrgStatementUpdateErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/statement/{statement_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Support Requests
 *
 * List support requests for the current user.
 */
export const orgSupportListSupportRequests = <ThrowOnError extends boolean = false>(options: Options<OrgSupportListSupportRequestsData, ThrowOnError>): RequestResult<OrgSupportListSupportRequestsResponses, OrgSupportListSupportRequestsErrors, ThrowOnError> => (options.client ?? client).get<OrgSupportListSupportRequestsResponses, OrgSupportListSupportRequestsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/support/',
    ...options
});

/**
 * Create Support Request
 *
 * Create a new support request.
 */
export const orgSupportCreateSupportRequest = <ThrowOnError extends boolean = false>(options: Options<OrgSupportCreateSupportRequestData, ThrowOnError>): RequestResult<OrgSupportCreateSupportRequestResponses, OrgSupportCreateSupportRequestErrors, ThrowOnError> => (options.client ?? client).post<OrgSupportCreateSupportRequestResponses, OrgSupportCreateSupportRequestErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/support/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Support Request
 *
 * Get a single support request by ID.
 */
export const orgSupportGetSupportRequest = <ThrowOnError extends boolean = false>(options: Options<OrgSupportGetSupportRequestData, ThrowOnError>): RequestResult<OrgSupportGetSupportRequestResponses, OrgSupportGetSupportRequestErrors, ThrowOnError> => (options.client ?? client).get<OrgSupportGetSupportRequestResponses, OrgSupportGetSupportRequestErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/support/{request_id}',
    ...options
});

/**
 * Update Support Request
 *
 * Update a support request.
 */
export const orgSupportUpdateSupportRequest = <ThrowOnError extends boolean = false>(options: Options<OrgSupportUpdateSupportRequestData, ThrowOnError>): RequestResult<OrgSupportUpdateSupportRequestResponses, OrgSupportUpdateSupportRequestErrors, ThrowOnError> => (options.client ?? client).patch<OrgSupportUpdateSupportRequestResponses, OrgSupportUpdateSupportRequestErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/support/{request_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Message
 *
 * Add a message to a support request.
 */
export const orgSupportMessageCreateMessage = <ThrowOnError extends boolean = false>(options: Options<OrgSupportMessageCreateMessageData, ThrowOnError>): RequestResult<OrgSupportMessageCreateMessageResponses, OrgSupportMessageCreateMessageErrors, ThrowOnError> => (options.client ?? client).put<OrgSupportMessageCreateMessageResponses, OrgSupportMessageCreateMessageErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/org/{org_id}/support/{request_id}/message',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Published Dashboard
 */
export const publicDashboardGetPublishedDashboard = <ThrowOnError extends boolean = false>(options: Options<PublicDashboardGetPublishedDashboardData, ThrowOnError>): RequestResult<PublicDashboardGetPublishedDashboardResponses, PublicDashboardGetPublishedDashboardErrors, ThrowOnError> => (options.client ?? client).get<PublicDashboardGetPublishedDashboardResponses, PublicDashboardGetPublishedDashboardErrors, ThrowOnError>({
    responseType: 'json',
    url: '/public/dashboard/{dashboard_id}',
    ...options
});

/**
 * Get Published Dashboard Data
 */
export const publicDashboardDataGetPublishedDashboardData = <ThrowOnError extends boolean = false>(options: Options<PublicDashboardDataGetPublishedDashboardDataData, ThrowOnError>): RequestResult<PublicDashboardDataGetPublishedDashboardDataResponses, PublicDashboardDataGetPublishedDashboardDataErrors, ThrowOnError> => (options.client ?? client).post<PublicDashboardDataGetPublishedDashboardDataResponses, PublicDashboardDataGetPublishedDashboardDataErrors, ThrowOnError>({
    responseType: 'json',
    url: '/public/dashboard/{dashboard_id}/data',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Published Dashboard Targets
 *
 * Progress summaries for the org's targets, for the all-targets overview
 * block. Gated: the dashboard must be published and actually contain a
 * `target_overview` block (so a published dashboard opts into exposing its
 * org's goals).
 */
export const publicDashboardTargetsGetPublishedDashboardTargets = <ThrowOnError extends boolean = false>(options: Options<PublicDashboardTargetsGetPublishedDashboardTargetsData, ThrowOnError>): RequestResult<PublicDashboardTargetsGetPublishedDashboardTargetsResponses, PublicDashboardTargetsGetPublishedDashboardTargetsErrors, ThrowOnError> => (options.client ?? client).get<PublicDashboardTargetsGetPublishedDashboardTargetsResponses, PublicDashboardTargetsGetPublishedDashboardTargetsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/public/dashboard/{dashboard_id}/targets',
    ...options
});

/**
 * Get Public Form
 *
 * Get a public form's information.
 *
 * Only returns information if the form is publicly accessible or has public access type.
 */
export const publicProgramFormGetPublicForm = <ThrowOnError extends boolean = false>(options: Options<PublicProgramFormGetPublicFormData, ThrowOnError>): RequestResult<PublicProgramFormGetPublicFormResponses, PublicProgramFormGetPublicFormErrors, ThrowOnError> => (options.client ?? client).get<PublicProgramFormGetPublicFormResponses, PublicProgramFormGetPublicFormErrors, ThrowOnError>({
    responseType: 'json',
    url: '/public/program/form/{form_id}',
    ...options
});

/**
 * Validate Form Access
 *
 * Validate access to a form using token or code.
 *
 * Returns submission ID if access is valid.
 */
export const publicProgramFormValidateAccessValidateFormAccess = <ThrowOnError extends boolean = false>(options: Options<PublicProgramFormValidateAccessValidateFormAccessData, ThrowOnError>): RequestResult<PublicProgramFormValidateAccessValidateFormAccessResponses, PublicProgramFormValidateAccessValidateFormAccessErrors, ThrowOnError> => (options.client ?? client).post<PublicProgramFormValidateAccessValidateFormAccessResponses, PublicProgramFormValidateAccessValidateFormAccessErrors, ThrowOnError>({
    responseType: 'json',
    url: '/public/program/form/{form_id}/validate-access',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Form Submission By Credentials
 *
 * Get a form submission using access credentials.
 */
export const publicProgramFormSubmissionGetFormSubmissionByCredentials = <ThrowOnError extends boolean = false>(options: Options<PublicProgramFormSubmissionGetFormSubmissionByCredentialsData, ThrowOnError>): RequestResult<PublicProgramFormSubmissionGetFormSubmissionByCredentialsResponses, PublicProgramFormSubmissionGetFormSubmissionByCredentialsErrors, ThrowOnError> => (options.client ?? client).get<PublicProgramFormSubmissionGetFormSubmissionByCredentialsResponses, PublicProgramFormSubmissionGetFormSubmissionByCredentialsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/public/program/form/{form_id}/submission',
    ...options
});

/**
 * Create Or Update Submission
 *
 * Create or update a form submission.
 *
 * For magic link forms: requires valid token
 * For access code forms: requires valid code
 * For public forms: creates new submission
 */
export const publicProgramFormSubmissionCreateOrUpdateSubmission = <ThrowOnError extends boolean = false>(options: Options<PublicProgramFormSubmissionCreateOrUpdateSubmissionData, ThrowOnError>): RequestResult<PublicProgramFormSubmissionCreateOrUpdateSubmissionResponses, PublicProgramFormSubmissionCreateOrUpdateSubmissionErrors, ThrowOnError> => (options.client ?? client).post<PublicProgramFormSubmissionCreateOrUpdateSubmissionResponses, PublicProgramFormSubmissionCreateOrUpdateSubmissionErrors, ThrowOnError>({
    responseType: 'json',
    url: '/public/program/form/{form_id}/submission',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Public Portal
 *
 * Get a public portal's information.
 */
export const publicProgramPortalGetPublicPortal = <ThrowOnError extends boolean = false>(options: Options<PublicProgramPortalGetPublicPortalData, ThrowOnError>): RequestResult<PublicProgramPortalGetPublicPortalResponses, PublicProgramPortalGetPublicPortalErrors, ThrowOnError> => (options.client ?? client).get<PublicProgramPortalGetPublicPortalResponses, PublicProgramPortalGetPublicPortalErrors, ThrowOnError>({
    responseType: 'json',
    url: '/public/program/portal/{portal_id}',
    ...options
});

/**
 * Validate Portal Access
 *
 * Validate access to a portal using token or code.
 */
export const publicProgramPortalValidateAccessValidatePortalAccess = <ThrowOnError extends boolean = false>(options: Options<PublicProgramPortalValidateAccessValidatePortalAccessData, ThrowOnError>): RequestResult<PublicProgramPortalValidateAccessValidatePortalAccessResponses, PublicProgramPortalValidateAccessValidatePortalAccessErrors, ThrowOnError> => (options.client ?? client).post<PublicProgramPortalValidateAccessValidatePortalAccessResponses, PublicProgramPortalValidateAccessValidatePortalAccessErrors, ThrowOnError>({
    responseType: 'json',
    url: '/public/program/portal/{portal_id}/validate-access',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Series
 */
export const publicTargetSeriesGetSeries = <ThrowOnError extends boolean = false>(options: Options<PublicTargetSeriesGetSeriesData, ThrowOnError>): RequestResult<PublicTargetSeriesGetSeriesResponses, PublicTargetSeriesGetSeriesErrors, ThrowOnError> => (options.client ?? client).get<PublicTargetSeriesGetSeriesResponses, PublicTargetSeriesGetSeriesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/public/target/{target_id}/series',
    ...options
});

/**
 * Get View
 */
export const publicViewGetView = <ThrowOnError extends boolean = false>(options: Options<PublicViewGetViewData, ThrowOnError>): RequestResult<PublicViewGetViewResponses, PublicViewGetViewErrors, ThrowOnError> => (options.client ?? client).get<PublicViewGetViewResponses, PublicViewGetViewErrors, ThrowOnError>({
    responseType: 'json',
    url: '/public/view/{view_id}',
    ...options
});

/**
 * Get Data
 *
 * Execute a published view's spec, optionally with overlay + weather.
 */
export const publicViewDataGetData = <ThrowOnError extends boolean = false>(options: Options<PublicViewDataGetDataData, ThrowOnError>): RequestResult<PublicViewDataGetDataResponses, PublicViewDataGetDataErrors, ThrowOnError> => (options.client ?? client).post<PublicViewDataGetDataResponses, PublicViewDataGetDataErrors, ThrowOnError>({
    responseType: 'json',
    url: '/public/view/{view_id}/data',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
